[
  {
    "key": "txt_ONESHOT_QUESTION",
    "text": "Do this for the current culture, then distribute another 100 points for your preferred culture.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بذلك للثقافة الحالية، ثم وزّع 100 نقطة أخرى للثقافة المفضلة."
      }
    ]
  },
  {
    "key": "txtQuestion",
    "text": "Section",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      },
      {
        "language": "FR",
        "text": "Section"
      },
      {
        "language": "EN",
        "text": "Section"
      }
    ]
  },
  {
    "key": "txt_min_to",
    "text": "10 ~ 15 min",
    "translations": [
      {
        "language": "AR",
        "text": "من 10 إلى 15 دقائق"
      },
      {
        "language": "FR",
        "text": "10 ~ 15 min"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Responden_295",
    "text": "Respondent updated successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث المستجيبين بنجاح"
      }
    ]
  },
  {
    "key": "txt_select_respondents",
    "text": "Select Respondents to send reminders",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المستجيبين لإرسال التذكيرات"
      }
    ]
  },
  {
    "key": "JOD",
    "text": "Joining date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      }
    ]
  },
  {
    "key": "DOB",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      }
    ]
  },
  {
    "key": "txt_Workplace_591",
    "text": "Culture Assessment By",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txt_export_tb",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Customize_416",
    "text": "Customize the invitation email template or use the default template generated by Zenithr.<br> Hint: Do not erase the assessment link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. <br> ملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على <b>\"النموذج الأساسي\"</b>."
      }
    ]
  },
  {
    "key": "txt_Youcanexp_908",
    "text": "You can export the comparison charts as per the current view. </br> Note: Available in PDF format",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل الرسوم البيانية للمقارنة وفقًا للعرض الحالي.</br> ملحوظة: متوفر في صيغة PDF. "
      }
    ]
  },
  {
    "key": "txt_Selectthe_788",
    "text": "Select the companies (if any) you want to compare. </br>Hint: if you have multiple assessments, you have the option to view average scores or select assessments for a tailored analysis! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الشركات (إن وُجد) التي ترغب في مقارنتها. </br>تلميح: إذا كانت لديك تقييمات متعددة، يُتاح لك خيار عرض متوسط الدرجات أو تحديد التقييمات التي ترغب في مقارنتها للحصول على تحليل مخصص. "
      }
    ]
  },
  {
    "key": "txt_Companies_799",
    "text": "Companies ",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات "
      }
    ]
  },
  {
    "key": "txt_Selectthe_681",
    "text": "Select the start and end dates to view the analysis for a specific timeframe. ",
    "translations": [
      {
        "language": "AR",
        "text": "لعرض نتائج رفاهية الموظف لفترة زمنية معينة، قم باختيار تواريخ البداية والنهاية. "
      }
    ]
  },
  {
    "key": "txtComparison_wellbeing",
    "text": "Ready to uncover your assessment history's top culture scores and compare them across years and companies (if any)? Discover the answer now! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج رفاهية الموظف ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن! "
      }
    ]
  },
  {
    "key": "txt_Compariso_275",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة "
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالضغط هنا."
      }
    ]
  },
  {
    "key": "txt_Clickhere_159",
    "text": "Click here to download all comments.</br>Note: Available in Excel format ",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات. </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txtComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      }
    ]
  },
  {
    "key": "txt_Expandthe_792",
    "text": "Expand the dimension to view each statement score and the distribution of respondents’ answers. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على البُعد لعرض متوسط كل عبارة وتوزيع إجابات المستجيبين. "
      }
    ]
  },
  {
    "key": "txt_Statement_817",
    "text": "Statements Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات "
      }
    ]
  },
  {
    "key": "txt_questions_desc",
    "text": "In \"Statements\", each dimension's score with its corresponding statement is shown. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل بُعد مع العبارات الخاصة به."
      }
    ]
  },
  {
    "key": "txt_ChartType_839",
    "text": "Chart Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني "
      }
    ]
  },
  {
    "key": "txtResponses_desc",
    "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the assessment setup step. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليل المستجيبون\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المخُتارة في خطوة إعداد التقييم."
      }
    ]
  },
  {
    "key": "txt_Elevateyo_771",
    "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "ارفع مستوى التحليلات بنقرة واحدة - قم بتحميل مخطط تمثيل البيانات بالألوان الخاصة بك!<br><br>ملحوظة: متوفرة في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_ExpandDim_862",
    "text": "Expand Dimensions ",
    "translations": [
      {
        "language": "AR",
        "text": "عرض العوامل"
      }
    ]
  },
  {
    "key": "txt_Clickonea_896",
    "text": "Click on each Dimension to expand the results of their statements. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على كل بُعد لعرض نتائج العبارات الخاصة بهم. "
      }
    ]
  },
  {
    "key": "txt_Discovert_892",
    "text": "Discover the assessment's highlights and insights in a summarized analysis! Compare the %difference between the overall score and dimensions & statements to demographics and custom criteria by selecting from the breakout dropdown. ",
    "translations": [
      {
        "language": "AR",
        "text": "   اكتشف أبرز نقاط التحليلات المُفصّلة في تحليل مُلخص! قارن الفرق في النسب بين درجة رفاهية الموظف الكلية والأبعاد والعبارات بالنسبة إلى الجوانب الديموغرافية والمعايير المخصصة وذلك من خلال من خلال الاختيار من القائمة المنسدلة. "
      }
    ]
  },
  {
    "key": "txt_Unlockthe_743",
    "text": "Compare culture scores by employee criteria, using the dropdowns to switch the criteria.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات الثقافة حسب معايير الموظفين، باستخدام القوائم المنسدلة لتغيير المعايير."
      }
    ]
  },
  {
    "key": "txt_Workplace_851",
    "text": "Culture Assessment ",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة مكان العمل "
      }
    ]
  },
  {
    "key": "txt_Clickhere_702",
    "text": "Click <b>Download</b> to download the Culture Assessment report and share the results with the relevant stakeholders.<br><br>Hint: Easily access detailed criteria reports by choosing your preferred criteria in the 'filters' menu and start downloading now! - Available in PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>تحميل</b> لتنزيل تقرير تقييم الثقافة ومشاركة النتائج مع أصحاب المصلحة المعنيين.<br><br>تلميح: قم بالوصول بسهولة إلى تقارير المعايير التحليلية المفصلة عن طريق اختيار نوع المعيار في قائمة \"التصفية\" وابدأ بالتحميل الآن! - متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "txt_Clickhere_662",
    "text": "Click here to filter the analysis by choosing the entity.</br> Note: The number of respondents must be at least 3 to view the analysis of each entity. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. </br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل وحدة تنظيمية مختارة. "
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>Overview</b> page gives you a complete summary of the Culture Assessment results, including culture alignment, current and preferred culture, culture gaps, and the level of change employees are requesting.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض صفحة <b>\"نظرة عامة\"</b> ملخصًا متكاملًا لنتائج تقييم الثقافة، بما يشمل مستوى المواءمة الثقافية، والثقافة الحالية والمرغوبة، والفجوات الثقافية، ومستوى التغيير الذي يطلبه الموظفون."
      }
    ]
  },
  {
    "key": "txt_step_4",
    "text": "One more step, and you’re ready to go! ",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد التقييم! "
      }
    ]
  },
  {
    "key": "txt_ClickOn_528",
    "text": "Click on <b>“Close Now”</b> to close the assessment.  </br>Note: You cannot add or delete respondents once you close the assessment. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>“أغلق الآن”</b> لإغلاق التقييم. </br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txt_CloseSurv_416",
    "text": "Close Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق التقييم "
      }
    ]
  },
  {
    "key": "txt_Unlocksea_518",
    "text": "Unlock seamless employee engagement – Reach respondents, even without email, with our general assessment link. Click here and start sharing! ",
    "translations": [
      {
        "language": "AR",
        "text": "   جميع المستجيبون يستطيعون المشاركة – يمكنك الوصول إلى المستجيبين حتى بدون بريد إلكتروني باستخدام رابط التقييم. انقر هنا وابدأ بالمشاركة! "
      }
    ]
  },
  {
    "key": "txt_Diditgobe_889",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكير التلقائي. "
      }
    ]
  },
  {
    "key": "txt_UpdateDat_941",
    "text": "Update Dates ",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ "
      }
    ]
  },
  {
    "key": "txt_Youcandow_532",
    "text": "You can download the list of respondents with their assessment status! </br> Note: Available in Excel format. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة التقييم الخاص بهم! </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txt_ExportRes_128",
    "text": "Export Respondents ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون "
      }
    ]
  },
  {
    "key": "txt_Forgottoa_219",
    "text": "Forgot to add a respondent? No worries, click here and start adding. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة. "
      }
    ]
  },
  {
    "key": "txt_Sendmanua_129",
    "text": "Send manual reminders or delete the respondent. ",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب. "
      }
    ]
  },
  {
    "key": "txt_MoreActio_120",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_Clickhere_145",
    "text": "Click here to send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للمستجيبين الذين لم يستكملوا التقييم. "
      }
    ]
  },
  {
    "key": "txt_Trackyour_168",
    "text": "Track your respondents' progress! You can click here to view the response rate in detail.<br><br>Note: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين! يمكنك النقر هنا لعرض معدل الاستجابة بالتفصيل.<br><br>ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_314",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the assessment invitations and go live!  ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>“دعوة لاستكمال التقييم”</b>، انقر هنا لإرسال دعوات التقييم وإطلاق التقييم مباشرةً!"
      }
    ]
  },
  {
    "key": "txt_Invitatio_215",
    "text": "Invitation Template ",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة "
      }
    ]
  },
  {
    "key": "txt_Customize_781",
    "text": "Customize the invitation email template or use the default template generated by Zenithr. </br>Hint: Do not erase the assessment link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. </br>ملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على \"النموذج الأساسي\". "
      }
    ]
  },
  {
    "key": "txt_invitation_email_desc",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"دعوة لاستكمال التقييم\"</b> تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المستجيبون\"</b> من خلال البريد الإلكتروني."
      }
    ]
  },
  {
    "key": "txt_Customize_297",
    "text": "Customize the reminder email template or use the default template generated by Zenithr.</br>Hint: Do not erase the assessment link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل التذكير أو استخدم النموذج الأساسي المُعرف من زينثر .</br> ملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على \"<b>النموذج الأساسي</b>\"."
      }
    ]
  },
  {
    "key": "txt_Addupto3a_148",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the assessment. ",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا التقييم. "
      }
    ]
  },
  {
    "key": "txt_Automated_437",
    "text": "Automated Reminders ",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية "
      }
    ]
  },
  {
    "key": "txt_Setthecom_342",
    "text": "Set the completion date of your assessment!<br><br> Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال التقييم! <br><br>تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      }
    ]
  },
  {
    "key": "txt_SurveyDea_220",
    "text": "Assessment Deadline ",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال التقييم "
      }
    ]
  },
  {
    "key": "txt_timeframe_desc",
    "text": "In <b>“Timeframe”</b>, you set the assessment deadline in addition to automated reminders. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>“المدة الزمنية”</b>، يمكنك تحديد الإطار الزمني للتقييم بالإضافة إلى تذكيرات تلقائية لاستكمال التقييم."
      }
    ]
  },
  {
    "key": "txt_Tostartad_220",
    "text": "To start adding respondents, click on <b>“Add Respondent”</b>.</br> Hint: We recommend adding by using Excel to save time and simplify your experience! ",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>“إضافة مستجيب”</b>. <br/> تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      }
    ]
  },
  {
    "key": "txt_respondents_desc",
    "text": "In the <b>“Respondents”</b> page, you add the Respondents you want to invite to the assessment manually, or by Excel file, or from your respondent pool. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المستجيبون\"</b>، يمكنك إضافة المستجيبين الذين ترغب في دعوتهم للتقييم يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء التقييم."
      }
    ]
  },
  {
    "key": "txt_Responden_431",
    "text": "Respondent Information ",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب "
      }
    ]
  },
  {
    "key": "txt_CustomCri_149",
    "text": "Custom Criteria ",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      }
    ]
  },
  {
    "key": "txt_Youcancre_632",
    "text": "You can create additional criteria. </br>Fill in the criterion name and its options. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية. </br>قم بتعبئة اسم المعيار وخياراته."
      }
    ]
  },
  {
    "key": "txt_analytical_criteria_desc",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br>Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive, detailed analysis and comparison!",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة.<br><br>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!"
      }
    ]
  },
  {
    "key": "txt_Nextstep_435",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_step_1",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_step_2",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_step_3",
    "text": "You are ready to go to the next step! ",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_Clickonb_749",
    "text": "Click on <b>“Preview Assessment”</b> to view your assessment's selected culture dimensions!<br><br>Note: Available in PDF format. To download, click “📁”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عرض التقييم\"</b> لعرض أبعاد ثقافة بيئة العمل المختارة في التقييم الخاص بك!<br><br>ملحوظة: متوفر بصيغة PDF. للتحميل انقر على \"📁\"."
      }
    ]
  },
  {
    "key": "txt_Useouradv_513",
    "text": "Use our advanced AI tool to generate statements tailored to your need! ",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك! "
      }
    ]
  },
  {
    "key": "txt_GenerateS_831",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      }
    ]
  },
  {
    "key": "txt_ClickOnStatement",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. </br>Hint: Click “👁️” to preview the statement sample used in the assessment. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على<b> \"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق.</br> تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في التقييم. "
      }
    ]
  },
  {
    "key": "txt_AddStatem_838",
    "text": "Add Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة "
      }
    ]
  },
  {
    "key": "txt_EditCusto_165",
    "text": "Edit Custom Dimension ",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل البعد المخصص "
      }
    ]
  },
  {
    "key": "txt_Editordel_801",
    "text": "Edit or delete the new custom dimension. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف البعد المخصص الجديد. "
      }
    ]
  },
  {
    "key": "txtCustomDimensions_desc",
    "text": "If you want to add more statements, first click <b>“New Custom Dimension”</b>.</br> Note: Total Dimensions covering the <b>Predefined</b> and <b>Custom Dimensions</b> shall not exceed 8 Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على<b> \"بعد مخصص جديد\"</b>. </br>ملحوظة: يجب ألا يتجاوز إجمالي الأبعاد <b>المُعرفة مسبقاُ</b> و<b>المخصصة </b>عن 8 أبعاد. "
      }
    ]
  },
  {
    "key": "txtDimensions_desc",
    "text": "Maximize your experience with the full <b>culture dimensions</b> or tailor it to your needs by selecting a minimum of 3 dimensions.",
    "translations": [
      {
        "language": "AR",
        "text": "حقق أقصى استفادة من تجربة تقييم ثقافة بيئة العمل مع نموذج <b>أبعاد ثقافة بيئة العمل</b> الكامل، أو قم بتخصيصه ليناسب احتياجاتك عن طريق اختيار 3 أبعاد على الأقل."
      }
    ]
  },
  {
    "key": "txtDimensions_name",
    "text": "Culture Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد ثقافة بيئة العمل"
      }
    ]
  },
  {
    "key": "txt_translation_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      }
    ]
  },
  {
    "key": "txt_Translati_697",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "txt_Fillinyou_655",
    "text": "Fill in your <b>\"Assessment Name\"</b>. </br></br> You can add a description as well. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة <b>اسم التقييم</b>.</br></br> يمكنك أيضاً إضافة وصف للتقييم."
      }
    ]
  },
  {
    "key": "txt_SurveyDet_371",
    "text": "Assessment Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل التقييم "
      }
    ]
  },
  {
    "key": "txt_survey_info_desc",
    "text": "In <b>“Assessment Information</b>”, you specify the main elements, including assessment name and dimensions & statements! ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"معلومات التقييم\"</b> تُحدد العناصر الرئيسية، بما في ذلك اسم التقييم والأبعاد والعبارات."
      }
    ]
  },
  {
    "key": "txt_Clickhere_208",
    "text": "Click here to delete a draft assessment.<br><br> Note: only draft assessments can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف التقييمات المسودة. <br><br>ملحوظة: يمكن حذف تقييمات المسودة فقط"
      }
    ]
  },
  {
    "key": "txt_DeleteSur_232",
    "text": "Delete Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "حذف تقييم "
      }
    ]
  },
  {
    "key": "txt_Tocreatea_600",
    "text": "To create a new culture assessment, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"إعداد جديد\"</b> لإنشاء تقييم ثقافة جديد."
      }
    ]
  },
  {
    "key": "txt_OpenSurve_592",
    "text": "Open Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "فتح التقييم"
      }
    ]
  },
  {
    "key": "txt_Pointthem_434",
    "text": "Point the mouse over the assessment list to open draft, live, and closed assessments. ",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة التقييمات لفتح التقييمات بحالة المسودة، المباشرة، والمنتهية."
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      }
    ]
  },
  {
    "key": "txt_dates_error",
    "text": "date error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ في التاريخ"
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3001",
    "text": "Invalid emails",
    "translations": [
      {
        "language": "AR",
        "text": "بريد الكتروني غير صالح"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3000",
    "text": "Duplication Emails in Excel Sheet",
    "translations": [
      {
        "language": "AR",
        "text": "تكرار البريد الإلكتروني في ورقة إكسل"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3002",
    "text": "Row(s) missing required Name or Email",
    "translations": [
      {
        "language": "AR",
        "text": "بعض الصفوف تفتقد إلى الاسم أو البريد الإلكتروني المطلوبين"
      }
    ]
  },
  {
    "key": "txtWokplaceWellbeingEx",
    "text": "Workplace Culture Experience By",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة الرفاهية في مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txtIndex",
    "text": "Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      }
    ]
  },
  {
    "key": "txtWellbeing",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtCommentAiChartTitle",
    "text": "Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات التعليقات"
      }
    ]
  },
  {
    "key": "txtNeutralAISection",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      }
    ]
  },
  {
    "key": "txtNegative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      }
    ]
  },
  {
    "key": "txtPositive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      }
    ]
  },
  {
    "key": "txtAtleastRespondentsRequired",
    "text": "At least 3 respondents should complete the assessment in order to close it",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال التقييم من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      }
    ]
  },
  {
    "key": "txtStatement",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      }
    ]
  },
  {
    "key": "Applied Filters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر المُطبَّقة"
      }
    ]
  },
  {
    "key": "Performance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      }
    ]
  },
  {
    "key": "Tenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "التركيبة السكانية"
      }
    ]
  },
  {
    "key": "Extra Criteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      }
    ]
  },
  {
    "key": "Business Level",
    "text": "Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grades",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الوظيفية"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Levels",
    "translations": [
      {
        "language": "AR",
        "text": "المستويات الوظيفية"
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rates",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات الأداء"
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Groups",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Groups",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondentsToStart",
    "text": "At least one respondent is needed to proceed",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مستجيب واحد على الأقل"
      }
    ]
  },
  {
    "key": "txtDriver/Question",
    "text": "Dimension / statement",
    "translations": [
      {
        "language": "AR",
        "text": "البعد/العبارة"
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceWellbeing",
    "text": "Workplace Culture Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtEmployeeIndexByDimension",
    "text": "Employee Culture Index by Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف حسب البعد"
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations3",
    "text": "Create a financial wellness program and policy. Establish a Financial Well-being Fund by allocating a specific percentage of the organization’s revenue. Implement various initiatives, including earned salary access, debt counseling, upskilling support, and hardship loans, to improve employees' financial well-being. Regularly track the number of employees benefiting from each initiative and review their effectiveness. Additionally, offer benefits such as life and health insurance, housing, and caregiving allowances to further support employees' financial stability. The organization may prioritize interventions for junior or lower wage bracket employees. These efforts will contribute to creating a resilient and financially secure workforce.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء برنامج وسياسة الرفاهية المالية. يمكن للمؤسسة تخصيص نسبة محددة من إيراداتها لإنشاء صندوق يساهم في الرفاهية المالية للموظفين بشكل دوري. كما يمكن للمؤسسة تنفيذ مبادرات متنوعة في هذا المجال، بما في ذلك قدرة الموظف على الوصول إلى الراتب المكتسب، والإرشاد المالي، ودعم التطوير المهني، والقروض العُسرية، لتحسين رفاهية الموظفين المالية. يجب على المؤسسة مراقبة عدد الموظفين الذين يستفيدون من كل مبادرة ومدى فعالية هذه المبادرات بانتظام. بالإضافة إلى ذلك يمكن للمؤسسة تقديم فوائد مثل التأمين على الحياة، والتأمين الصحي، وبدلات السكن والرعاية، وذلك لدعم استقرار الموظفين المالي بشكل أكبر (قد تعطي المؤسسة الأولوية للموظفين الجُدد أو ذوي الأجور المنخفضة). ستساهم هذه الجهود في خلق بيئة عمل متينة و آمنة مالياً."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations2",
    "text": "Improve pay equity and pay equality. Ensure equal pay and benefits for all employees engaged in similar work in alignment with industry standards and organization resources, irrespective of their background. Establish a transparent reward and pay distribution process based on comprehensive job role evaluations. This initiative will enhance trust and foster a sense of fairness among employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تحسين مفهوم المساواة في الأجور لكافة الجوانب. يجب أن يحصل جميع الموظفين على رواتب ومزايا متساوية للأعمال المتماثلة وبما يتوافق مع معايير العمل وموارد المؤسسة ، و بغض النظر عن خلفيتهم القادمين منها. اتباع عملية عادلة في دفع الأجور وإعطاء المكافآت مبنية على تقييمات مسؤوليات الوظائف يساهم في تعزيز الثقة والشعور بالإنصاف بين الموظفين."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations1",
    "text": "Ensure fair pay and employee benefits. Implement a feasible base salary increase, secure working hours, and reduce compensation-related worries by ensuring regular and timely salary payments. This initiative must address living situation changes and align with the organization's financial resources.",
    "translations": [
      {
        "language": "AR",
        "text": "ضمان رواتب ومزايا عادلة لجميع الموظفين. ترتبط الرفاهية المالية ارتباطاً وثيقاً بدخل الموظف. وبالتالي، يجب التأكد من حصول الموظفين على راتب أساسي معقول قابل للزيادة، وساعات عمل آمنة. وكذلك، وضمان دفع رواتب منتظمة وفي الوقت المحدد، لتقليل القلق المرتبط بالتعويضات. لتطبيق ما ذكر أعلاه يجب الأخذ بعين الاعتبار التغيرات المستمرة في ظروف المعيشة و التوافق مع موارد المؤسسة المالية."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations3",
    "text": "Support employees to upskill and find meaning. Provide employees access to on-demand learning platforms (Udemy, Coursera, LinkedIn Learning etc.) and subsidize upskilling costs to enhance their skill sets. Additionally, allocate 3-4 hours weekly to learn skills for their future roles. Schedule regular feedback, coaching, and career counseling sessions to support employees in adapting to changes in their job roles and identify employees' strengths, weaknesses, interests, values, and potential. These initiatives can also help employees reframe their outlook toward the job to make it more meaningful.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم الموظفين لتعزيز مهاراتهم وجعلها ذات مغزى. يمكن للمؤسسة أن توفر للموظفين إمكانية تعزيز مهاراتهم من خلال الاستثمار في منصات التعلم (Udemy, Coursera, LinkedIn Learning). ويمكن للمؤسسة إعطاء الأولوية لتعزيز مهارات الموظفين من خلال تخصيص بضع ساعات (3-4 ساعات) أسبوعياً لتعلم المهارات التي ستساعدهم في دورهم المستقبلي. بالإضافة إلى ذلك، قد تحدد المؤسسات بعض الوقت لتلقي ردود الموظفين، وتقديم خدمات التدريب، وخدمات الإرشاد المهني لمساعدة الموظفين على التكيف مع التغييرات في أدوارهم الوظيفية. كما يمكنهم أيضاً تحديد نقاط القوة والضعف والإمكانات لدى الموظفين. يمكن أن تساعد هذه المبادرات الموظفين على إعادة صياغة نظرتهم للوظيفة لجعلها أكثر جدوى."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations2",
    "text": "Consider redesigning the job role. Annually, conduct reflective sessions with the team to identify aspects of their roles that energize and drain them. Utilize this information to enhance job roles and leverage team strengths proactively. Implement automation, digitalization, and innovative solutions to optimize productivity and efficiency. Engage employees in high-value tasks to benefit the organization and its customers. Regularly evaluate progress to ensure continuous improvement.",
    "translations": [
      {
        "language": "AR",
        "text": "النظر في إعادة تصميم الدور الوظيفي. مع تطور الأدوار والمسؤوليات الوظيفية، فإنه يصبح من الضروري التفكير سنوياً مع الفريق في جوانب دورهم الوظيفي التي تعمل على تنشيطهم وتحفيزهم. ستساعد هذه المعلومات المؤسسة على تحسين الأدوار الوظيفية والاستفادة دورياً من نقاط قوة الفريق، كما يمكن للمؤسسة  تطبيق عمليات الأتمتة والرقمنة والحلول الابتكارية لتحسين الإنتاجية والكفاءة، بالإضافة إلى إشراك الموظفين في مهام ذات قيمة عالية لصالح المؤسسة وعملائها. يجب على المؤسسة القيام بتقييم التقدم بانتظام لضمان التحسين المستمر."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations1",
    "text": "Connect employees to the big picture. Offer opportunities for employees to learn about the organization's vision and how their role contributes to achieving it. Show employees how the leadership is committed to the organization's vision and impact through their actions and behavior.  Additionally, show appreciation for employees who contribute to the organization's vision through public recognition, bonuses, promotions, or other incentives.",
    "translations": [
      {
        "language": "AR",
        "text": "ربط الموظفين بالرؤية الشاملة للمؤسسة. منح فرص للموظفين للتعرف على رؤية المؤسسة وعلى كيفية مساهمة دورهم في تحقيقها. على المؤسسة أن تظهر لموظفيها كيف تلتزم القيادة برؤية المؤسسة وتأثير أفعالهم وسلوكهم على ذلك. كما يمكن للمؤسسة أيضاً إظهار التقدير للموظفين الذين يساهمون في تحقيق رؤية المؤسسة من خلال إظهار التقدير أو إعطاء المكافآت أو الترقيات أو غيرها من الحوافز."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations4",
    "text": "Increase Transparency and Personal Accountability. Ensure managers foster a sense of accountability by setting individual and team goals and regularly reviewing progress towards these goals. Build trust and improve collaboration by demonstrating integrity, involving the team in crucial decisions, and recognizing individual contributors in collaborative projects.",
    "translations": [
      {
        "language": "AR",
        "text": "رفع مستوى الشفافية والمساءلة الشخصية. يمكن للمدراء تعزيز شعور المساءلة من خلال تحديد الأهداف الفردية والجماعية، ومراجعة التقدم المحرز في تحقيق هذه الأهداف بشكل دوري. كما يمكن للمدراء بناء الثقة وتعزيز التعاون من خلال إظهار النزاهة، وإشراك الفريق في اتخاذ القرارات الحاسمة، وتقدير المساهمين الفرديين في المشاريع التعاونية."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations3",
    "text": "Foster a sense of community. Create a sense of belonging and community within the workplace. Some initiatives the organization can consider include starting an employee-run book club, organizing an organizational sports league, or setting up an employee-run mentoring program. Encourage employees to donate their time, energy, and resources to support causes and communities as part of their corporate social responsibility initiatives. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز الشعور بالانتماء للمؤسسة. خلق شعور بالانتماء والوحدة داخل مكان العمل. وتتضمن بعض المبادرات التي يمكن للمؤسسة التفكير فيها  إنشاء نادي للقراءة يديره الموظفون أو تنظيم دوري رياضي للمؤسسة أو إعداد برنامج توجيه يديره الموظفون. وقد تشجع المؤسسة أيضاً الموظفين على التبرع بوقتهم وطاقتهم ومواردهم لجعلهم يرغبون في تقديم الدعم بشكل جماعي باعتبارهم مجتمعاً واحداً  كجزء من مساهمتهم في مبادرات المسؤولية الاجتماعية."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations2",
    "text": "Encourage collaboration. Create opportunities for employees to collaborate on projects and initiatives and provide the necessary resources and support to collaborate successfully. Some valuable resources include training on teamwork, providing tools and technology that facilitate collaboration, and recognizing and rewarding successful partnerships. ",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع التعاون. خلق فرص للموظفين للتعاون في المشاريع والمبادرات وتوفير الموارد اللازمة والدعم للتعاون بنجاح. وتتضمن بعض الموارد القيمة التدريب على العمل الجماعي، وتوفير الأدوات والتكنولوجيا التي تسهل التعاون، وتقدير الشراكات الناجحة ومكافأتها."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations1",
    "text": "Promote open communication. Encourage employees to communicate openly, honestly, and respectfully with each other and their managers. Ensure regular team meetings, one-on-one check-ins, and create channels for informal communication (tea breaks, group lunches, games, etc. may help). Empower managers to show genuine interest and empathy towards their employees to create a supportive work environment and improve team morale.",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز التواصل المفتوح. تشجيع الموظفين على التواصل بصراحة وصدق واحترام مع بعضهم البعض ومع مدرائهم. ويمكن للمؤسسة تحقيق ذلك من خلال عقد اجتماعات دورية للفريق، والتواصل الفردي، ومن خلال إنشاء قنوات للتواصل غير الرسمي (قد يساعد في ذلك أخذ استراحة الشاي أو القهوة، وتناول وجبات غداء جماعية، والألعاب، وما إلى ذلك). يجب على المؤسسة منح المدراء القدرة على التعبير عن اهتمامهم الصادق تجاه موظفيهم لخلق بيئة عمل داعمة وتحسين روح الفريق الواحد."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations4",
    "text": "Provide training for managers and supervisors. Train managers and supervisors to enhance their understanding of psychological factors, enable them to effectively manage and communicate with employees, and foster a positive and supportive work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير التدريب للمدراء والمسؤولين. يجب على أصحاب العمل تدريب المدراء والمسؤولين لتعزيز فهمهم للعوامل النفسية، وتمكينهم من إدارة الموظفين والتواصل معهم بشكل فعال لتعزيز بيئة عمل إيجابية وداعمة."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations3",
    "text": "Address workplace stressors. Conduct regular surveys or employee focus groups to identify specific workplace stress sources. Some everyday stressors include unrealistic deadlines, lack of resources, poor communication, and lack of autonomy. Address negative interactions and toxic behavior, such as bullying or harassment, to improve the psychological well-being of employees.",
    "translations": [
      {
        "language": "AR",
        "text": "معالجة ضغوط مكان العمل. يجب على أرباب العمل إجراء استبيانات دورية أو عمل جلسات نقاش مع الموظفين لتحديد المصادر التي تتسبب في حدوث توتر في مكان العمل. وتشمل بعض الضغوطات اليومية المواعيد النهائية غير الواقعية لتسليم الأعمال المنوطة بهم، ونقص الموارد وضعف التواصل والافتقار إلى الاستقلالية. إلى جانب ذلك، يجب على أصحاب العمل معالجة التفاعلات السلبية بين الموظفين والسلوك السيء، مثل التنمر أو التحرش، إلخ."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations2",
    "text": "Ensure employees can disconnect from work. Ensure employees disconnect from work after work hours and take regular breaks during non-work hours to reduce stress and enhance work-life balance. Additionally, create guidelines for flexible or remote work arrangements to effectively support employees in managing their work and personal responsibilities. ",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الفرص للموظفين للانفصال عن العمل. السماح للموظفين بأخذ فترات راحة منتظمة وقطع التواصل مع العمل بعد ساعات العمل الرسمية لتقليل التوتر وتعزيز التوازن بين العمل والحياة. كما يمكن لأصحاب العمل أيضاً دعم الموظفين من خلال السماح لهم بالعمل بمرونة أو عن بُعد لتحقيق التوازن بين عملهم ومسؤولياتهم الشخصية بشكل أفضل."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations1",
    "text": "Promote a culture of openness and support. Encourage employees to talk openly about their mental health and offer resources such as employee assistance programs, counseling services, and mental health days to support employees in handling stress and maintaining good psychological well-being. Provide resources and training on - time management training, relaxation techniques, mindfulness practices, etc.  to help employees handle stress. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز ثقافة الانفتاح والدعم. تشجيع الموظفين على التحدث بصراحة عن صحتهم النفسية، وتقديم الموارد اللازمة لهم مثل برامج مساعدة الموظفين، وخدمات تقديم المشورة، وأيام الصحة النفسية لدعم الموظفين في كيفية معالجة الإجهاد والحفاظ على صحة نفسية جيدة. كما يمكنهم أيضاً توفير الموارد والتدريب لمساعدة الموظفين على كيفية معالجة الإجهاد، مثل التدريب على إدارة الوقت وتقنيات الاسترخاء وممارسات التركيز الذهني."
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "التوصييات"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations4",
    "text": "Communicate effectively. Establish an efficient communication system to effectively relay health and safety information to employees. Provide comprehensive guidance on potential hazards, incident reporting, and updates on policies and procedures. Ensure clarity regarding employee rights, responsibilities, and points of contact for inquiries or concerns. Regularly evaluate the effectiveness of the communication strategy to enhance health and safety awareness and compliance.",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل الفعال. التواصل بشكل فعال مع الموظفين حول مواضيع الصحة والسلامة، بما في ذلك تزويدهم بالمعلومات حول المخاطر المحتملة، والإبلاغ عن الحوادث، ومشاركة التحديثات حول السياسات أو الإجراءات الجديدة. وعلاوة على ذلك، ضمان فهم الموظفين لحقوقهم ومسؤولياتهم ومن هي جهات الاتصال التي يجب اللجوء اليها للاستفسارات. يجب على المؤسسة أن تقوم بتقييم فعالية استراتيجية الاتصال بشكل منتظم لتعزيز الوعي بالصحة والسلامة والامتثال."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations3",
    "text": "Promote a healthy lifestyle. Implement a comprehensive employee wellness program to promote regular exercise, healthy eating, and stress management. Provide dedicated spaces for healthy food options and adequate space to encourage employees to take breaks for physical activity and stretching. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز أسلوب حياة صحية. تنفيذ برنامجًا شاملاً يضمن رفاهية الموظفين ويعزز ممارسة التمارين الرياضية بانتظام، وتحسين عادات التغذية الصحية،  وكيفية إدارة التوتر، بالإضافة إلى توفير خيارات طعام صحية للموظفين ومساحة كافية لتشجيعهم على أخذ فترات راحة لممارسة الأنشطة البدنية."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations2",
    "text": "Create an ergonomic work environment: Provide ergonomic furniture and equipment to reduce the risk of injury and strain caused by poor posture, repetitive motions, and other work-related hazards. Provide regular training and education on health and safety topics to all employees. Some activities may include things like first aid, fire safety, and training on specific hazards that are present in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "خلق بيئة عمل مريحة. توفير أثاث ومعدات مريحة للتقليل من مخاطر الإصابات والإجهاد الناجم عن الأوضاع السيئة والتحرك المستمر والمخاطر الأخرى المتعلقة بالعمل. وكذلك، يجب توفير تدريب وتعليم دوري حول مواضيع الصحة والسلامة لجميع الموظفين. وقد تتضمن بعض الأنشطة أشياءً مثل الإسعافات الأولية والوقاية من الحرائق والتدريب على مخاطر معينة موجودة في مكان العمل."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations1",
    "text": "Introduce wellness leaves. Assess feasibility and introduce wellness leaves for eligible organizations by aligning with labor law and compliance requirements. By the start of the following calendar year, the organization may introduce a wellness leave policy that allows employees to use their accrued sick leave to promote well-being and illness prevention (like massages, sleep adjustments, wellness classes, and preventive health screenings). Update policies, inform employees, and monitor the usage of wellness leaves to promote well-being and illness prevention. Collaborate with healthcare experts to support employee health and reinforce the organization’s commitment to their well-being. ",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز مفهوم الإجازات المرضية إلى إجازات إضافية (وقائية). يمكن للمؤسسات المؤهلة أن تقوم بطرح مفهوم الإجازات الإضافية (الوقائية) وبما بتوافق مع قوانين العمل ومتطلبات الامتثال. يمكن للمؤسسات في بداية العام طرح سياسة تمكن الموظفين من استخدام إجازاتهم المرضية المدفوعة غير المستخدمة لأغراض صحية وقائية مثل الذهاب لجلسات التدليك، وجلسات تعديل دورات النوم، وأخذ دروس عن الصحة الوقائية، هذا وبالإضافة إلى تشجيع الموظفين على القيام وبشكل دوري بعمل فحوصات وتحاليل طبية ووقائية). على المؤسسة أن تقوم بتحديث السياسات فيما يخص هذا المجال، وإبلاغ الموظفين، ورصد ومتابعة استخدام الإجازات الإضافية الوقائية لدعم الرعاية الصحية والوقاية من الأمراض. كما يمكن للمؤسسة التعاون مع خبراء في مجال الرعاية الصحية لدعم صحة الموظفين وتعزيز التزام المؤسسة بالحفاظ على صحتهم ورفاهيتهم."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPDescription",
    "text": "<p>Financial well-being refers to a state of financial wellness where employees have enough money to meet their basic needs and can cope with financial shocks like job loss. Employees may face stress because of current money management issues and because they are worried about their future financial security. The most common factors contributing to financial stress are the individual's wealth, knowledge, attitude toward finances, and current economic behavior. Lack of fair compensation and benefits, inflation, unexpected medical expenditure, student loans, stress related to potential layoffs, retirement, and caregiving responsibilities may lead to financial distress in employees.<br><br>Financial Well-being assesses if the current workplace provides financial safety and security to its employees. Financial stress can lead to absenteeism (an employee stays away from work without a valid reason) and presenteeism (an employee shows up at work but is not fully engaged) among employees. Financial stress may also decrease organizational commitment; hence they are less likely to be proactive, engaged, and satisfied with their current job. If a company scores low on this dimension, its employees face financial distress or dissatisfaction. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية المالية إلى حالة من الاستقرار المالي حيث يكون لدى الفرد ما يكفيه من المال لتلبية احتياجاته الأساسية، ويمكّنه من التعامل مع الصدمات المالية مثل فقدان الوظيفة.  وقد تشكل كيفية إدارة الأموال الحالية والأمن المالي المستقبلي ضغوطاً  كبيرة على الموظفين، وفي هذا السياق، جدير بالذكر أن العوامل الأكثر شيوعاً التي تساهم في الضغوط المالية هي ثروة الفرد الحالية، والمعرفة التي يمتلكها في هذا المجال، وموقفه تجاه الشؤون المالية والسلوك الاقتصادي الحالي. وقد يؤدي عدم وجود تعويضات ومزايا عادلة، والتضخم الاقتصادي، والنفقات الطبية غير المتوقعة، والقروض الطلابية، والضغوط المرتبطة بتسريح العمال، والتقاعد، والمسؤوليات المتعلقة بتقديم الرعاية  إلى ضائقة مالية لدى الموظفين.<br><br>وتُقيّم الرفاهية المالية ما إذا كانت المؤسسة توفر الأمن والسلامة المالية لموظفيها. وفي هذا السياق، تجدر الإشارة إلى أن الضغط المالي يؤدي إلى التغيب المستمر عن العمل (يبقى الموظف بعيداً عن العمل دون سبب وجيه) والحضور الشكلي (يتواجد الموظف في العمل ولكنه لا يشارك بشكل كامل)، وقد يؤدي الضغط المالي أيضاً إلى انخفاض مستوى التزامات الموظفين بالعمل في المؤسسة، ووبذلك فإنه من  المرجح أن يكونوا غير استباقيين ومشاركين وراضين عن وظائفهم الحالية. واستناداً إلى ما ذكر أعلاه، إذا سجلت المؤسسة درجات منخفضة في هذا البعد، فإن موظفيها يواجهون ضائقة مالية أو حالة عدم رضا.</p>"
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPDescription",
    "text": "<p>\"Occupational well-being\" refers to an employee's sense of purpose, growth, and fulfillment. Occupational well-being measures the presence of meaning, growth, and positive emotions toward the organization and current profession or job role. This dimension is closely related to employee engagement and satisfies an employee's need to improve and be part of something beyond oneself.<br><br>When people are involved in decisions about their work environment, tasks, and goals, they are likelier to feel that their opinions and ideas are valued. Involving employees can lead to a more positive work culture and satisfying work experience. Similarly, people are more motivated and engaged when they think their work is essential and makes a difference. When employees feel their work matters, it can increase job satisfaction, improving overall well-being.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم الرفاهية المهنية فهم الغرض من الوظيفة الحالية والإحساس بالمشاعر الإيجابية تجاهها وتجاه المؤسسة. هذه البعد مرتبط ارتباطًا وثيقًا بالارتباط الوظيفي للموظفين ويفي بحاجتهم للتحسين المستمر وأن يكونوا جزءًا من شيء يتجاوز ذاتهم. تشير الرفاهية المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم الرفاهية المهنية وجود المغزى والنمو والمشاعر الإيجابية تجاه الوظيفة الحالية للشركة أو دورها الوظيفي. ويرتبط هذا البعد ارتباطاً وثيقاً بمشاركة الموظفين، ويلبي حاجة الموظف إلى التحسين وأن يكون جزءاً من شيء يتجاوز مصلحته الشخصية.<br><br>عندما يشارك الموظفين في القرارات المتعلقة ببيئة عملهم ومهامهم وأهدافهم، فمن المرجح أن يشعروا بأن آرائهم وأفكارهم تحظى بالتقدير، ويمكن أن يؤدي إشراك الموظفين بتلك القرارات إلى بروز ثقافة عمل أكثر إيجابية وتجربة عمل مرضية. وبالمثل، يكون الموظفون أكثر حماساً واندماجاً بالعمل عندما يعتقدون أن عملهم ضروري وأنه يحدث فرقاً، وعندما يشعر الموظفون أن عملهم مهم، يمكن أن يؤدي ذلك إلى زيادة الرضا الوظيفي وتعزيز الرفاهية العامة.</p>"
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPDescription",
    "text": "<p>Social Well-being is where employees have strong and dependable working relations with coworkers, managers, and clients. It is a crucial component of overall Employee well-being and is closely related to physical and mental health. People with a reliable support network feel secure and less anxious or stressed at work. Being part of a community can also boost social well-being. <br><br>Social well-being assesses whether an organization fosters a culture of trust, personal connection, and social support among its employees. This can boost job satisfaction among employees and improve employee retention.<br><br>Organizations with high scores in this dimension will likely have productivity in teams and roles requiring collaboration and teamwork. These organizations might also have workplace design, practices, and culture that encourage employees to build connections and maintain healthy & meaningful relationships at work.<br><br>The social well-being of employees may be poor if employees work remotely or in a hybrid setting, are new, or are marginalized due to their differences. Organizations with low scores may need to investigate and take proactive steps to prevent employees from feeling excluded, lonely, or isolated. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تتمثل الرفاهية الاجتماعية في أن يكون للموظفين علاقات عمل قوية وموثوقة مع زملائهم في العمل ومدرائهم وعملائهم. وتعتبر الرفاهية الاجتماعية عنصر حاسم في رفاهية الموظف بشكل عام، وترتبط ارتباطاً وثيقاً بالصحة الجسدية والنفسية، ويشعر الأشخاص الذين يتمتعون بدعم اجتماعي قوي بالأمان ويكونون أقل قلقاً أو توتراً في مكان العمل. وجدير بالذكر أن كون الشخص جزءاً من مجتمع ما بشكل عام يعزز الرفاهية الاجتماعية وبشكل كبير.<br><br>وتقيم الرفاهية الاجتماعية عما إذا كانت المؤسسة تعزز ثقافة الثقة والاتصال الشخصي والدعم الاجتماعي بين موظفيها. كما يمكن أن تعزز الرفاهية الاجتماعية للموظفين رضاهم الوظيفي وتحسن معدل استبقاء الموظفين.<br><br>ومن المحتمل أن تتمتع المؤسسات ذات الدرجات العالية في هذا البعد بالإنتاجية في فرق العمل والمسؤوليات والمهام التي تتطلب التعاون والعمل الجماعي. وقد يكون لهذه المؤسسات أيضاً بيئة عمل وممارسات وثقافة معينة تشجع الموظفين على بناء علاقات صحية وذات مغزى في العمل والحفاظ عليها.<br><br>وقد تكون الرفاهية الاجتماعية للموظفين سيئة إذا كان الموظفون يعملون عن بعد أو في بيئة هجينة، أو إذا كانوا جديدين في العمل، أو تم تهميشهم بسبب الاختلافات فيما بينهم. وقد تحتاج المؤسسات ذات الدرجات المنخفضة إلى التحقيق في مدى تطبيقها للرفاهية الاجتماعية للموظفين، واتخاذ خطوات استباقية لمنع الموظفين من الشعور بالتهميش أو الوحدة أو العزلة في العمل.</p>"
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPDescription",
    "text": "<p>Psychological well-being refers to mental well-being and the ability to disconnect from work to manage personal life. Work-related stressors can affect mental health by making it difficult for employees to balance work and personal responsibilities. Not doing well can further lead to feelings of guilt and inadequacy, which can negatively impact mental health. Psychological Well-being assesses whether employees feel their organization cares about their mental health and work-life balance. <br><br>The organization need to identify and address workplace stress sources to promote a healthier and more balanced workforce. <br><br>Work-related Stressors can affect an individual's emotions and lead to various mental health problems, such as anxiety, depression, and even burnout. <br><br>Organizations can improve employee satisfaction, enhance productivity, and reduce absenteeism by prioritizing mental health and work-life balance. Organizations that do not prioritize psychological well-being can risk leaving employees emotionally exhausted and indifferent toward their work. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية النفسية إلى الصحة العقلية والقدرة على الفصل بين العمل والحياة الشخصية. يمكن أن تؤثر الضغوطات المرتبطة بالعمل على الصحة النفسية من خلال جعل الموظفين في حالة يصعب عليهم فيها الموازنة بين مسؤوليات العمل والمسؤوليات الشخصية مما قد يؤدي إلى الشعور بالذنب وعدم الكفاءة، وبالتالي يؤثر سلباً على صحتهم النفسية. وتُقيّم الرفاهية النفسية مدى شعور الموظفين بأن صاحب العمل يهتم بصحتهم النفسية وبقدرتهم على الموازنة بين العمل والحياة الشخصية. ويحتاج أرباب العمل إلى تحديد مصادر الإجهاد في مكان العمل ومعالجتها لتعزيز الصحة النفسية لموظفيهم وقدرتهم على الموازنة بين العمل والحياة.<br><br>كما يمكن أن تؤثر الضغوطات المرتبطة بالعمل على مشاعر الموظف، مما قد يؤدي إلى ظهور العديد من المشاكل النفسية، مثل القلق والاكتئاب وحتى الإرهاق. ويمكن للمؤسسات تحسين مستوى رضا الموظفين وتعزيز الإنتاجية وتقليل التغيب عن العمل عن طريق إعطاء الأولوية للتوازن بين العمل والحياة والصحة النفسية. وقد تبين أن المؤسسات التي لا تعطي الأولوية للصحة النفسية لموظفيها تخاطر بتركهم مرهقين شعورياً وغير مبالين تجاه عملهم.</p>"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPDescription",
    "text": "<p>Physical well-being is the state of optimal physical health and wellness for employees, encompassing the body's overall health and functionality. It covers various elements such as proper nutrition, regular exercise, adequate sleep, and preventative healthcare. The existing design of the workplace and policies can nudge employees toward or away from their physical well-being. Physical Well-being assesses the physical safety and health of employees at their workplace. Employees' physical well-being is essential for a business's success and productivity because it directly affects their ability to perform their duties effectively and efficiently. <br><br>Additionally, physically well employees are more likely to be engaged and motivated, increasing productivity and job satisfaction. In the long term, investing in the physical well-being of employees can also lead to lower healthcare costs and a reduction in absenteeism. Organizations with low score must investigate how their workplace design, policies, and procedures can negatively impact physical well-being. For example, poor ergonomics, such as poorly designed desks and chairs, can lead to musculoskeletal problems like back pain, neck pain, and carpal tunnel syndrome. Poor lighting and ventilation can also contribute to physical issues, such as eye strain and headaches. Specific policies and procedures can negatively impact physical well-being. A culture that discourages taking breaks can lead to fatigue and burnout. Similarly, a lack of flexibility in the work schedule can cause physical health problems. The organization should be mindful of these factors and make necessary adjustments to promote their employees' physical well-being.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية من الناحية البدنية (الصحية) إلى حالة الصحة الجسدية والعافية المثلى للموظفين، وذلك يشمل عناصر مختلفة مثل التغذية السليمة، وممارسة التمارين الرياضية بانتظام، والنوم الكافي، والرعاية الصحية الوقائية. ويمكن للتصميم الحالي لمكان العمل والسياسات المتبعة فيه أن ترقى بالموظفين نحو رفاهيتهم الصحية أو تأخذهم بعيداً عن تلك الرفاهية. وتقيّم الرفاهية الصحية مدى السلامة البدنية وصحة الموظفين في مكان عملهم. وتعتبر الرفاهية الصحية للموظفين ضرورية لنجاح الأعمال وإنتاجية الموظفين، لأنها تؤثر وبشكل مباشر على قدرتهم على أداء التزاماتهم بفعالية وكفاءة. بالإضافة إلى ذلك، فإنه من المرجح أن يكون الموظفون الذين يتمتعون بصحة جيدة بدنياً أكثر اندماجاً وتحفيزاً، مما يزيد من الإنتاجية والرضا الوظيفي، ويمكن أن يؤدي الاستثمار في الرفاهية الصحية للموظفين إلى انخفاض تكاليف الرعاية الصحية وتقليل التغيب عن العمل على المدى الطويل.<br><br>ويجب على المؤسسات ذات الدرجات المنخفضة في هذا الجانب التحقق من كيفية تأثير تصميم مكان العمل والسياسات والإجراءات المتبعة بشكل سلبي على الرفاهية الصحية للموظفين، على سبيل المثال، يمكن أن تؤدي بيئة العمل السيئة، مثل المكاتب والكراسي سيئة التصميم، إلى حدوث مشاكل في العضلات والعظام مثل آلام الظهر، وآلام الرقبة، ومتلازمة النفق الرسغي، كما يمكن أن يساهم ضعف الإضاءة والتهوية في حدوث مشكلات جسدية، مثل إجهاد العين والصداع، كما يمكن لبعض السياسات والإجراءات أن تؤثر سلباً على الرفاهية الموظفين في هذا المنطلق. هذا وكما يمكن أن تؤدي الثقافة التي لا تشجع على أخذ فترات راحة إلى الإجهاد والإرهاق، وبالمثل، فإن عدم وجود مرونة في جدول العمل يمكن أن يسبب مشاكل صحية بدنية، لذلك يجب على أرباب العمل أن يضعوا في اعتبارهم هذه العوامل وأن يقوموا بالتعديلات اللازمة لتعزيز الصحة البدنية لموظفيهم.</p>"
      }
    ]
  },
  {
    "key": "txtDimensionsofWorkplaceWellbeingDesc",
    "text": "The below indicates the scores for each of the [Dimensions Count] dimensions of Workplace Culture at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يشير ما  يلي إلى الدرجات لكل بُعد من أبعاد رفاهية الموظف في الشركة:"
      }
    ]
  },
  {
    "key": "txtDimensionsOfWorkplaceWellbeing",
    "text": "Workplace Culture Dimensions ",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndexpara",
    "text": "The Employee Culture Index indicates the overall culture perception of respondents in the company. The Data below exhibits the percentage of respondents with very high, high, moderate, low, and very low culture alignment based on their responses to the various dimensions of Workplace Culture.",
    "translations": [
      {
        "language": "AR",
        "text": "وتمثل مؤشرات رفاهية الموظفين المستوى التالي من درجة الرفاهية في مكان العمل. وتعرض النتائج أدناه النسب المئوية للموظفين الذين يتمتعون برفاهية مرتفعة للغاية، مرتفعة، معتدلة، منخفضة منخفضة للغاية بناءً على ردودهم على أبعاد رفاهية الموظف المختارة."
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndex",
    "text": "Employee Culture Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeingpara1",
    "text": "The Workplace Culture Score represents the respondents' overall perception of their workplace culture. It is the average score of the respondents to the selected dimensions of Workplace Culture.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة رفاهية الموظف في مكان العمل عن التصور والرفاهية الكلية. وهي تشكل المعدل الكلي لنتائج أبعاد رفاهية الموظف المختارة."
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeing",
    "text": "Overall Workplace Culture Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة رفاهية الموظف الكلي في مكان العمل"
      }
    ]
  },
  {
    "key": "txtCalculationProcess4",
    "text": "The overall score for each dimension can help companies understand what measures they need to take to improve workplace culture.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن للنتيجة الإجمالية لكل بُعد مساعدة الشركات على فهم التدابير التي يتعين عليهم اتخاذها لتحسين رفاهية الموظفين."
      }
    ]
  },
  {
    "key": "txtCalculationProcess3",
    "text": "The overall score for each dimension gives the average response of the employees for that dimension.",
    "translations": [
      {
        "language": "AR",
        "text": "تعطي الدرجة الإجمالية لكل بُعد متوسط استجابة الموظفين لهذا البعد."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "\"Very Low\" means that the current workplace, culture, and practices are not employee friendly and may even endanger workplace culture. In contrast, \"Very High\" means that the contemporary workplace, culture, and practices are significantly employee friendly and that the company takes workplace culture seriously.",
    "translations": [
      {
        "language": "AR",
        "text": "وتعني كلمة \"منخفض للغاية\" أن مكان العمل الحالي والثقافة والممارسات ليست محببة للموظفين، بل وقد تعرض رفاهية الموظف للخطر. وفي المقابل، تعني كلمة \"مرتفع للغاية\" أن مكان العمل والثقافة والممارسات الحالية محببة للموظفين بشكل كبير، وأن الشركة تأخذ رفاهية الموظفين على محمل الجد."
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "The overall workplace culture score of the organization ranges from Very Low, Low, Moderate, High, to Very High.",
    "translations": [
      {
        "language": "AR",
        "text": "تتراوح النتيجة الإجمالية لرفاهية الموظف في الشركة من منخفض للغاية، منخفض، معتدل، مرتفع إلى مرتفع للغاية."
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      }
    ]
  },
  {
    "key": "txtHowtousethisreportpara",
    "text": "<p>Culture Assessment scores displayed in this report indicate the overall perception of the employees in the company. <br><br>The Recommended actions in this report are only some of the many activities that can improve workplace culture. They are not limited to the displayed suggestions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير درجات رفاهية الموظف المعروضة في هذا التقرير إلى الدرجات الإجمالية للموظفين في الشركة.  <br><br> وجدير بالذكر أن الإجراءات الموصى بها لتعزيز رفاهية الموظف غير مقتصرة على الاقتراحات المعروضة في هذا التقرير، بل هي أمثلة عن بعض الأنشطة من أصل أنشطة أخرى متعددة والتي من شأنها تعزيز رفاهية الموظف في مكان العمل.</p>"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensionsPara",
    "text": "<p>Even when the company has good intentions, current workplace practices, policies, and culture sometimes negatively impact employee experience. <br><br>Zenithr's team has designed its Culture Assessment module based on the industry's latest thought leadership and the Competing Values Framework. Zenithr's team uses a structured approach to help companies align and improve workplace culture.<br><br>Improving alignment in one dimension can simultaneously benefit overall organizational performance. The companies can first prioritize areas presented in the report.  </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>إن ممارسات وسياسات وثقافة مكان العمل الحالية - حتى عندما يكون لدى المؤسسة نوايا حسنة - تؤثر سلباً في بعض الأحيان على رفاهية الموظف. <br><br>وقد قام فريق زينثر بتصور وتصميم رفاهية الموظفين بناءً على أحدث التطورات والأبحاث الرائدة في هذا المجال. ويستخدم فريق زينثر نهج التفكير التصميمي لمساعدة المؤسسات على إعطاء الأولوية لرفاهية موظفيها وتحسينها باستمرار.<br><br>وجدير بالذكر أنه يمكن لتحسين أحد الأبعاد أن يؤدي إلى تحسين الأبعاد الأخرى في ذات الوقت، لذلك يمكن للمؤسسات  البدء بإعطاء الأولوية للأبعاد ذات الدرجات المنخفضة، كما سيتم ذكره في التقرير.   </p>"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensions",
    "text": "Zenithr Workplace Culture Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف الخاصة ب زينثر"
      }
    ]
  },
  {
    "key": "txtobjectives",
    "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">Objectives of this Report</h4><div class=\"flex flex-col items-stretch gap-2\"><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Identify and understand how employees perceive their workplace culture across various dimensions.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Obtain open-ended responses and employees' feedback to align and support workplace culture.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Address areas of improvement based on cultural diagnosis.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Provide recommendations for the company to maintain and enhance organizational culture.</p></div></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">أهداف التقرير</h4><div class=\"flex flex-col items-stretch gap-2\"><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تحديد وفهم كيفية إدراك الموظفين لمفهوم رفاهيتهم عبر أبعاد مختلفة.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>الحصول على ردود وملاحظات واضحة من الموظفين للحفاظ على رفاهيتهم في مكان العمل ودعمه.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>معالجة مجالات تحسين العمل (بناءً على أبعاد ذات درجات منخفضة)</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تقديم توصيات للشركة للحفاظ على الرفاهية في العمل وتعزيزها.</p></div></div>"
      }
    ]
  },
  {
    "key": "txtIntroductionpara",
    "text": "<p>Workplace culture refers to the shared values, belief systems, attitudes, and assumptions that influence how employees behave and interact within an organization. <br><br> Zenithr Culture Assessment evaluates organizational culture mapping. Companies prioritizing healthy workplace culture can enhance engagement, organizational citizenship behavior, and productivity. <br><br> Zenithr Culture Assessment assessment gives organizations an overview of their dominant cultural archetypes to help design relevant interventions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير رفاهية الموظف إلى جودة حياة العمل التي يعيشها الموظف عند عمله لدى المؤسسة. <br><br>ويقاس تقييم زينيثر الخاص برفاهية الموظف عن طريق التركيز على خمسة أبعاد أساسية - جسدية ونفسية واجتماعية ومهنية ومالية. ويمكن للمؤسسات التي تعطي الأولوية لرفاهية الموظفين أن تقلل من معدل إجهاد الموظفين، ومن التدوير الوظيفي، ومصروفات الرعاية الصحية، وعدم الاندماج في العمل، والتعذر والتغيب عن العمل. كما يمكنهم أيضاً تحسين الوضع الصحي العام لموظفيهم، وتحسين إنتاجية المؤسسة، و ثقافتها المؤسسية، وقدرتها على التكيف مع التغيير.<br><br>ويعطي تقييم رفاهية الموظف المُطوّر من قبل زينثر للمؤسسات لمحة عامة عن مدى تأثيرهم على رفاهية موظفيهم. وقد تساعدهم النتائج على تحديد وتصميم وإجراء التغييرات ذات الصلة في مكان العمل لجعله محبباً للموظفين.</p>"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      }
    ]
  },
  {
    "key": "txtWellbeingReport",
    "text": "Culture Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      }
    ]
  },
  {
    "key": "txtEmployeeWellbeing",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      }
    ]
  },
  {
    "key": "txt_download_comments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليفات"
      }
    ]
  },
  {
    "key": "txtWorkplaceWellbeingScore",
    "text": "Culture Assessment Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة رفاهية مكان العمل"
      }
    ]
  },
  {
    "key": "txtWellbeingComparison",
    "text": "Culture Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtSurveysByCompany",
    "text": "Assessments By Company",
    "translations": [
      {
        "language": "AR",
        "text": "التقييمات حسب الشركة"
      }
    ]
  },
  {
    "key": "txtAveraged",
    "text": "Averaged",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات المختارة"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txtInDays",
    "text": "(in {{0}} days)",
    "translations": [
      {
        "language": "AR",
        "text": "(خلال {{0}} أيام)"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      }
    ]
  },
  {
    "key": "txtStatusAnalysis",
    "text": "Respondents by Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل حالة المستجيبون"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txt_Generated_142",
    "text": "Generated Link",
    "translations": [
      {
        "language": "AR",
        "text": "الرابط المنشئ"
      }
    ]
  },
  {
    "key": "WB:2003",
    "text": "Link has already been sent to the user.",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة الرابط مع المستجيب"
      }
    ]
  },
  {
    "key": "txt_remove_criteria_confirmation_message",
    "text": "Are you sure you want to delete this criteria?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذه المعايير؟"
      }
    ]
  },
  {
    "key": "txtAnalysisSection",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      }
    ]
  },
  {
    "key": "txtRespondentsBy",
    "text": "Respondents By",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txtByCriteria",
    "text": "By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حسب المعايير"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      }
    ]
  },
  {
    "key": "txtbydimensions",
    "text": "By Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الأبعاد"
      }
    ]
  },
  {
    "key": "VGOODEXP",
    "text": "Very High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع للغاية"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع"
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض"
      }
    ]
  },
  {
    "key": "VPOOREXP",
    "text": "Very Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض للغاية"
      }
    ]
  },
  {
    "key": "txtWellbeingIndexByScale",
    "text": "Culture Assessment Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_dimensions_score",
    "text": "Dimensions Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الأبعاد"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "Global",
    "translations": [
      {
        "language": "AR",
        "text": "العالمي"
      }
    ]
  },
  {
    "key": "txt_TopPerfor_672",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "بشكل عام"
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      }
    ]
  },
  {
    "key": "txt_Workplace_Wellbeing_Score",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية مكان العمل"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "txtExtraDriver",
    "text": "Extra Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "بُعد الرفاهية الإضافي"
      }
    ]
  },
  {
    "key": "preparingReport",
    "text": "Preparing Report",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التقرير"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message",
    "text": "Are you sure you want to delete this assessment?",
    "translations": [
      {
        "language": "AR",
        "text": "هل انت متأكد من حذف هذا التقييم؟"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Assessment Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم التقييم"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved\t",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التقييم"
      }
    ]
  },
  {
    "key": "txtWellbeingSurveyPreview",
    "text": "Culture Assessment Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض تقييم رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtRespondentsByStatus",
    "text": "RESPONDENTS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الحالة"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate\t",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      }
    ]
  },
  {
    "key": "txtReminderSent",
    "text": "Reminders has been sent.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التذكيرات."
      }
    ]
  },
  {
    "key": "txt_employee_WellbeingSurvey",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_questionnaire_welcome",
    "text": "<p>Thank you for taking the time to fill out the Culture Assessment. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the assessment will be used for research and improvement purposes by the Human Resources Team.<br><br> Disclaimer: All information pertaining to this assessment shall remain anonymous and shall not be disclosed to anyone.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>نشكرك لمشاركتك في هذا التقييم. أجوبتك النزيهة والصريحة مهمة لنا. يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا التقييم سرية للغاية وستبقى هويتك مجهولة. وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.<br><br> إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا التقييم سرية ولن يتم الإفصاح عنها لأي جهة.</p>"
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم ثقافة وبيئة العمل"
      }
    ]
  },
  {
    "key": "txtSendEmails",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال تذكيرات"
      }
    ]
  },
  {
    "key": "txtProvideEndDate",
    "text": "You need to provide an end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال تاريخ الإكمال."
      }
    ]
  },
  {
    "key": "txt_go_closed",
    "text": "This assessment will now be closed and you will no longer be able to make any changes or add new respondents.\t",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا التقييم الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txt_Atleast3r_677",
    "text": "At least 3 respondents should complete the assessment in order to close it\t",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال التقييم من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txtRemindersBulkSend",
    "text": "Reminders will be sent to total #count respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إرسال التذكيرات ل #count مستجيب."
      }
    ]
  },
  {
    "key": "txtSelectAllRespondentsFromPages",
    "text": "Select all respondents from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "اختر  كل المستجيبين من كافة الصفحات؟"
      }
    ]
  },
  {
    "key": "txtSelectedRespondentsOnPage",
    "text": "#count respondents on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار #count مستجيب من هذه الصفحة."
      }
    ]
  },
  {
    "key": "txtAllRespondentsFromPages",
    "text": "All #count respondents from all pages are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count المستجيبين من كافة الصفحات."
      }
    ]
  },
  {
    "key": "txtSelectedSurveysOnPage",
    "text": "#count draft assessments on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم #count تحديد مسودة على هذه الصفحة."
      }
    ]
  },
  {
    "key": "txtSelectAllFromPages",
    "text": "Select all #count draft assessments from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد تحديد #count  مسودة من كافة الصفحات؟"
      }
    ]
  },
  {
    "key": "txt_ClearSele_284",
    "text": "Clear Selection",
    "translations": [
      {
        "language": "AR",
        "text": " مسح كافة التحديدات"
      }
    ]
  },
  {
    "key": "txtAllSurveysSelected",
    "text": "All #count assessments from all pages are selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count التقييمات من كافة الصفحات"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      }
    ]
  },
  {
    "key": "txt_ShareSurv_665",
    "text": "Share Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة التقييم"
      }
    ]
  },
  {
    "key": "txt_DeleteSel_329",
    "text": "Delete Selected",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?\t",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      }
    ]
  },
  {
    "key": "txt_NewRespon_215",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txt_Share_429",
    "text": "Share",
    "translations": [
      {
        "language": "AR",
        "text": "شارك"
      }
    ]
  },
  {
    "key": "txt_CloseNow_473",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      }
    ]
  },
  {
    "key": "txtExport",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Searchres_762",
    "text": "Search respondents...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث..."
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.\t",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_565",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      }
    ]
  },
  {
    "key": "txt_delete_item_confirmation_message",
    "text": "Are you sure you want to permanently remove this item?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا العنصر نهائياً؟"
      }
    ]
  },
  {
    "key": "txt_NewQuesti_189",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_newstatem_408",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Assessment Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة التقييم"
      }
    ]
  },
  {
    "key": "txt_Selectall_272",
    "text": "Select all",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Dimension Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم البعد"
      }
    ]
  },
  {
    "key": "txt_Atleaston_223",
    "text": "At least one statement needs to be added",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل"
      }
    ]
  },
  {
    "key": "txt_Dimension_242",
    "text": "Dimensions can't be more than 6",
    "translations": [
      {
        "language": "AR",
        "text": "الأبعاد يجب ألا تزيد عن 6!"
      }
    ]
  },
  {
    "key": "txt_Dimension_415",
    "text": "At least 3 predefined dimensions must be selected!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 أبعاد على الأقل!"
      }
    ]
  },
  {
    "key": "txt_inthispag_314",
    "text": "in this page have been selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار عناصر في هذه الصفحة"
      }
    ]
  },
  {
    "key": "txt_Allitemsh_336",
    "text": "All items have been selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد كافة العناصر"
      }
    ]
  },
  {
    "key": "txt_BACKTOSUR_422",
    "text": "BACK",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال التقييم"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Assessment Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد التقييم"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondents",
    "text": "At least 3 respondents are needed to submit the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال التقييم من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!\t",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      }
    ]
  },
  {
    "key": "txt_Pleaseimp_478",
    "text": "Please import valid .xlsx file.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى استيراد ملف .xlsx صالح."
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المزيد من التعليقات؟"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": "I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في بيئة العمل"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج عرض لسؤال التقييم."
      }
    ]
  },
  {
    "key": "txt_Sample_Question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Assessment Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات التقييم"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_862",
    "text": "Add up to 4 statements\t",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 4 عبارات"
      }
    ]
  },
  {
    "key": "txt_NewCustom_150",
    "text": "New Custom Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "بعد مخصص جديد"
      }
    ]
  },
  {
    "key": "txt_STATEMENT_772",
    "text": "Statements of",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات"
      }
    ]
  },
  {
    "key": "txt_Selectupt_657",
    "text": "Select up to 6 Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "حدد ما يصل إلى 6 أبعاد"
      }
    ]
  },
  {
    "key": "txt_Optional_264",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      }
    ]
  },
  {
    "key": "txt_Descripti_202",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "txtCustomDimensions",
    "text": "Custom Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد مخصصة"
      }
    ]
  },
  {
    "key": "txtDimensions",
    "text": "Predefined Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد مُعرفة مسبقاً"
      }
    ]
  },
  {
    "key": "txt_SurveyLis_133",
    "text": " Assessment List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة التقييمات"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_NewSetup_163",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      }
    ]
  },
  {
    "key": "txt_Search_185",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      }
    ]
  },
  {
    "key": "txt_DateCreat_677",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      }
    ]
  },
  {
    "key": "txt_SurveyTit_804",
    "text": "Assessment Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان التقييم"
      }
    ]
  },
  {
    "key": "txt_Status_579",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_Workplace_928",
    "text": "Organizational Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة مكان العمل"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الجميع"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the assessment before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة التقييم قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل التقييم"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Assessment Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان التقييم"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      }
    ]
  },
  {
    "key": "txt_CvfSummaryTitle",
    "text": "Competing Values Framework Summary",
    "translations": [
      {
        "language": "AR",
        "text": "ملخص نموذج القيم التنافسية"
      }
    ]
  },
  {
    "key": "txt_CvfSummarySubtitle",
    "text": "Executive analysis of core OCAI archetype matrices and cultural alignment.",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل تنفيذي لمصفوفات الأنماط الأساسية لأداة تقييم الثقافة التنظيمية (OCAI) والمواءمة الثقافية."
      }
    ]
  },
  {
    "key": "txt_CurrentDominantCulture",
    "text": "Current Dominant Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة السائدة الحالية"
      }
    ]
  },
  {
    "key": "txt_PreferredDominantCulture",
    "text": "Preferred Dominant Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة السائدة المرغوبة"
      }
    ]
  },
  {
    "key": "txt_CalibratedWeight",
    "text": "Calibrated Aggregated Weight",
    "translations": [
      {
        "language": "AR",
        "text": "الوزن الإجمالي المعاير"
      }
    ]
  },
  {
    "key": "txt_IdealTargetScore",
    "text": "Ideal Target Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة المستهدفة المثالية"
      }
    ]
  },
  {
    "key": "txt_QuadrantDistribution",
    "text": "Quadrant Score Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع درجات الأرباع"
      }
    ]
  },
  {
    "key": "txt_Now",
    "text": "Now",
    "translations": [
      {
        "language": "AR",
        "text": "الآن"
      }
    ]
  },
  {
    "key": "txt_Preferred",
    "text": "Preferred",
    "translations": [
      {
        "language": "AR",
        "text": "المرغوبة"
      }
    ]
  },
  {
    "key": "txt_Clan",
    "text": "Clan",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الجماعة"
      }
    ]
  },
  {
    "key": "txt_Adhocracy",
    "text": "Adhocracy",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الإبداع"
      }
    ]
  },
  {
    "key": "txt_Market",
    "text": "Market",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة السوق"
      }
    ]
  },
  {
    "key": "txt_Hierarchy",
    "text": "Hierarchy",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الهرمية"
      }
    ]
  },
  {
    "key": "txt_Mixed",
    "text": "Mixed",
    "translations": [
      {
        "language": "AR",
        "text": "مختلط"
      }
    ]
  },
  {
    "key": "txt_CurrentCulture",
    "text": "Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الحالية"
      }
    ]
  },
  {
    "key": "txt_PreferredCulture",
    "text": "Preferred Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة المرغوبة"
      }
    ]
  },
  {
    "key": "txt_OcaiRadarProfilesTitle",
    "text": "OCAI Radar Profiles",
    "translations": [
      {
        "language": "AR",
        "text": "ملفات أداة تقييم الثقافة التنظيمية (OCAI)"
      }
    ]
  },
  {
    "key": "txt_OcaiRadarProfilesSubtitle",
    "text": "Interactive assessment vectors overlaying Current vs. Preferred competing values matrices.",
    "translations": [
      {
        "language": "AR",
        "text": "متجهات تقييم تفاعلية تقارن مصفوفات القيم التنافسية الحالية والمرغوبة."
      }
    ]
  },
  {
    "key": "txt_OverallAssessmentVector",
    "text": "Overall Assessment Vector",
    "translations": [
      {
        "language": "AR",
        "text": "متجه التقييم العام"
      }
    ]
  },
  {
    "key": "txt_InsufficientMatrices",
    "text": "Insufficient assessment response matrices to render radar vector.",
    "translations": [
      {
        "language": "AR",
        "text": "مصفوفات استجابة غير كافية لعرض رسم الرادار."
      }
    ]
  },
  {
    "key": "txt_DimensionProfilesBreakdown",
    "text": "Dimension Profiles Breakdown",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل ملفات الأبعاد"
      }
    ]
  },
  {
    "key": "txt_NoDataToDisplay",
    "text": "No data to display.",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد بيانات للعرض."
      }
    ]
  },
  {
    "key": "txt_StrategicGapAnalysisTitle",
    "text": "Strategic Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الفجوات الاستراتيجية"
      }
    ]
  },
  {
    "key": "txt_StrategicGapAnalysisSubtitle",
    "text": "Evaluating transformational velocity matrices via archetype delta scores (Preferred - Current).",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم سرعة التحول من خلال حساب الفروق بين النماذج الثقافية (المرغوبة - الحالية)."
      }
    ]
  },
  {
    "key": "txt_OverallAssessmentDelta",
    "text": "Overall Assessment Delta",
    "translations": [
      {
        "language": "AR",
        "text": "الفروق الإجمالية للتقييم"
      }
    ]
  },
  {
    "key": "txt_Quadrant",
    "text": "Quadrant",
    "translations": [
      {
        "language": "AR",
        "text": "الربع"
      }
    ]
  },
  {
    "key": "txt_Velocity",
    "text": "Velocity",
    "translations": [
      {
        "language": "AR",
        "text": "السرعة"
      }
    ]
  },
  {
    "key": "txt_DimensionGapDetails",
    "text": "Dimension Gap Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل فجوات الأبعاد"
      }
    ]
  },
  {
    "key": "txt_DimensionBreakdown",
    "text": "Dimension Breakdown",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل البعد"
      }
    ]
  },
  {
    "key": "txt_QuadrantVelocityComparisons",
    "text": "Quadrant Velocity Comparisons",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنات سرعة التحول للأرباع"
      }
    ]
  },
  {
    "key": "txt_Archetype",
    "text": "Archetype",
    "translations": [
      {
        "language": "AR",
        "text": "النمط"
      }
    ]
  },
  {
    "key": "txt_CurrentState",
    "text": "Current State",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة الحالية"
      }
    ]
  },
  {
    "key": "txt_PreferredState",
    "text": "Preferred State",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة المرغوبة"
      }
    ]
  },
  {
    "key": "txt_TransformationTargetGap",
    "text": "Transformation Target Gap",
    "translations": [
      {
        "language": "AR",
        "text": "فجوة التحول المستهدفة"
      }
    ]
  },
  {
    "key": "txt_GrowthRequired",
    "text": "Growth Required",
    "translations": [
      {
        "language": "AR",
        "text": "نمو مطلوب"
      }
    ]
  },
  {
    "key": "txt_ReductionTargeted",
    "text": "Reduction Targeted",
    "translations": [
      {
        "language": "AR",
        "text": "تقليص مستهدف"
      }
    ]
  },
  {
    "key": "txt_EquilibriumCurrent",
    "text": "Equilibrium Current",
    "translations": [
      {
        "language": "AR",
        "text": "توازن حالي"
      }
    ]
  },
  {
    "key": "txt_ClanDriver",
    "text": "Collaborative Focus",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز التعاوني"
      }
    ]
  },
  {
    "key": "txt_AdhocracyDriver",
    "text": "Creative Focus",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الإبداعي"
      }
    ]
  },
  {
    "key": "txt_MarketDriver",
    "text": "Competitive Focus",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز التنافسي"
      }
    ]
  },
  {
    "key": "txt_HierarchyDriver",
    "text": "Structured Focus",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الهيكلي"
      }
    ]
  },
  {
    "key": "txt_LeadershipStyles",
    "text": "Leadership Styles",
    "translations": [
      {
        "language": "AR",
        "text": "أنماط القيادة"
      }
    ]
  },
  {
    "key": "txt_CoreStrengths",
    "text": "Core Strengths",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة الأساسية"
      }
    ]
  },
  {
    "key": "txt_DriverShiftAnalysis",
    "text": "Driver-Level Shift Trajectory Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل مسار التحول على مستوى المحرك"
      }
    ]
  },
  {
    "key": "txt_DriverShiftSubtext",
    "text": "Examine primary archetype transitions per assessment driver dimension.",
    "translations": [
      {
        "language": "AR",
        "text": "فحص التحولات الأساسية للنماذج لكل بعد من أبعاد التقييم."
      }
    ]
  },
  {
    "key": "txt_OcaiFrameworkGuide",
    "text": "OCAI Interpretive Framework Guide",
    "translations": [
      {
        "language": "AR",
        "text": "دليل الإطار التفسيري لأداة تقييم الثقافة التنظيمية (OCAI)"
      }
    ]
  },
  {
    "key": "txt_OcaiGuideSubtext",
    "text": "Reference definitions for Competing Values Framework organizational culture archetypes.",
    "translations": [
      {
        "language": "AR",
        "text": "تعريفات مرجعية لأنماط الثقافة التنظيمية لنموذج القيم التنافسية."
      }
    ]
  },
  {
    "key": "txt_CvfDiagnosticProfile",
    "text": "Competing Values Framework Diagnostic Profile",
    "translations": [
      {
        "language": "AR",
        "text": "الملف التشخيصي لنموذج القيم التنافسية"
      }
    ]
  },
  {
    "key": "txt_ProfileOverlay",
    "text": "Current vs. Preferred Overlay",
    "translations": [
      {
        "language": "AR",
        "text": "تراكب الوضع الحالي والمرغوب"
      }
    ]
  },
  {
    "key": "txt_StructuralPolarityTensions",
    "text": "Macro Structural Tensions & Polarity Balances",
    "translations": [
      {
        "language": "AR",
        "text": "التوترات الهيكلية الكلية وتوازنات القطبية"
      }
    ]
  },
  {
    "key": "txt_PolaritySubtext",
    "text": "Analyze organizational equilibrium along core Competing Values Framework foundational competing axes.",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل التوازن التنظيمي عبر المحاور المتنافسة الأساسية لنموذج القيم التنافسية."
      }
    ]
  },
  {
    "key": "txt_PsychologicalOrientation",
    "text": "Psychological Orientation Axis",
    "translations": [
      {
        "language": "AR",
        "text": "محور التوجه النفسي"
      }
    ]
  },
  {
    "key": "txt_InternalFocus",
    "text": "Internal Focus & Integration",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الداخلي والتكامل"
      }
    ]
  },
  {
    "key": "txt_ExternalFocus",
    "text": "External Focus & Differentiation",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الخارجي والتمايز"
      }
    ]
  },
  {
    "key": "txt_StrategicOrientationShift",
    "text": "Strategic Orientation Trajectory",
    "translations": [
      {
        "language": "AR",
        "text": "مسار التوجه الاستراتيجي"
      }
    ]
  },
  {
    "key": "txt_IncreasingInternal",
    "text": "Targeting Higher Internal Pull",
    "translations": [
      {
        "language": "AR",
        "text": "استهداف جذب داخلي أعلى"
      }
    ]
  },
  {
    "key": "txt_ExpandingExternal",
    "text": "Targeting External Differentiation",
    "translations": [
      {
        "language": "AR",
        "text": "استهداف التمايز الخارجي"
      }
    ]
  },
  {
    "key": "txt_EquilibriumStable",
    "text": "Stable Structural Polarity",
    "translations": [
      {
        "language": "AR",
        "text": "قطبية هيكلية مستقرة"
      }
    ]
  },
  {
    "key": "txt_ControlMechanismAxis",
    "text": "Control Mechanism Architecture",
    "translations": [
      {
        "language": "AR",
        "text": "بنية آلية التحكم"
      }
    ]
  },
  {
    "key": "txt_FlexibilityDiscretion",
    "text": "Flexibility & Discretion",
    "translations": [
      {
        "language": "AR",
        "text": "المرونة وحرية التصرف"
      }
    ]
  },
  {
    "key": "txt_StabilityControl",
    "text": "Stability & Control",
    "translations": [
      {
        "language": "AR",
        "text": "الاستقرار والضبط"
      }
    ]
  },
  {
    "key": "txt_StrategicControlShift",
    "text": "Strategic Agility Trajectory",
    "translations": [
      {
        "language": "AR",
        "text": "مسار الرشاقة الاستراتيجية"
      }
    ]
  },
  {
    "key": "txt_IncreasingFlexibility",
    "text": "Expanding Discretionary Agility",
    "translations": [
      {
        "language": "AR",
        "text": "توسيع الرشاقة التقديرية"
      }
    ]
  },
  {
    "key": "txt_ExpandingControls",
    "text": "Targeting Structured Controls",
    "translations": [
      {
        "language": "AR",
        "text": "استهداف ضوابط منظمة"
      }
    ]
  },
  {
    "key": "txt_ClusterConcentrationCore",
    "text": "Archetype Layer Concentration Mapping",
    "translations": [
      {
        "language": "AR",
        "text": "تخطيط تركيز طبقة النموذج الأصلي"
      }
    ]
  },
  {
    "key": "txt_CoreDominance",
    "text": "Core Dominance",
    "translations": [
      {
        "language": "AR",
        "text": "الهيمنة الأساسية"
      }
    ]
  },
  {
    "key": "txt_Factors",
    "text": "Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "المحركات"
      }
    ]
  },
  {
    "key": "txt_DriverTransformationSuite",
    "text": "Granular Assessment Driver Vectors Overlay Suite",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة تراكب متجهات محرك التقييم الدقيقة"
      }
    ]
  },
  {
    "key": "txt_DriverSuiteSubtext",
    "text": "Detailed diagnostic assessment mapping auto-scaling boundaries and transformational volatility per cultural driver layer.",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم تشخيصي مفصل يوضح حدود التوسع التلقائي والتقلب التحويلي لكل طبقة محرك ثقافي."
      }
    ]
  },
  {
    "key": "txt_RadarOverlay",
    "text": "Radar Vectors",
    "translations": [
      {
        "language": "AR",
        "text": "متجهات الرادار"
      }
    ]
  },
  {
    "key": "txt_AccountingGrid",
    "text": "Delta Arrays",
    "translations": [
      {
        "language": "AR",
        "text": "مصفوفات الفروقات"
      }
    ]
  },
  {
    "key": "txt_QuadrantDeltaAccounting",
    "text": "Quadrant Delta Target Accounting",
    "translations": [
      {
        "language": "AR",
        "text": "حساب أهداف فروقات الأرباع"
      }
    ]
  },
  {
    "key": "txt_CumulativeElasticityIndex",
    "text": "Cumulative Elasticity Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر المرونة التراكمي"
      }
    ]
  },
  {
    "key": "txt_CriticalElasticity",
    "text": "High Transformation Elasticity",
    "translations": [
      {
        "language": "AR",
        "text": "مرونة تحول عالية"
      }
    ]
  },
  {
    "key": "txt_ModerateAdaptation",
    "text": "Moderate Adaptation",
    "translations": [
      {
        "language": "AR",
        "text": "تكيف معتدل"
      }
    ]
  },
  {
    "key": "txt_OperationalAnchor",
    "text": "Highly Stable Anchor",
    "translations": [
      {
        "language": "AR",
        "text": "مرتكز عالي الاستقرار"
      }
    ]
  },
  {
    "key": "txt_ClanTitle",
    "text": "Clan Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الجماعة"
      }
    ]
  },
  {
    "key": "txt_ClanTagline",
    "text": "A supportive workplace built on trust, teamwork and belonging.",
    "translations": [
      {
        "language": "AR",
        "text": "بيئة عمل داعمة تقوم على الثقة والعمل الجماعي والشعور بالانتماء."
      }
    ]
  },
  {
    "key": "txt_ClanDesc",
    "text": "Clan culture is an internally focused, flexible culture that emphasizes relationships, collaboration, employee development, and shared ownership. Leaders serve as mentors, facilitators, and coaches, fostering an environment built on loyalty, trust, and shared values that strengthen the organization.",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الجماعة ثقافة مرنة ذات توجه داخلي، تُعنى بالعلاقات والتعاون وتطوير الموظفين وتقاسم المسؤولية. ويؤدي القادة فيها أدوار الإرشاد والتيسير والتوجيه لتطوير الأداء، بما يهيّئ بيئة قائمة على الولاء والثقة والقيم المشتركة التي تعزّز تماسك المنظمة."
      }
    ]
  },
  {
    "key": "txt_AdhocracyTitle",
    "text": "Adhocracy Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الإبداع"
      }
    ]
  },
  {
    "key": "txt_AdhocracyTagline",
    "text": "An adaptable workplace that explores ideas and new opportunities.",
    "translations": [
      {
        "language": "AR",
        "text": "بيئة عمل مرنة تستكشف الأفكار والفرص الجديدة."
      }
    ]
  },
  {
    "key": "txt_AdhocracyDesc",
    "text": "Adhocracy culture is an externally focused, flexible culture that prioritizes external engagement and innovation. It encourages entrepreneurship, experimentation, and swift adaptation to change. This type of culture values initiative and discovery, empowering individuals to seek and capitalize on emerging opportunities actively.",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الإبداع ثقافة مرنة ذات توجه خارجي، تعطي الأولوية للتفاعل مع البيئة الخارجية والابتكار. وتشجّع ريادة الأعمال والتجريب وسرعة التكيّف مع التغيير، وتقدّر المبادرة والاستكشاف، وتمكّن الأفراد من البحث عن الفرص الناشئة واغتنامها."
      }
    ]
  },
  {
    "key": "txt_MarketTitle",
    "text": "Market Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة السوق"
      }
    ]
  },
  {
    "key": "txt_MarketTagline",
    "text": "A results-focused workplace that emphasizes targets and competitive success.",
    "translations": [
      {
        "language": "AR",
        "text": "بيئة عمل تركز على النتائج وتحقيق الأهداف والنجاح التنافسي."
      }
    ]
  },
  {
    "key": "txt_MarketDesc",
    "text": "Market culture is an externally focused, stable, and control-oriented orientation, which emphasizes competitiveness, goal achievement, and tangible results. This organizational style functions similarly to a marketplace, emphasizing transaction efficiency, market share, and measurable results. Leaders in this culture are goal-driven and results-focused, promoting a production-oriented environment that supports achievement and accountability.",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة السوق ثقافة ذات توجه خارجي، تركّز على الاستقرار والضبط، وتؤكد التنافسية وتحقيق الأهداف والنتائج الملموسة. ويعمل هذا النمط التنظيمي بمنطق السوق، مع التركيز على كفاءة المعاملات والحصة السوقية والنتائج القابلة للقياس. ويوجّه القادة جهودهم نحو تحقيق الأهداف والنتائج، ويرسّخون بيئة تُعنى بالإنتاج وتدعم الإنجاز والمساءلة."
      }
    ]
  },
  {
    "key": "txt_HierarchyTitle",
    "text": "Hierarchy Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الهرمية"
      }
    ]
  },
  {
    "key": "txt_HierarchyTagline",
    "text": "A structured workplace that values clear processes and dependable operations.",
    "translations": [
      {
        "language": "AR",
        "text": "بيئة عمل منظمة تقدر وضوح الإجراءات وموثوقية العمليات."
      }
    ]
  },
  {
    "key": "txt_HierarchyDesc",
    "text": "The Hierarchy culture is an internally focused, stable, and control-oriented orientation built on formalized structure, standardized procedures, and well-defined lines of authority. This approach prioritizes efficiency, reliability, and consistency, allowing organizations to function smoothly and predictably. Leaders play a vital role as coordinators and organizers, fostering an environment where processes are streamlined and operations run effectively.",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الهرمية ثقافة ذات توجه داخلي، تركّز على الاستقرار والضبط، وتقوم على هياكل رسمية وإجراءات موحّدة وتسلسل واضح للصلاحيات. وتعطي الأولوية للكفاءة والموثوقية والاتساق، بما يتيح للمنظمة العمل بسلاسة وبصورة يمكن توقّعها. ويؤدي القادة دورًا أساسيًا في التنسيق والتنظيم، وتهيئة بيئة تُبسَّط فيها الإجراءات وتُدار العمليات بفاعلية."
      }
    ]
  },
  {
    "key": "txt_StyleMentoring",
    "text": "Mentoring",
    "translations": [
      {
        "language": "AR",
        "text": "الإرشاد والتوجيه"
      }
    ]
  },
  {
    "key": "txt_StyleFacilitating",
    "text": "Facilitating collaboration",
    "translations": [
      {
        "language": "AR",
        "text": "تيسير التعاون"
      }
    ]
  },
  {
    "key": "txt_StyleNurturing",
    "text": "Supporting people",
    "translations": [
      {
        "language": "AR",
        "text": "دعم الأفراد"
      }
    ]
  },
  {
    "key": "txt_StyleInnovating",
    "text": "Innovating",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      }
    ]
  },
  {
    "key": "txt_StyleEntrepreneurial",
    "text": "Taking entrepreneurial initiative",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة الريادية"
      }
    ]
  },
  {
    "key": "txt_StyleVisionary",
    "text": "Setting a future vision",
    "translations": [
      {
        "language": "AR",
        "text": "رسم رؤية مستقبلية"
      }
    ]
  },
  {
    "key": "txt_StyleHardDriving",
    "text": "Driving target achievement",
    "translations": [
      {
        "language": "AR",
        "text": "الدفع نحو تحقيق الأهداف"
      }
    ]
  },
  {
    "key": "txt_StyleCompetitor",
    "text": "Leading competitively",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة بروح تنافسية"
      }
    ]
  },
  {
    "key": "txt_StyleProducing",
    "text": "Delivering results",
    "translations": [
      {
        "language": "AR",
        "text": "تحقيق النتائج"
      }
    ]
  },
  {
    "key": "txt_StyleCoordinating",
    "text": "Coordinating work",
    "translations": [
      {
        "language": "AR",
        "text": "تنسيق العمل"
      }
    ]
  },
  {
    "key": "txt_StyleMonitoring",
    "text": "Monitoring performance and processes",
    "translations": [
      {
        "language": "AR",
        "text": "متابعة الأداء والعمليات"
      }
    ]
  },
  {
    "key": "txt_StyleOrganizing",
    "text": "Organizing work",
    "translations": [
      {
        "language": "AR",
        "text": "تنظيم العمل"
      }
    ]
  },
  {
    "key": "txt_Statements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txt_Future",
    "text": "Future",
    "translations": [
      {
        "language": "AR",
        "text": "المستقبل"
      }
    ]
  },
  {
    "key": "txt_closed_730",
    "text": "Closed",
    "translations": [
      {
        "language": "AR",
        "text": "مغلق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfTitle",
    "text": "The Competing Values Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم ثقافة القيم التنافسية"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة"
      }
    ]
  },
  {
    "key": "txtGap",
    "text": "Gap",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة"
      }
    ]
  },
  {
    "key": "txtStatementAnalysis",
    "text": "Statement Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل العبارات"
      }
    ]
  },
  {
    "key": "txt_survey_mode",
    "text": "Assessment Mode",
    "translations": [
      {
        "language": "AR",
        "text": "نمط التقييم"
      },
      {
        "language": "FR",
        "text": "Mode d'enquête"
      }
    ]
  },
  {
    "key": "txt_survey_mode_one_shot",
    "text": "Combined",
    "translations": [
      {
        "language": "AR",
        "text": "مدمج"
      },
      {
        "language": "FR",
        "text": "Combiné"
      }
    ]
  },
  {
    "key": "txt_survey_mode_two_batch",
    "text": "Sequential",
    "translations": [
      {
        "language": "AR",
        "text": "متسلسل"
      },
      {
        "language": "FR",
        "text": "Séquentiel"
      }
    ]
  },
  {
    "key": "txt_survey_mode_one_shot_desc",
    "text": "Respondents allocate Now and Preferred points on the same screen.",
    "translations": [
      {
        "language": "AR",
        "text": "يوزّع المشاركون نقاط الحالة الحالية والمفضّلة في الشاشة نفسها."
      },
      {
        "language": "FR",
        "text": "Les répondants répartissent les points Actuel et Souhaité sur le même écran."
      }
    ]
  },
  {
    "key": "txt_survey_mode_two_batch_desc",
    "text": "Respondents allocate all Now points first, then start a second pass for Preferred points.",
    "translations": [
      {
        "language": "AR",
        "text": "يوزّع المشاركون نقاط الحالة الحالية أولاً، ثم يبدأون مرحلة ثانية لنقاط الحالة المفضّلة."
      },
      {
        "language": "FR",
        "text": "Les répondants répartissent d'abord tous les points Actuel, puis commencent une seconde étape pour les points Souhaité."
      }
    ]
  },
  {
    "key": "txt_survey_mode_locked",
    "text": "The assessment mode cannot be changed after invitations have been sent.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن تغيير نمط التقييم بعد إرسال الدعوات."
      },
      {
        "language": "FR",
        "text": "Le mode d'enquête ne peut plus être modifié après l'envoi des invitations."
      }
    ]
  },
  {
    "key": "txt_cvf_total_allocated",
    "text": "Total Allocated Points",
    "translations": [
      {
        "language": "AR",
        "text": "مجموع النقاط الموزّعة"
      },
      {
        "language": "FR",
        "text": "Total des points attribués"
      }
    ]
  },
  {
    "key": "txt_cvf_must_total_100",
    "text": "Each state column must sum to precisely 100 points",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع كل عمود 100 نقطة بالتحديد"
      },
      {
        "language": "FR",
        "text": "Chaque colonne doit totaliser exactement 100 points"
      }
    ]
  },
  {
    "key": "txt_cvf_valid",
    "text": "Valid (100)",
    "translations": [
      {
        "language": "AR",
        "text": "صحيح (100)"
      },
      {
        "language": "FR",
        "text": "Valide (100)"
      }
    ]
  },
  {
    "key": "txt_cvf_invalid",
    "text": "Invalid",
    "translations": [
      {
        "language": "AR",
        "text": "غير صحيح"
      },
      {
        "language": "FR",
        "text": "Non valide"
      }
    ]
  },
  {
    "key": "txt_cvf_pass_now",
    "text": "Your culture today",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافتكم الحالية"
      },
      {
        "language": "FR",
        "text": "Votre culture actuelle"
      }
    ]
  },
  {
    "key": "txt_cvf_pass_future",
    "text": "Your preferred culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة المفضّلة"
      },
      {
        "language": "FR",
        "text": "Votre culture souhaitée"
      }
    ]
  },
  {
    "key": "txt_cvf_batch_intro_title",
    "text": "Part one complete",
    "translations": [
      {
        "language": "AR",
        "text": "اكتمل الجزء الأول"
      },
      {
        "language": "FR",
        "text": "Première partie terminée"
      }
    ]
  },
  {
    "key": "txt_cvf_batch_intro_body",
    "text": "You have described your culture as it is today. Next, allocate the same 100 points to the culture you would prefer.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد وصفتم ثقافة مؤسستكم كما هي اليوم. التالي، وزّعوا 100 نقطة على الثقافة التي تفضّلونها."
      },
      {
        "language": "FR",
        "text": "Vous avez décrit votre culture telle qu'elle est aujourd'hui. Répartissez maintenant les mêmes 100 points sur la culture que vous souhaiteriez."
      }
    ]
  },
  {
    "key": "txt_cvf_batch_intro_start",
    "text": "Start part two",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الجزء الثاني"
      },
      {
        "language": "FR",
        "text": "Commencer la deuxième partie"
      }
    ]
  },
  {
    "key": "txt_cvf_now_intro_title",
    "text": "Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الحالية"
      },
      {
        "language": "FR",
        "text": "Culture actuelle"
      }
    ]
  },
  {
    "key": "txt_cvf_now_intro_body",
    "text": "In this section, please describe your culture as it is experienced today.",
    "translations": [
      {
        "language": "AR",
        "text": "في هذا القسم، يُرجى وصف ثقافة مؤسستكم كما هي عليه اليوم."
      },
      {
        "language": "FR",
        "text": "Dans cette section, veuillez décrire votre culture telle qu'elle est vécue aujourd'hui."
      }
    ]
  },
  {
    "key": "txt_cvf_now_intro_start",
    "text": "Start part one",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الجزء الأول"
      },
      {
        "language": "FR",
        "text": "Commencer la première partie"
      }
    ]
  },
  {
    "key": "txt_cvf_error_now_total_100",
    "text": "Your Now allocation must total exactly 100 points.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع نقاط الحالة الحالية 100 نقطة بالتحديد."
      },
      {
        "language": "FR",
        "text": "La répartition Actuel doit totaliser exactement 100 points."
      }
    ]
  },
  {
    "key": "txt_cvf_error_future_total_100",
    "text": "Your Preferred allocation must total exactly 100 points.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع نقاط الحالة المفضّلة 100 نقطة بالتحديد."
      },
      {
        "language": "FR",
        "text": "La répartition Souhaité doit totaliser exactement 100 points."
      }
    ]
  },
  {
    "key": "txt_cvf_error_both_total_100",
    "text": "Both the Now and Preferred allocations must total exactly 100 points.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع نقاط الحالة الحالية والمفضّلة 100 نقطة لكل منهما."
      },
      {
        "language": "FR",
        "text": "Les répartitions Actuel et Souhaité doivent chacune totaliser exactement 100 points."
      }
    ]
  },
  {
    "key": "txt_cvf_allocated_exactly_100",
    "text": "Allocated Exactly 100 Points",
    "translations": [
      {
        "language": "AR",
        "text": "تم توزيع 100 نقطة بالتحديد"
      },
      {
        "language": "FR",
        "text": "Exactement 100 points attribués"
      }
    ]
  },
  {
    "key": "txt_cvf_part",
    "text": "Part",
    "translations": [
      {
        "language": "AR",
        "text": "الجزء"
      },
      {
        "language": "FR",
        "text": "Partie"
      }
    ]
  },
  {
    "key": "txt_OverviewAnalysis",
    "text": "Overview Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل النظرة العامة"
      },
      {
        "language": "FR",
        "text": "Analyse générale"
      }
    ]
  },
  {
    "key": "txt_DominantNow",
    "text": "Dominant Now",
    "translations": [
      {
        "language": "AR",
        "text": "السائد حالياً"
      },
      {
        "language": "FR",
        "text": "Dominant actuel"
      }
    ]
  },
  {
    "key": "txt_Alignment",
    "text": "Alignment",
    "translations": [
      {
        "language": "AR",
        "text": "التوافق"
      },
      {
        "language": "FR",
        "text": "Alignement"
      }
    ]
  },
  {
    "key": "txt_OverallCultureScore",
    "text": "Overall Culture Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة العامة للثقافة"
      },
      {
        "language": "FR",
        "text": "Score culturel global"
      }
    ]
  },
  {
    "key": "txt_DateClose_105",
    "text": "Date Closed",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإغلاق"
      },
      {
        "language": "FR",
        "text": "Date de clôture"
      }
    ]
  },
  {
    "key": "txt_WellAligned",
    "text": "Well aligned",
    "translations": [
      {
        "language": "AR",
        "text": "توافق جيد"
      },
      {
        "language": "FR",
        "text": "Bien aligné"
      }
    ]
  },
  {
    "key": "txt_ModeratelyAligned",
    "text": "Moderately aligned",
    "translations": [
      {
        "language": "AR",
        "text": "توافق متوسط"
      },
      {
        "language": "FR",
        "text": "Modérément aligné"
      }
    ]
  },
  {
    "key": "txt_Misaligned",
    "text": "Misaligned",
    "translations": [
      {
        "language": "AR",
        "text": "غير متوافق"
      },
      {
        "language": "FR",
        "text": "Mal aligné"
      }
    ]
  },
  {
    "key": "txt_LargestGap",
    "text": "Largest Gap",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة الأكبر"
      },
      {
        "language": "FR",
        "text": "Plus grand écart"
      }
    ]
  },
  {
    "key": "txt_RespondentsOf",
    "text": "respondents completed of",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيباً أكملوا التقييم من أصل"
      },
      {
        "language": "FR",
        "text": "répondants ont terminé sur"
      }
    ]
  },
  {
    "key": "txt_Invited",
    "text": "invited",
    "translations": [
      {
        "language": "AR",
        "text": "مدعواً"
      },
      {
        "language": "FR",
        "text": "invités"
      }
    ]
  },
  {
    "key": "txt_EmployeesWantLess",
    "text": "Employees want less",
    "translations": [
      {
        "language": "AR",
        "text": "يرغب الموظفون في تقليل"
      },
      {
        "language": "FR",
        "text": "Les employés souhaitent moins de"
      }
    ]
  },
  {
    "key": "txt_EmployeesWantMore",
    "text": "Employees want more",
    "translations": [
      {
        "language": "AR",
        "text": "يرغب الموظفون في زيادة"
      },
      {
        "language": "FR",
        "text": "Les employés souhaitent plus de"
      }
    ]
  },
  {
    "key": "txt_ResponseRateTooltip",
    "text": "Share of invited respondents who completed the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة المدعوين الذين أكملوا التقييم."
      },
      {
        "language": "FR",
        "text": "Part des personnes invitées ayant complété l'enquête."
      }
    ]
  },
  {
    "key": "txt_LargestGapTooltip",
    "text": "The archetype with the largest difference between current and preferred scores.",
    "translations": [
      {
        "language": "AR",
        "text": "النمط ذو الفرق الأكبر بين الدرجات الحالية والمرغوبة."
      },
      {
        "language": "FR",
        "text": "L'archétype présentant le plus grand écart entre les scores actuels et souhaités."
      }
    ]
  },
  {
    "key": "txt_CurrentPreferredDominantCulture",
    "text": "Current & Preferred Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الحالية والمرغوبة"
      },
      {
        "language": "FR",
        "text": "Culture actuelle et préférée"
      }
    ]
  },
  {
    "key": "txt_CurrentPreferredDominantCultureSub",
    "text": "The archetypes carrying the highest weight today and in the preferred future.",
    "translations": [
      {
        "language": "AR",
        "text": "الأنماط ذات الوزن الأعلى اليوم وفي المستقبل المرغوب."
      },
      {
        "language": "FR",
        "text": "Les archétypes ayant le poids le plus élevé aujourd'hui et dans le futur souhaité."
      }
    ]
  },
  {
    "key": "txt_WhatItMeans",
    "text": "What it means",
    "translations": [
      {
        "language": "AR",
        "text": "ماذا يعني ذلك"
      },
      {
        "language": "FR",
        "text": "Ce que cela signifie"
      }
    ]
  },
  {
    "key": "txt_Current",
    "text": "Current",
    "translations": [
      {
        "language": "AR",
        "text": "الحالية"
      },
      {
        "language": "FR",
        "text": "Actuel"
      }
    ]
  },
  {
    "key": "txt_Pts",
    "text": "pts",
    "translations": [
      {
        "language": "AR",
        "text": "نقطة"
      },
      {
        "language": "FR",
        "text": "pts"
      }
    ]
  },
  {
    "key": "txt_OverallCultureProfileGap",
    "text": "Overall Culture Profile & Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "الملف الثقافي العام وتحليل الفجوات"
      },
      {
        "language": "FR",
        "text": "Profil culturel global et analyse des écarts"
      }
    ]
  },
  {
    "key": "txt_OverallCultureProfileGapSub",
    "text": "Current vs Preferred scores across the four CVF archetypes, with per-quadrant gap.",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الحالية مقابل المرغوبة عبر الأنماط الأربعة، مع فجوة كل ربع."
      },
      {
        "language": "FR",
        "text": "Scores actuels et souhaités pour les quatre archétypes CVF, avec l'écart par quadrant."
      }
    ]
  },
  {
    "key": "txt_CultureGaps",
    "text": "Culture Gaps",
    "translations": [
      {
        "language": "AR",
        "text": "فجوات الثقافة"
      },
      {
        "language": "FR",
        "text": "Écarts culturels"
      }
    ]
  },
  {
    "key": "txt_PreferredMinusCurrent",
    "text": "Preferred − Current",
    "translations": [
      {
        "language": "AR",
        "text": "المرغوبة − الحالية"
      },
      {
        "language": "FR",
        "text": "Souhaité − Actuel"
      }
    ]
  },
  {
    "key": "txt_Radar",
    "text": "Radar",
    "translations": [
      {
        "language": "AR",
        "text": "رادار"
      },
      {
        "language": "FR",
        "text": "Radar"
      }
    ]
  },
  {
    "key": "txt_Bar",
    "text": "Bar",
    "translations": [
      {
        "language": "AR",
        "text": "أعمدة"
      },
      {
        "language": "FR",
        "text": "Barres"
      }
    ]
  },
  {
    "key": "txt_ConnectingRadarPolarity",
    "text": "Connecting the Radar Profile to the Polarity Axes",
    "translations": [
      {
        "language": "AR",
        "text": "ربط الملف الراداري بمحاور الاستقطاب"
      },
      {
        "language": "FR",
        "text": "Relier le profil radar aux axes de polarité"
      }
    ]
  },
  {
    "key": "txt_ConnectingRadarPolaritySub",
    "text": "The four archetype scores re-projected onto the two axes, with the companion Culture Stability index.",
    "translations": [
      {
        "language": "AR",
        "text": "درجات الأنماط الأربعة معاد إسقاطها على المحورين، مع مؤشر استقرار الثقافة المصاحب."
      },
      {
        "language": "FR",
        "text": "Les scores des quatre archétypes reprojetés sur les deux axes, avec l'indice de stabilité culturelle."
      }
    ]
  },
  {
    "key": "txt_PolarityAxis",
    "text": "Polarity Axis",
    "translations": [
      {
        "language": "AR",
        "text": "محور الاستقطاب"
      },
      {
        "language": "FR",
        "text": "Axe de polarité"
      }
    ]
  },
  {
    "key": "txt_GapAnalysis",
    "text": "Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الفجوات الثقافية"
      },
      {
        "language": "FR",
        "text": "Analyse des écarts"
      }
    ]
  },
  {
    "key": "txt_Collaborate",
    "text": "Collaborate",
    "translations": [
      {
        "language": "AR",
        "text": "التعاون"
      },
      {
        "language": "FR",
        "text": "Collaborer"
      }
    ]
  },
  {
    "key": "txt_Create",
    "text": "Create",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      },
      {
        "language": "FR",
        "text": "Créer"
      }
    ]
  },
  {
    "key": "txt_Control",
    "text": "Control",
    "translations": [
      {
        "language": "AR",
        "text": "الضبط"
      },
      {
        "language": "FR",
        "text": "Contrôler"
      }
    ]
  },
  {
    "key": "txt_Compete",
    "text": "Compete",
    "translations": [
      {
        "language": "AR",
        "text": "التنافس"
      },
      {
        "language": "FR",
        "text": "Rivaliser"
      }
    ]
  },
  {
    "key": "txt_External",
    "text": "External",
    "translations": [
      {
        "language": "AR",
        "text": "خارجي"
      },
      {
        "language": "FR",
        "text": "Externe"
      }
    ]
  },
  {
    "key": "txt_Flexible",
    "text": "Flexible",
    "translations": [
      {
        "language": "AR",
        "text": "مرن"
      },
      {
        "language": "FR",
        "text": "Flexible"
      }
    ]
  },
  {
    "key": "txt_CultureStability",
    "text": "Culture Stability",
    "translations": [
      {
        "language": "AR",
        "text": "استقرار الثقافة"
      },
      {
        "language": "FR",
        "text": "Stabilité culturelle"
      }
    ]
  },
  {
    "key": "txt_CultureStabilitySub",
    "text": "How much change employees are asking for in each archetype.",
    "translations": [
      {
        "language": "AR",
        "text": "مقدار التغيير الذي يطلبه الموظفون في كل نمط."
      },
      {
        "language": "FR",
        "text": "L'ampleur du changement demandé par les employés pour chaque archétype."
      }
    ]
  },
  {
    "key": "txt_CultureStabilityIndex",
    "text": "Culture Stability Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر استقرار الثقافة"
      },
      {
        "language": "FR",
        "text": "Indice de stabilité culturelle"
      }
    ]
  },
  {
    "key": "txt_PointsChangeTotal",
    "text": "Total absolute gap: {{0}} points across the four culture types. Higher alignment scores mean the current and preferred profiles are more similar.",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي الفجوة المطلقة: {{0}} نقطة عبر أنماط الثقافة الأربعة. كلما ارتفعت درجة التوافق كان الوضع الحالي والمرغوب أكثر تشابهاً."
      },
      {
        "language": "FR",
        "text": "Écart absolu total : {{0}} points sur les quatre types de culture. Plus le score d'alignement est élevé, plus les profils actuel et souhaité sont similaires."
      }
    ]
  },
  {
    "key": "txt_PointsOfChangeWanted",
    "text": "Points of change wanted",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط التغيير المطلوبة"
      },
      {
        "language": "FR",
        "text": "Points de changement demandés"
      }
    ]
  },
  {
    "key": "txt_ScaleOfChange",
    "text": "Scale of change",
    "translations": [
      {
        "language": "AR",
        "text": "حجم التغيير"
      },
      {
        "language": "FR",
        "text": "Ampleur du changement"
      }
    ]
  },
  {
    "key": "txt_Minor",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض"
      },
      {
        "language": "FR",
        "text": "Faible"
      }
    ]
  },
  {
    "key": "txt_Moderate",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط"
      },
      {
        "language": "FR",
        "text": "Modéré"
      }
    ]
  },
  {
    "key": "txt_Significant",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع"
      },
      {
        "language": "FR",
        "text": "Élevé"
      }
    ]
  },
  {
    "key": "txt_StabilityScaleHint",
    "text": "Gap categories: below 4 points = low; 4–10 points = moderate; above 10 points = high.",
    "translations": [
      {
        "language": "AR",
        "text": "فئات الفجوة: أقل من 4 نقاط = منخفضة؛ من 4 إلى 10 نقاط = متوسطة؛ أكثر من 10 نقاط = مرتفعة."
      },
      {
        "language": "FR",
        "text": "Catégories d'écart : moins de 4 points = faible ; 4–10 points = modéré ; plus de 10 points = élevé."
      }
    ]
  },
  {
    "key": "txt_StabilitySignHint",
    "text": "Positive values indicate a preference for more emphasis; negative values indicate a preference for less.",
    "translations": [
      {
        "language": "AR",
        "text": "القيم الموجبة تشير إلى الرغبة في مزيد من التركيز؛ والقيم السالبة تشير إلى الرغبة في تركيز أقل."
      },
      {
        "language": "FR",
        "text": "Les valeurs positives indiquent une préférence pour plus d'accent ; les valeurs négatives pour moins."
      }
    ]
  },
  {
    "key": "txt_GroupComparison",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة"
      },
      {
        "language": "FR",
        "text": "Comparaison"
      }
    ]
  },
  {
    "key": "txt_GroupComparisonSub",
    "text": "Compare profiles across breakouts.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن الملفات الثقافية عبر الفئات."
      },
      {
        "language": "FR",
        "text": "Comparez les profils par segment."
      }
    ]
  },
  {
    "key": "txt_Breakout",
    "text": "Breakout",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      },
      {
        "language": "FR",
        "text": "Segment"
      }
    ]
  },
  {
    "key": "txt_Group",
    "text": "Group",
    "translations": [
      {
        "language": "AR",
        "text": "المجموعة"
      },
      {
        "language": "FR",
        "text": "Groupe"
      }
    ]
  },
  {
    "key": "txt_Gap",
    "text": "Gap",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة"
      },
      {
        "language": "FR",
        "text": "Écart"
      }
    ]
  },
  {
    "key": "txt_Dominant",
    "text": "Dominant",
    "translations": [
      {
        "language": "AR",
        "text": "السائد"
      },
      {
        "language": "FR",
        "text": "Dominant"
      }
    ]
  },
  {
    "key": "txt_ConfidentialityHidden",
    "text": "Results hidden to protect respondent confidentiality (n < 3).",
    "translations": [
      {
        "language": "AR",
        "text": "أُخفيت النتائج لحماية سرية المستجيبين (أقل من 3)."
      },
      {
        "language": "FR",
        "text": "Résultats masqués pour protéger la confidentialité des répondants (n < 3)."
      }
    ]
  },
  {
    "key": "txt_NoGroupData",
    "text": "No group data available for this criteria.",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد بيانات مجموعات متاحة لهذا المعيار."
      },
      {
        "language": "FR",
        "text": "Aucune donnée de groupe disponible pour ce critère."
      }
    ]
  },
  {
    "key": "txt_DimensionsTabTitle",
    "text": "Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "الأبعاد"
      },
      {
        "language": "FR",
        "text": "Dimensions"
      }
    ]
  },
  {
    "key": "txt_DimensionsTabDesc",
    "text": "The <b>Dimensions</b> section presents Culture Assessment results across the six OCAI assessment dimensions. Select a dimension to view its cultural shift, current and preferred cultural archetypes, and detailed results.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض قسم <b>الأبعاد</b> نتائج تقييم الثقافة عبر أبعاد التقييم الستة في أداة تقييم الثقافة التنظيمية (OCAI). اختر بُعدًا لعرض التحول الثقافي فيه، والأنماط الثقافية الحالية والمرغوبة، والنتائج التفصيلية."
      },
      {
        "language": "FR",
        "text": "Analysez la répartition des points par quadrant pour chaque dimension, entre l'état actuel et futur."
      }
    ]
  },
  {
    "key": "txt_DimensionsTabHint",
    "text": "Each dimension is listed as an expandable card showing its Shifting status and archetype transition. Expand to see the Current vs Preferred radar, per-archetype scores and the Reading summary.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعرض كل بُعد كبطاقة قابلة للتوسيع تُظهر حالة التحول وانتقال النمط. وسّع البطاقة لعرض رادار الحالي مقابل المرغوب ودرجات كل نمط وملخص القراءة."
      },
      {
        "language": "FR",
        "text": "Chaque dimension apparaît comme une carte dépliable montrant son statut d'évolution et la transition d'archétype. Dépliez pour voir le radar Actuel vs Souhaité, les scores par archétype et la synthèse."
      }
    ]
  },
  {
    "key": "txt_Shifting",
    "text": "Shifting",
    "translations": [
      {
        "language": "AR",
        "text": "في تحول"
      },
      {
        "language": "FR",
        "text": "En évolution"
      }
    ]
  },
  {
    "key": "txt_Stable",
    "text": "Stable",
    "translations": [
      {
        "language": "AR",
        "text": "مستقر"
      },
      {
        "language": "FR",
        "text": "Stable"
      }
    ]
  },
  {
    "key": "txt_PerArchetypeScores",
    "text": "Scores",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات"
      },
      {
        "language": "FR",
        "text": "Scores"
      }
    ]
  },
  {
    "key": "txt_Change",
    "text": "Change",
    "translations": [
      {
        "language": "AR",
        "text": "التغيير"
      },
      {
        "language": "FR",
        "text": "Évolution"
      }
    ]
  },
  {
    "key": "txt_Reading",
    "text": "Culture interpretation",
    "translations": [
      {
        "language": "AR",
        "text": "دلالات النتائج الثقافية"
      },
      {
        "language": "FR",
        "text": "Lecture"
      }
    ]
  },
  {
    "key": "txt_DimReadingShifting",
    "text": "{0} is currently the most prominent culture in this dimension, but respondents would prefer {1} to receive the greatest emphasis.",
    "translations": [
      {
        "language": "AR",
        "text": "تُعدّ {0} النمط الأبرز حالياً في هذا البعد، إلا أن المشاركين يرغبون في أن تحظى {1} بالتركيز الأكبر."
      },
      {
        "language": "FR",
        "text": "Actuellement dominé par {0} ; les employés préfèrent une évolution vers {1}."
      }
    ]
  },
  {
    "key": "txt_DimReadingStable",
    "text": "{0} receives the greatest emphasis in both the current and preferred culture for this dimension.",
    "translations": [
      {
        "language": "AR",
        "text": "تحظى {0} بالتركيز الأكبر في هذا البعد، سواء في الثقافة الحالية أو الثقافة المرغوبة."
      },
      {
        "language": "FR",
        "text": "Dominé par {0} aujourd'hui comme dans le futur souhaité."
      }
    ]
  },
  {
    "key": "txt_DimReadingLargest",
    "text": "Within this overall picture, respondents would most like to strengthen {0} (+{1} points) and reduce the emphasis on {2} ({3} points).",
    "translations": [
      {
        "language": "AR",
        "text": "وفي إطار هذه الصورة العامة، تتمثل أبرز رغبات المشاركين في تعزيز التركيز على {0} (+{1} نقطة) وتقليل التركيز على {2} ({3} نقطة)."
      },
      {
        "language": "FR",
        "text": "Plus forte hausse : {0} (+{1}) ; plus forte baisse : {2} ({3})."
      }
    ]
  },
  {
    "key": "txt_DimReadingTotal",
    "text": "Across all four culture types, the differences between the current and preferred scores add up to {0} points.",
    "translations": [
      {
        "language": "AR",
        "text": "وبالنظر إلى الأنماط الأربعة مجتمعة، يبلغ مجموع الفروق بين الدرجات الحالية والمرغوبة {0} نقطة."
      },
      {
        "language": "FR",
        "text": "Réallocation totale : {0} pts."
      }
    ]
  },
  {
    "key": "txt_DimReadingNoDifference",
    "text": "No difference between the current and preferred scores in this area.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد فرق بين درجات الثقافة الحالية والثقافة المرغوبة في هذا البعد."
      }
    ]
  },
  {
    "key": "txt_AiReadingsTitle",
    "text": "AI Readings",
    "translations": [
      {
        "language": "AR",
        "text": "قراءات الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": "Lectures IA"
      }
    ]
  },
  {
    "key": "txt_AiReadingsTabDesc",
    "text": "The <b>AI Readings</b> section provides a concise interpretation of the assessment results, highlighting key strengths, areas of attention, the largest cultural shift, alignment risks, dimension findings, and strategic implications.",
    "translations": [
      {
        "language": "AR",
        "text": "يقدم قسم <b>قراءات الذكاء الاصطناعي</b> تفسيرًا موجزًا لنتائج التقييم، بما يشمل نقاط القوة الرئيسية، ومجالات الاهتمام، وأكبر تحول ثقافي، ومخاطر المواءمة، ونتائج الأبعاد، والآثار الاستراتيجية."
      },
      {
        "language": "FR",
        "text": "Analyses narratives et priorités recommandées générées à partir de vos résultats CVF."
      }
    ]
  },
  {
    "key": "txt_AiReadingsSub",
    "text": "Narrative interpretations of the assessment and the ranked priority list derived from the gap analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تفسيرات سردية للتقييم وقائمة الأولويات المرتبة المستمدة من تحليل الفجوات."
      },
      {
        "language": "FR",
        "text": "Interprétations narratives de l'évaluation et liste de priorités classées issue de l'analyse des écarts."
      }
    ]
  },
  {
    "key": "txt_AiGeneratedReadings",
    "text": "AI-Generated Readings",
    "translations": [
      {
        "language": "AR",
        "text": "قراءات مولّدة بالذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": "Lectures générées par IA"
      }
    ]
  },
  {
    "key": "txt_CulturePrioritiesActions",
    "text": "Culture Priorities & Actions",
    "translations": [
      {
        "language": "AR",
        "text": "أولويات الثقافة والإجراءات"
      },
      {
        "language": "FR",
        "text": "Priorités culturelles et actions"
      }
    ]
  },
  {
    "key": "txt_CulturePrioritiesActionsSub",
    "text": "A single ordered list derived from the gap analysis, ranked by absolute gap magnitude.",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة واحدة مرتبة مستمدة من تحليل الفجوات، مصنفة حسب حجم الفجوة المطلق."
      },
      {
        "language": "FR",
        "text": "Une liste ordonnée unique issue de l'analyse des écarts, classée par ampleur absolue de l'écart."
      }
    ]
  },
  {
    "key": "txt_ExpectedBehaviors",
    "text": "Expected Behaviors",
    "translations": [
      {
        "language": "AR",
        "text": "السلوكيات المتوقعة"
      },
      {
        "language": "FR",
        "text": "Comportements attendus"
      }
    ]
  },
  {
    "key": "txt_LeadershipOrgAction",
    "text": "Leadership & Org Action",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات القيادة والمؤسسة"
      },
      {
        "language": "FR",
        "text": "Actions de la direction et de l'organisation"
      }
    ]
  },
  {
    "key": "txt_SuccessMeasure",
    "text": "Success Measure",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النجاح"
      },
      {
        "language": "FR",
        "text": "Indicateur de réussite"
      }
    ]
  },
  {
    "key": "txt_HighPriority",
    "text": "High priority",
    "translations": [
      {
        "language": "AR",
        "text": "أولوية عالية"
      },
      {
        "language": "FR",
        "text": "Priorité élevée"
      }
    ]
  },
  {
    "key": "txt_MediumPriority",
    "text": "Medium priority",
    "translations": [
      {
        "language": "AR",
        "text": "أولوية متوسطة"
      },
      {
        "language": "FR",
        "text": "Priorité moyenne"
      }
    ]
  },
  {
    "key": "txt_MonitorPriority",
    "text": "Monitor priority",
    "translations": [
      {
        "language": "AR",
        "text": "أولوية للمراقبة"
      },
      {
        "language": "FR",
        "text": "Priorité à surveiller"
      }
    ]
  },
  {
    "key": "txt_RecommendedPriorities",
    "text": "Recommended Priorities",
    "translations": [
      {
        "language": "AR",
        "text": "الأولويات الموصى بها"
      },
      {
        "language": "FR",
        "text": "Priorités recommandées"
      }
    ]
  },
  {
    "key": "txt_RecommendedPrioritiesSub",
    "text": "Ranked actions with the highest expected impact on closing the culture gap.",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات مرتبة حسب الأثر المتوقع الأكبر في سد الفجوة الثقافية."
      },
      {
        "language": "FR",
        "text": "Actions classées selon leur impact attendu sur la réduction de l'écart culturel."
      }
    ]
  },
  {
    "key": "txt_GeneratedByAi",
    "text": "Generated by AI",
    "translations": [
      {
        "language": "AR",
        "text": "مُنشأ بواسطة الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": "Généré par IA"
      }
    ]
  },
  {
    "key": "txt_GeneratedByTemplate",
    "text": "Auto-generated summary",
    "translations": [
      {
        "language": "AR",
        "text": "ملخص مُنشأ تلقائيًا"
      },
      {
        "language": "FR",
        "text": "Résumé généré automatiquement"
      }
    ]
  },
  {
    "key": "txt_AiGeneratedInterpretation",
    "text": "AI-Generated Interpretation",
    "translations": [
      {
        "language": "AR",
        "text": "تفسير مُنشأ بالذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": "Interprétation générée par IA"
      }
    ]
  },
  {
    "key": "txt_AiReadingsDisclaimer",
    "text": "AI insights should be reviewed alongside organizational context and leadership judgment.",
    "translations": [
      {
        "language": "AR",
        "text": "ينبغي مراجعة رؤى الذكاء الاصطناعي جنبًا إلى جنب مع السياق المؤسسي وتقدير القيادة."
      },
      {
        "language": "FR",
        "text": "Les analyses de l'IA doivent être examinées en tenant compte du contexte organisationnel et du jugement de la direction."
      }
    ]
  },
  {
    "key": "txt_High",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "عالٍ"
      },
      {
        "language": "FR",
        "text": "Élevé"
      }
    ]
  },
  {
    "key": "txt_Medium",
    "text": "Medium",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط"
      },
      {
        "language": "FR",
        "text": "Moyen"
      }
    ]
  },
  {
    "key": "txt_Monitor",
    "text": "Monitor",
    "translations": [
      {
        "language": "AR",
        "text": "مراقبة"
      },
      {
        "language": "FR",
        "text": "À surveiller"
      }
    ]
  },
  {
    "key": "txt_PreviewPendingBackend",
    "text": "Preview · pending backend",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة · بانتظار الخادم"
      },
      {
        "language": "FR",
        "text": "Aperçu · en attente du backend"
      }
    ]
  },
  {
    "key": "txt_ClanKeyOrientationFocus",
    "text": "Internal maintenance that prioritizes flexibility and care for individuals",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز البيئة الداخلية مع إعطاء الأولوية للمرونة والاهتمام بالأفراد"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanKeyOrientationStructure",
    "text": "Collaborative, inclusive, and informal teamwork",
    "translations": [
      {
        "language": "AR",
        "text": "عمل جماعي تعاوني يتيح المشاركة للجميع ولا يتقيّد كثيرًا بالأطر الرسمية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanKeyOrientationLeadership",
    "text": "Mentor, facilitator, coach, and team-builder",
    "translations": [
      {
        "language": "AR",
        "text": "الإرشاد، والتيسير، والتوجيه لتطوير الأداء، وبناء الفرق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanKeyOrientationValueDrivers",
    "text": "Commitment, communication, and employee development",
    "translations": [
      {
        "language": "AR",
        "text": "الالتزام، والتواصل، وتطوير الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanKeyCharacteristics",
    "text": "Coaching leadership; participative decisions; teamwork; knowledge-sharing; mentoring; consensus-building; and success measured through engagement, people development, and cohesion.",
    "translations": [
      {
        "language": "AR",
        "text": "قيادة تقوم على التوجيه لتطوير الأداء؛ ومشاركة في اتخاذ القرارات وعمل جماعي وتبادل للمعرفة وإرشاد مهني وبناء للتوافق. ويُقاس النجاح بالارتباط الوظيفي وتطوير الأفراد والتماسك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanConstraint1",
    "text": "Decision-making can be slow due to consensus-seeking",
    "translations": [
      {
        "language": "AR",
        "text": "قد يتباطأ اتخاذ القرار بسبب السعي إلى التوافق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanConstraint2",
    "text": "Risk of avoiding difficult performance conversations to preserve harmony",
    "translations": [
      {
        "language": "AR",
        "text": "احتمال تجنّب مناقشات الأداء الصعبة حفاظًا على الانسجام"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanConstraint3",
    "text": "May under-emphasize competitiveness, speed, or external market pressure",
    "translations": [
      {
        "language": "AR",
        "text": "قد لا تحظى التنافسية أو السرعة أو ضغوط السوق الخارجية بالاهتمام الكافي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanConstraint4",
    "text": "May promote resistance to external ideas",
    "translations": [
      {
        "language": "AR",
        "text": "قد تشجّع على مقاومة الأفكار القادمة من خارج المنظمة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyKeyOrientationFocus",
    "text": "External positioning with flexibility and adaptability",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز موقع المنظمة في بيئتها الخارجية مع المرونة والقدرة على التكيّف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyKeyOrientationStructure",
    "text": "Fluid, dynamic, and organic; minimal hierarchy",
    "translations": [
      {
        "language": "AR",
        "text": "مرن وديناميكي يتشكّل وفق احتياجات العمل، مع مستويات إدارية محدودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyKeyOrientationLeadership",
    "text": "Innovator, entrepreneur, and visionary risk-taker",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار، وريادة الأعمال، والرؤية المستقبلية، والاستعداد لتحمّل المخاطر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyKeyOrientationValueDrivers",
    "text": "Innovative outputs, growth, and cutting-edge capability",
    "translations": [
      {
        "language": "AR",
        "text": "النتائج الابتكارية، والنمو، والقدرات المتقدمة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyKeyCharacteristics",
    "text": "Visionary leadership, quick test-and-learn cycles, collaborative project teams, a high tolerance for ambiguity, entrepreneurial behaviors, and success gauged by innovation, growth, and new offerings.",
    "translations": [
      {
        "language": "AR",
        "text": "قيادة ذات رؤية مستقبلية، ودورات سريعة للتجريب والتعلّم، وفرق مشاريع تعاونية، وقدرة عالية على التعامل مع الغموض، وسلوكيات ريادية. ويُقاس النجاح بالابتكار والنمو وما يُقدَّم من منتجات أو خدمات جديدة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyConstraint1",
    "text": "Can create inconsistency, duplication of effort, or lack of standardization",
    "translations": [
      {
        "language": "AR",
        "text": "قد تؤدي إلى تفاوت الممارسات أو ازدواجية الجهود أو غياب الإجراءات الموحّدة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyConstraint2",
    "text": "Higher risk exposure and potential for costly experimentation",
    "translations": [
      {
        "language": "AR",
        "text": "ارتفاع التعرّض للمخاطر واحتمال تحمّل تكاليف تجريب مرتفعة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyConstraint3",
    "text": "May strain operational efficiency, compliance, or quality control",
    "translations": [
      {
        "language": "AR",
        "text": "قد تفرض ضغوطًا على الكفاءة التشغيلية أو الامتثال أو ضبط الجودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyConstraint4",
    "text": "Employees may experience ambiguity fatigue or burnout absent structure",
    "translations": [
      {
        "language": "AR",
        "text": "قد يعاني الموظفون من الإرهاق الناجم عن الغموض أو من الاحتراق الوظيفي في غياب التنظيم الواضح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketKeyOrientationFocus",
    "text": "External positioning with stability and control",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز موقع المنظمة في بيئتها الخارجية مع الاستقرار والضبط"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketKeyOrientationStructure",
    "text": "Goal-driven, hierarchical in accountability, and performance-based",
    "translations": [
      {
        "language": "AR",
        "text": "موجّه بالأهداف وقائم على الأداء، مع تسلسل هرمي للمساءلة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketKeyOrientationLeadership",
    "text": "Hard-driving competitor, producer, and results-focused director",
    "translations": [
      {
        "language": "AR",
        "text": "الحزم في المنافسة، ودفع الإنتاج، وتوجيه العمل نحو النتائج"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketKeyOrientationValueDrivers",
    "text": "Market share, profitability, and target achievement",
    "translations": [
      {
        "language": "AR",
        "text": "الحصة السوقية، والربحية، وتحقيق المستهدفات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketKeyCharacteristics",
    "text": "Clear targets; customer and competitor insights; ownership of goals; transparent performance tracking; commercial responsibility; and success evaluated through customer value, market share, and winning.",
    "translations": [
      {
        "language": "AR",
        "text": "أهداف واضحة وفهم معمّق للعملاء والمنافسين وتحمّل مسؤولية تحقيق الأهداف ومتابعة شفافة للأداء ومسؤولية عن النتائج التجارية. ويُقيَّم النجاح بالقيمة المقدّمة للعملاء والحصة السوقية والتفوّق التنافسي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketConstraint1",
    "text": "Can foster high-pressure environments that raise stress levels or cause burnout",
    "translations": [
      {
        "language": "AR",
        "text": "قد تنشأ بيئة عمل شديدة الضغط تزيد التوتر أو تؤدي إلى الاحتراق الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketConstraint2",
    "text": "Internal teamwork may decline as competition between individuals or units becomes more dominant",
    "translations": [
      {
        "language": "AR",
        "text": "قد يتراجع العمل الجماعي مع تصاعد المنافسة بين الأفراد أو الوحدات التنظيمية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketConstraint3",
    "text": "Emphasis might be placed on short-term gains rather than nurturing long-term relationships or fostering innovation",
    "translations": [
      {
        "language": "AR",
        "text": "قد تطغى المكاسب قصيرة الأجل على بناء العلاقات طويلة الأمد أو دعم الابتكار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketConstraint4",
    "text": "Trust may be at risk if competitiveness leads to internal rivalry between colleagues",
    "translations": [
      {
        "language": "AR",
        "text": "قد تتراجع الثقة إذا تحوّلت الروح التنافسية إلى صراع داخلي بين الزملاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyKeyOrientationFocus",
    "text": "Internal maintenance with stability and control",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز البيئة الداخلية مع الاستقرار والضبط"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyKeyOrientationStructure",
    "text": "Formal, standardized, and rule-based; clear chain of command",
    "translations": [
      {
        "language": "AR",
        "text": "رسمي وموحّد وقائم على القواعد، مع تسلسل واضح للسلطة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyKeyOrientationLeadership",
    "text": "Coordinator, administrator, and organizer",
    "translations": [
      {
        "language": "AR",
        "text": "التنسيق، والإدارة، والتنظيم"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyKeyOrientationValueDrivers",
    "text": "Efficiency, timeliness, consistency, and reliability",
    "translations": [
      {
        "language": "AR",
        "text": "الكفاءة، والالتزام بالمواعيد، والاتساق، والموثوقية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyKeyCharacteristics",
    "text": "Standard operating procedures, clear decision rights, compliance and quality management, disciplined planning, defined escalation paths, and success measured by efficiency and reliability.",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات تشغيل قياسية، وصلاحيات واضحة لاتخاذ القرار، وإدارة للامتثال والجودة، وتخطيط منضبط، ومسارات محددة لرفع المسائل إلى المستويات الإدارية المعنية. ويُقاس النجاح بالكفاءة والموثوقية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyConstraint1",
    "text": "Can slow responsiveness to change or emerging opportunities",
    "translations": [
      {
        "language": "AR",
        "text": "قد تُبطئ الاستجابة للتغيير أو للفرص الناشئة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyConstraint2",
    "text": "Excessive bureaucracy may frustrate employees and limit initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قد تُحبط البيروقراطية المفرطة الموظفين وتحدّ من المبادرة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyConstraint3",
    "text": "Innovation and creative risk-taking may be discouraged",
    "translations": [
      {
        "language": "AR",
        "text": "قد تحدّ من الابتكار والاستعداد لتحمّل المخاطر المرتبطة به"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyConstraint4",
    "text": "Rigid structures can create silos and slow cross-functional collaboration",
    "translations": [
      {
        "language": "AR",
        "text": "قد تؤدي الهياكل الجامدة إلى انعزال الإدارات وإبطاء التعاون بينها"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanAsCurrentCulture",
    "text": "When Clan characteristics dominate the current-state profile, employees generally report a supportive and cohesive working environment where relationships and morale are prioritized alongside performance.",
    "translations": [
      {
        "language": "AR",
        "text": "عندما تغلب سمات ثقافة الجماعة على الثقافة الحالية، يصف الموظفون بيئة العمل عمومًا بأنها داعمة ومتماسكة، وتولي اهتمامًا بالعلاقات والروح المعنوية إلى جانب الأداء."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyAsCurrentCulture",
    "text": "When Adhocracy dominates the current-state profile, the organization tends to be fast-moving, innovation-driven, and comfortable operating with limited formal structure.",
    "translations": [
      {
        "language": "AR",
        "text": "عندما تغلب ثقافة الإبداع على الثقافة الحالية، تتسم المنظمة عادةً بسرعة الاستجابة والتركيز على الابتكار، مع القدرة على العمل دون اعتماد كبير على الهياكل الرسمية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyAsCurrentCulture",
    "text": "When Hierarchy characteristics dominate the current-state profile, the organization tends to operate with strong process discipline, predictability, and clearly defined roles and controls.",
    "translations": [
      {
        "language": "AR",
        "text": "عندما تغلب سمات الثقافة الهرمية على الثقافة الحالية، تتسم المنظمة عادةً بانضباط العمليات، وإمكانية توقّع سير العمل، ووضوح الأدوار والضوابط."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketAsCurrentCulture",
    "text": "When Market characteristics dominate the current-state profile, the organization is typically driven by clear targets, competitive positioning, and a strong focus on results.",
    "translations": [
      {
        "language": "AR",
        "text": "عندما تغلب سمات ثقافة السوق على الثقافة الحالية، توجّه المنظمةَ عادةً أهدافٌ واضحة، وحرصٌ على تعزيز موقعها التنافسي، وتركيزٌ كبير على النتائج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanPreferredSubtitle",
    "text": "Collaborate",
    "translations": [
      {
        "language": "AR",
        "text": "التعاون"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyPreferredSubtitle",
    "text": "Create",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketPreferredSubtitle",
    "text": "Compete",
    "translations": [
      {
        "language": "AR",
        "text": "التنافس"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyPreferredSubtitle",
    "text": "Control",
    "translations": [
      {
        "language": "AR",
        "text": "الضبط"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanAsPreferredCulture",
    "text": "Selecting Clan as the preferred future state signals a desire to strengthen collaboration, trust, and people-centric management practices.",
    "translations": [
      {
        "language": "AR",
        "text": "يشير اختيار ثقافة الجماعة ثقافةً مرغوبةً للمستقبل إلى الرغبة في تعزيز التعاون والثقة، وتبنّي ممارسات إدارية تضع الموظفين في صميم اهتمامها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyAsPreferredCulture",
    "text": "Selecting Adhocracy as the preferred future state signals a desire to increase innovation capacity, agility, and entrepreneurial behavior.",
    "translations": [
      {
        "language": "AR",
        "text": "يشير اختيار ثقافة الإبداع ثقافةً مرغوبةً للمستقبل إلى الرغبة في تنمية القدرة على الابتكار، وتعزيز الرشاقة التنظيمية والسلوك الريادي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketAsPreferredCulture",
    "text": "Selecting Market as the preferred future state signals a desire to sharpen accountability, competitiveness, and results-orientation.",
    "translations": [
      {
        "language": "AR",
        "text": "يشير اختيار ثقافة السوق ثقافةً مرغوبةً للمستقبل إلى الرغبة في تعزيز المساءلة والقدرة التنافسية والتركيز على النتائج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyAsPreferredCulture",
    "text": "Selecting Hierarchy as the preferred future state signals a desire for greater structure, consistency, and control — often following a period of rapid growth, volatility, or inconsistent execution.",
    "translations": [
      {
        "language": "AR",
        "text": "يشير اختيار الثقافة الهرمية ثقافةً مرغوبةً للمستقبل إلى الرغبة في مزيد من التنظيم والاتساق والضبط. وغالبًا ما تأتي هذه الرغبة بعد فترة من النمو السريع أو التقلبات أو تفاوت مستوى التنفيذ."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfTransitionSustain",
    "text": "Sustain",
    "translations": [
      {
        "language": "AR",
        "text": "استدامة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfTransitionShift",
    "text": "Shift",
    "translations": [
      {
        "language": "AR",
        "text": "انتقال"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfTransitionTransform",
    "text": "Transform",
    "translations": [
      {
        "language": "AR",
        "text": "تحوّل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfSustainWhatChanges",
    "text": "Current and Preferred are both {{0}}. This scenario reinforces and deepens the existing orientation rather than shifting to a different quadrant; the six OCAI content dimensions may still show internal variation worth reviewing even though the dominant quadrant is unchanged.",
    "translations": [
      {
        "language": "AR",
        "text": "كلٌّ من الثقافة الحالية والثقافة المرغوبة هو {{0}}. ويعزّز هذا السيناريو التوجه القائم ويعمّقه دون الانتقال إلى ربع آخر. ومع ذلك، قد تكشف أبعاد التقييم الستة في أداة تقييم الثقافة التنظيمية (OCAI) عن تفاوت داخلي يستحق المراجعة، حتى مع بقاء الربع السائد دون تغيير."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfSustainRisk",
    "text": "Complacency risk: without deliberate reinforcement, gains already made in this quadrant can erode over time.",
    "translations": [
      {
        "language": "AR",
        "text": "خطر التراخي: قد تتراجع المكاسب المتحققة في هذا الربع بمرور الوقت إذا لم تُبذل جهود مقصودة لترسيخها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToAdhocracy_WhatChanges",
    "text": "Clan and Adhocracy are adjacent quadrants: they share the same operating mode (Flexible) while the Internal/External focus moves from Internal to External.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الجماعة وثقافة الإبداع في ربعين متجاورين؛ إذ تشتركان في نمط العمل القائم على المرونة، بينما ينتقل التركيز على المحور الداخلي/الخارجي من الداخل إلى الخارج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToAdhocracy_Risk",
    "text": "Moderate risk: the organization may be perceived as too risk-averse or slow to adapt, exposing it to more agile competitors",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد يُنظر إلى المنظمة على أنها مفرطة في تجنّب المخاطر أو بطيئة في التكيّف، مما يعرّضها لمنافسة من جهات أكثر رشاقة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToHierarchy_WhatChanges",
    "text": "Clan and Hierarchy are adjacent quadrants: they share the same orientation (Internal) while the Flexibility/Control emphasis moves from Flexible to Control.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الجماعة والثقافة الهرمية في ربعين متجاورين؛ إذ تشتركان في التوجه الداخلي، بينما ينتقل التركيز على محور المرونة/الضبط من المرونة إلى الضبط."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToHierarchy_Risk",
    "text": "Moderate risk: the organization may show inconsistent processes, unclear ownership, or quality variability that expose it to operational risk",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد تعاني المنظمة من عدم اتساق العمليات أو غموض المسؤوليات أو تفاوت الجودة، مما يعرّضها لمخاطر تشغيلية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToClan_WhatChanges",
    "text": "Adhocracy and Clan are adjacent quadrants: they share the same operating mode (Flexible) while the Internal/External focus moves from External to Internal.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الإبداع وثقافة الجماعة في ربعين متجاورين؛ إذ تشتركان في نمط العمل القائم على المرونة، بينما ينتقل التركيز على المحور الداخلي/الخارجي من الخارج إلى الداخل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToClan_Risk",
    "text": "Moderate risk: employees may experience low trust, weak collaboration, or limited voice in decisions if this quadrant remains under-developed",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد يعاني الموظفون من ضعف الثقة والتعاون، أو محدودية المشاركة بالرأي في القرارات، إذا لم تحظَ قيم هذا الربع بالقدر الكافي من التطوير."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToMarket_WhatChanges",
    "text": "Adhocracy and Market are adjacent quadrants: they share the same orientation (External) while the Flexibility/Control emphasis moves from Flexible to Control.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الإبداع وثقافة السوق في ربعين متجاورين؛ إذ تشتركان في التوجه الخارجي، بينما ينتقل التركيز على محور المرونة/الضبط من المرونة إلى الضبط."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToMarket_Risk",
    "text": "Moderate risk: the organization may exhibit weak accountability, unclear targets, or complacency relative to market demands",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد تعاني المنظمة من ضعف المساءلة أو غموض الأهداف أو التراخي في الاستجابة لمتطلبات السوق."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToAdhocracy_WhatChanges",
    "text": "Market and Adhocracy are adjacent quadrants: they share the same orientation (External) while the Flexibility/Control emphasis moves from Control to Flexible.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة السوق وثقافة الإبداع في ربعين متجاورين؛ إذ تشتركان في التوجه الخارجي، بينما ينتقل التركيز على محور المرونة/الضبط من الضبط إلى المرونة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToAdhocracy_Risk",
    "text": "Moderate risk: the organization may be perceived as too risk-averse or slow to adapt, exposing it to more agile competitors",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد يُنظر إلى المنظمة على أنها مفرطة في تجنّب المخاطر أو بطيئة في التكيّف، مما يعرّضها لمنافسة من جهات أكثر رشاقة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToHierarchy_WhatChanges",
    "text": "Market and Hierarchy are adjacent quadrants: they share the same operating mode (Control) while the Internal/External focus moves from External to Internal.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة السوق والثقافة الهرمية في ربعين متجاورين؛ إذ تشتركان في نمط العمل القائم على الضبط، بينما ينتقل التركيز على المحور الداخلي/الخارجي من الخارج إلى الداخل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToHierarchy_Risk",
    "text": "Moderate risk: the organization may show inconsistent processes, unclear ownership, or quality variability that expose it to operational risk",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد تعاني المنظمة من عدم اتساق العمليات أو غموض المسؤوليات أو تفاوت الجودة، مما يعرّضها لمخاطر تشغيلية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToClan_WhatChanges",
    "text": "Hierarchy and Clan are adjacent quadrants: they share the same orientation (Internal) while the Flexibility/Control emphasis moves from Control to Flexible.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع الثقافة الهرمية وثقافة الجماعة في ربعين متجاورين؛ إذ تشتركان في التوجه الداخلي، بينما ينتقل التركيز على محور المرونة/الضبط من الضبط إلى المرونة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToClan_Risk",
    "text": "Moderate risk: employees may experience low trust, weak collaboration, or limited voice in decisions if this quadrant remains under-developed",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد يعاني الموظفون من ضعف الثقة والتعاون، أو محدودية المشاركة بالرأي في القرارات، إذا لم تحظَ قيم هذا الربع بالقدر الكافي من التطوير."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToMarket_WhatChanges",
    "text": "Hierarchy and Market are adjacent quadrants: they share the same operating mode (Control) while the Internal/External focus moves from Internal to External.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع الثقافة الهرمية وثقافة السوق في ربعين متجاورين؛ إذ تشتركان في نمط العمل القائم على الضبط، بينما ينتقل التركيز على المحور الداخلي/الخارجي من الداخل إلى الخارج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToMarket_Risk",
    "text": "Moderate risk: the organization may exhibit weak accountability, unclear targets, or complacency relative to market demands",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة: قد تعاني المنظمة من ضعف المساءلة أو غموض الأهداف أو التراخي في الاستجابة لمتطلبات السوق."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToMarket_WhatChanges",
    "text": "Clan and Market sit in diagonally opposite quadrants of the CVF, so this move requires simultaneous change on both underlying axes — Internal Focus & Integration shifts to External Focus & Differentiation, and Flexibility & Discretion shifts to Stability & Control.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الجماعة وثقافة السوق في ربعين متقابلين قطريًا ضمن نموذج القيم التنافسية (CVF). ولذلك يتطلّب هذا الانتقال تغييرًا متزامنًا على المحورين الأساسيين: من التركيز الداخلي والتكامل إلى التركيز الخارجي والتمايز، ومن المرونة وحرية التصرف إلى الاستقرار والضبط."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_ClanToMarket_Risk",
    "text": "High degree-of-difficulty risk: the organization may exhibit weak accountability, unclear targets, or complacency relative to market demands — compounded by legacy systems, incentives, and leadership habits built for the opposite quadrant.",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر مرتفعة ترتبط بصعوبة التحوّل: قد تعاني المنظمة من ضعف المساءلة أو غموض الأهداف أو التراخي في الاستجابة لمتطلبات السوق؛ وتتفاقم هذه المخاطر بفعل الأنظمة الموروثة والحوافز والممارسات القيادية الراسخة التي صُمّمت لتناسب الربع المقابل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToClan_WhatChanges",
    "text": "Market and Clan sit in diagonally opposite quadrants of the CVF, so this move requires simultaneous change on both underlying axes — External Focus & Differentiation shifts to Internal Focus & Integration, and Stability & Control shifts to Flexibility & Discretion.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة السوق وثقافة الجماعة في ربعين متقابلين قطريًا ضمن نموذج القيم التنافسية (CVF). ولذلك يتطلّب هذا الانتقال تغييرًا متزامنًا على المحورين الأساسيين: من التركيز الخارجي والتمايز إلى التركيز الداخلي والتكامل، ومن الاستقرار والضبط إلى المرونة وحرية التصرف."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_MarketToClan_Risk",
    "text": "High degree-of-difficulty risk: employees may experience low trust, weak collaboration, or limited voice in decisions if this quadrant remains underdeveloped — compounded by legacy systems, incentives, and leadership habits built for the opposite quadrant.",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر مرتفعة ترتبط بصعوبة التحوّل: قد يعاني الموظفون من ضعف الثقة والتعاون، أو محدودية المشاركة بالرأي في القرارات، إذا لم تحظَ قيم هذا الربع بالقدر الكافي من التطوير؛ وتتفاقم هذه المخاطر بفعل الأنظمة الموروثة والحوافز والممارسات القيادية الراسخة التي صُمّمت لتناسب الربع المقابل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToHierarchy_WhatChanges",
    "text": "Adhocracy and Hierarchy sit in diagonally opposite quadrants of the CVF, so this move requires simultaneous change on both underlying axes — External Focus & Differentiation shifts to Internal Focus & Integration, and Flexibility & Discretion shifts to Stability & Control.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع ثقافة الإبداع والثقافة الهرمية في ربعين متقابلين قطريًا ضمن نموذج القيم التنافسية (CVF). ولذلك يتطلّب هذا الانتقال تغييرًا متزامنًا على المحورين الأساسيين: من التركيز الخارجي والتمايز إلى التركيز الداخلي والتكامل، ومن المرونة وحرية التصرف إلى الاستقرار والضبط."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_AdhocracyToHierarchy_Risk",
    "text": "High degree-of-difficulty risk: the organization may show inconsistent processes, unclear ownership, or quality variability that expose it to operational risk — compounded by legacy systems, incentives, and leadership habits built for the opposite quadrant.",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر مرتفعة ترتبط بصعوبة التحوّل: قد تعاني المنظمة من عدم اتساق العمليات أو غموض المسؤوليات أو تفاوت الجودة، مما يعرّضها لمخاطر تشغيلية؛ وتتفاقم هذه المخاطر بفعل الأنظمة الموروثة والحوافز والممارسات القيادية الراسخة التي صُمّمت لتناسب الربع المقابل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToAdhocracy_WhatChanges",
    "text": "Hierarchy and Adhocracy sit in diagonally opposite quadrants of the CVF, so this move requires simultaneous change on both underlying axes — Internal Focus & Integration shifts to External Focus & Differentiation, and Stability & Control shifts to Flexibility & Discretion.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع الثقافة الهرمية وثقافة الإبداع في ربعين متقابلين قطريًا ضمن نموذج القيم التنافسية (CVF). ولذلك يتطلّب هذا الانتقال تغييرًا متزامنًا على المحورين الأساسيين: من التركيز الداخلي والتكامل إلى التركيز الخارجي والتمايز، ومن الاستقرار والضبط إلى المرونة وحرية التصرف."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfGap_HierarchyToAdhocracy_Risk",
    "text": "High degree-of-difficulty risk: the organization may be perceived as too risk-averse or slow to adapt, exposing it to more agile competitors — compounded by legacy systems, incentives, and leadership habits built for the opposite quadrant.",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر مرتفعة ترتبط بصعوبة التحوّل: قد يُنظر إلى المنظمة على أنها مفرطة في تجنّب المخاطر أو بطيئة في التكيّف، مما يعرّضها لمنافسة من جهات أكثر رشاقة؛ وتتفاقم هذه المخاطر بفعل الأنظمة الموروثة والحوافز والممارسات القيادية الراسخة التي صُمّمت لتناسب الربع المقابل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative1Name",
    "text": "Manager-as-Coach Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج المدير الموجّه"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative1Desc",
    "text": "Train people leaders in coaching and mentorship techniques to shift day-to-day management style from directive to developmental.",
    "translations": [
      {
        "language": "AR",
        "text": "تدريب المديرين المسؤولين عن الموظفين على مهارات التوجيه لتطوير الأداء والإرشاد المهني، للانتقال في الإدارة اليومية من إصدار التوجيهات إلى تنمية قدرات الموظفين."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative1TimeHorizon",
    "text": "3–6 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 3 إلى 6 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative2Name",
    "text": "Team Chartering Workshops",
    "translations": [
      {
        "language": "AR",
        "text": "ورش إعداد مواثيق عمل الفرق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative2Desc",
    "text": "Facilitate cross-functional teams in co-creating working agreements, decision rights, and communication norms.",
    "translations": [
      {
        "language": "AR",
        "text": "تيسير إعداد فرق العمل المشتركة بين الإدارات لاتفاقات تنظّم العمل، وتحدّد صلاحيات اتخاذ القرار وقواعد التواصل، بمشاركة أعضاء الفرق."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative2TimeHorizon",
    "text": "1–3 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهر إلى 3 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative3Name",
    "text": "Employee Listening Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج الاستماع إلى الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative3Desc",
    "text": "Introduce regular pulse surveys and skip-level forums to surface concerns and reinforce two-way communication.",
    "translations": [
      {
        "language": "AR",
        "text": "إجراء استبيانات دورية قصيرة لاستطلاع آراء الموظفين، وعقد لقاءات مباشرة مع القيادات الأعلى من المدير المباشر، للكشف عن شواغل الموظفين وتعزيز الحوار المتبادل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative3TimeHorizon",
    "text": "Ongoing",
    "translations": [
      {
        "language": "AR",
        "text": "مستمر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative4Name",
    "text": "Recognition & Peer Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج التقدير المتبادل بين الزملاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative4Desc",
    "text": "Launch structured peer-recognition mechanisms tied to collaborative behaviors, not only individual output.",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق آليات منظّمة تتيح للزملاء تقدير بعضهم بعضًا، وربطها بالسلوكيات التعاونية إلى جانب الإنجاز الفردي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative4TimeHorizon",
    "text": "1–2 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهر إلى شهرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative5Name",
    "text": "Onboarding & Mentorship Redesign",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تصميم برامج التهيئة الوظيفية والإرشاد المهني"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative5Desc",
    "text": "Pair new hires with mentors and strengthen socialization elements of onboarding to accelerate belonging.",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص مرشدين للموظفين الجدد وتعزيز الجوانب الاجتماعية في برامج التهيئة الوظيفية، بما يسرّع شعورهم بالانتماء."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanInitiative5TimeHorizon",
    "text": "3–4 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 3 إلى 4 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanSuccessIndicator1",
    "text": "Improvement in engagement-survey scores on trust, belonging, and collaboration",
    "translations": [
      {
        "language": "AR",
        "text": "تحسّن نتائج استبيانات الارتباط الوظيفي في البنود المتعلقة بالثقة والانتماء والتعاون"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanSuccessIndicator2",
    "text": "Reduction in voluntary attrition, particularly among high performers",
    "translations": [
      {
        "language": "AR",
        "text": "انخفاض معدل ترك العمل طوعًا، ولا سيما بين الموظفين ذوي الأداء المتميز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanSuccessIndicator3",
    "text": "Increase in cross-functional project participation",
    "translations": [
      {
        "language": "AR",
        "text": "زيادة المشاركة في المشاريع المشتركة بين الإدارات والتخصصات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ClanSuccessIndicator4",
    "text": "Positive shift in Clan quadrant score on repeat OCAI administration",
    "translations": [
      {
        "language": "AR",
        "text": "تغيّر إيجابي في درجة ربع ثقافة الجماعة عند إعادة تطبيق أداة تقييم الثقافة التنظيمية (OCAI)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative1Name",
    "text": "Innovation Incubator / Lab",
    "translations": [
      {
        "language": "AR",
        "text": "حاضنة أو مختبر الابتكار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative1Desc",
    "text": "Stand up a ring-fenced team and budget to prototype and pilot new ideas outside normal operating constraints.",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص فريق وميزانية مستقلين لتطوير نماذج أولية وتجربة أفكار جديدة بعيدًا عن قيود التشغيل المعتادة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative1TimeHorizon",
    "text": "6–12 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 6 إلى 12 شهرًا"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative2Name",
    "text": "Structured Ideation Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج منظّم لتوليد الأفكار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative2Desc",
    "text": "Introduce hackathons, innovation challenges, or idea-submission platforms with clear evaluation and funding pathways.",
    "translations": [
      {
        "language": "AR",
        "text": "تنظيم هاكاثونات أو تحديات للابتكار، أو إطلاق منصات لتقديم الأفكار، مع تحديد مسارات واضحة للتقييم والتمويل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative2TimeHorizon",
    "text": "2–4 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهرين إلى 4 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative3Name",
    "text": "Psychological Safety for Failure",
    "translations": [
      {
        "language": "AR",
        "text": "الأمان النفسي عند الإخفاق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative3Desc",
    "text": "Redesign performance narratives and leadership messaging to normalize intelligent risk-taking and learning from failed experiments.",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة صياغة الخطاب المتعلق بالأداء ورسائل القيادة، لترسيخ تقبّل المخاطرة المدروسة والتعلّم من التجارب غير الناجحة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative3TimeHorizon",
    "text": "Ongoing",
    "translations": [
      {
        "language": "AR",
        "text": "مستمر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative4Name",
    "text": "Agile Ways of Working",
    "translations": [
      {
        "language": "AR",
        "text": "أساليب العمل الرشيقة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative4Desc",
    "text": "Train teams in agile/sprint-based methods to increase iteration speed while retaining lightweight governance.",
    "translations": [
      {
        "language": "AR",
        "text": "تدريب الفرق على منهجيات العمل الرشيق ودورات العمل القصيرة، لتسريع دورات التطوير مع الحفاظ على حوكمة مبسّطة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative4TimeHorizon",
    "text": "3–6 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 3 إلى 6 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative5Name",
    "text": "Innovation Governance Council",
    "translations": [
      {
        "language": "AR",
        "text": "مجلس حوكمة الابتكار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative5Desc",
    "text": "Establish a lightweight stage-gate process so experimentation remains prioritized, funded, and connected to strategy.",
    "translations": [
      {
        "language": "AR",
        "text": "إرساء آلية مبسّطة تقوم على مراحل تتخللها نقاط مراجعة وقرار، لضمان ترتيب أولويات التجارب وتوفير تمويلها وربطها بالاستراتيجية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracyInitiative5TimeHorizon",
    "text": "2–3 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهرين إلى 3 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracySuccessIndicator1",
    "text": "Increase in number of piloted ideas that progress to scale",
    "translations": [
      {
        "language": "AR",
        "text": "زيادة عدد الأفكار التي تنتقل من التطبيق التجريبي إلى التوسّع في التطبيق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracySuccessIndicator2",
    "text": "Reduction in time-to-market for new products or services",
    "translations": [
      {
        "language": "AR",
        "text": "تقليص المدة اللازمة لطرح المنتجات أو الخدمات الجديدة في السوق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracySuccessIndicator3",
    "text": "Improved engagement scores on innovation- and autonomy-related items",
    "translations": [
      {
        "language": "AR",
        "text": "تحسّن نتائج استبيانات الارتباط الوظيفي في البنود المتعلقة بالابتكار والاستقلالية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AdhocracySuccessIndicator4",
    "text": "Positive shift in Adhocracy quadrant score on repeat OCAI administration",
    "translations": [
      {
        "language": "AR",
        "text": "تغيّر إيجابي في درجة ربع ثقافة الإبداع عند إعادة تطبيق أداة تقييم الثقافة التنظيمية (OCAI)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative1Name",
    "text": "Goal-Setting Framework (OKRs/KPIs)",
    "translations": [
      {
        "language": "AR",
        "text": "إطار تحديد الأهداف والنتائج الرئيسية (OKRs) ومؤشرات الأداء الرئيسية (KPIs)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative1Desc",
    "text": "Implement a cascading goal system that connects individual, team, and organizational targets with regular review cadence.",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق منظومة أهداف مترابطة عبر المستويات التنظيمية، تصل أهداف الأفراد بأهداف الفرق والمنظمة، مع مراجعتها بانتظام."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative1TimeHorizon",
    "text": "3–6 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 3 إلى 6 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative2Name",
    "text": "Performance Management Redesign",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تصميم منظومة إدارة الأداء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative2Desc",
    "text": "Revise performance review criteria and calibration processes to reinforce clear, fair, and consistent accountability.",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة معايير تقييم الأداء وآليات معايرة التقييمات، لترسيخ مساءلة واضحة وعادلة ومتسقة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative2TimeHorizon",
    "text": "6–12 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 6 إلى 12 شهرًا"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative3Name",
    "text": "Incentive & Recognition Realignment",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة مواءمة الحوافز والتقدير"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative3Desc",
    "text": "Align compensation and recognition programs with desired competitive behaviors and results.",
    "translations": [
      {
        "language": "AR",
        "text": "مواءمة برامج التعويضات والتقدير مع السلوكيات التنافسية والنتائج المنشودة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative3TimeHorizon",
    "text": "6–12 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 6 إلى 12 شهرًا"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative4Name",
    "text": "Customer Insight Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج فهم العملاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative4Desc",
    "text": "Establish structured mechanisms (voice-of-customer, win/loss reviews) to sharpen external market focus.",
    "translations": [
      {
        "language": "AR",
        "text": "وضع آليات منظّمة، مثل الاستماع إلى صوت العميل وتحليل أسباب كسب الفرص التجارية أو خسارتها، لتعزيز التركيز على السوق الخارجية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative4TimeHorizon",
    "text": "2–4 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهرين إلى 4 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative5Name",
    "text": "Manager Capability Building",
    "translations": [
      {
        "language": "AR",
        "text": "تنمية قدرات المديرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative5Desc",
    "text": "Equip managers to hold performance conversations that are direct yet constructive, avoiding purely punitive dynamics.",
    "translations": [
      {
        "language": "AR",
        "text": "تمكين المديرين من إجراء مناقشات صريحة وبنّاءة حول الأداء، مع تجنّب الاقتصار على الأساليب العقابية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketInitiative5TimeHorizon",
    "text": "3–4 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 3 إلى 4 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketSuccessIndicator1",
    "text": "Improvement in goal-attainment rates and forecast accuracy",
    "translations": [
      {
        "language": "AR",
        "text": "تحسّن معدلات تحقيق الأهداف ودقة التنبؤات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketSuccessIndicator2",
    "text": "Movement in competitive market-share or customer-satisfaction metrics",
    "translations": [
      {
        "language": "AR",
        "text": "التغيّر في مؤشرات الحصة السوقية مقارنةً بالمنافسين أو في مؤشرات رضا العملاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketSuccessIndicator3",
    "text": "Reduction in performance-related grievances or turnover among top performers",
    "translations": [
      {
        "language": "AR",
        "text": "انخفاض التظلّمات المتعلقة بالأداء أو معدل دوران الموظفين ذوي الأداء المتميز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MarketSuccessIndicator4",
    "text": "Positive shift in Market quadrant score on repeat OCAI administration",
    "translations": [
      {
        "language": "AR",
        "text": "تغيّر إيجابي في درجة ربع ثقافة السوق عند إعادة تطبيق أداة تقييم الثقافة التنظيمية (OCAI)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative1Name",
    "text": "Process Standardization & SOPs",
    "translations": [
      {
        "language": "AR",
        "text": "توحيد العمليات وإجراءات التشغيل القياسية (SOPs)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative1Desc",
    "text": "Document and standardize core processes to reduce variability and clarify handoffs across teams.",
    "translations": [
      {
        "language": "AR",
        "text": "توثيق العمليات الأساسية وتوحيدها للحدّ من التفاوت، وتوضيح آلية تسليم العمل وانتقال المسؤولية بين الفرق."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative1TimeHorizon",
    "text": "4–6 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 4 إلى 6 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative2Name",
    "text": "Governance & Decision-Rights Review",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة الحوكمة وصلاحيات اتخاذ القرار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative2Desc",
    "text": "Clarify RACI/decision rights to remove bottlenecks while maintaining appropriate control.",
    "translations": [
      {
        "language": "AR",
        "text": "توضيح الأدوار والمسؤوليات وفق مصفوفة (RACI)، وصلاحيات اتخاذ القرار، لإزالة معوّقات سير العمل مع الحفاظ على الرقابة المناسبة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative2TimeHorizon",
    "text": "2–3 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهرين إلى 3 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative3Name",
    "text": "Quality Management System",
    "translations": [
      {
        "language": "AR",
        "text": "نظام إدارة الجودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative3Desc",
    "text": "Implement or strengthen a QMS with defined metrics, audits, and continuous-improvement cycles.",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق نظام إدارة الجودة (QMS) أو تعزيزه، مع تحديد مقاييس واضحة وعمليات تدقيق ودورات للتحسين المستمر."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative3TimeHorizon",
    "text": "6–12 months",
    "translations": [
      {
        "language": "AR",
        "text": "من 6 إلى 12 شهرًا"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative4Name",
    "text": "Policy Simplification Sprint",
    "translations": [
      {
        "language": "AR",
        "text": "دورة عمل مكثّفة لتبسيط السياسات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative4Desc",
    "text": "Review existing policies to eliminate redundant approvals and outdated controls that no longer add value.",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة السياسات القائمة لإلغاء الموافقات الزائدة والضوابط المتقادمة التي لم تعد تضيف قيمة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative4TimeHorizon",
    "text": "1–3 months",
    "translations": [
      {
        "language": "AR",
        "text": "من شهر إلى 3 أشهر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative5Name",
    "text": "Compliance & Risk Training",
    "translations": [
      {
        "language": "AR",
        "text": "التدريب على الامتثال وإدارة المخاطر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative5Desc",
    "text": "Refresh training on regulatory, quality, and risk-management requirements relevant to the business.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التدريب على المتطلبات التنظيمية ومتطلبات الجودة وإدارة المخاطر ذات الصلة بنشاط المنظمة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchyInitiative5TimeHorizon",
    "text": "Ongoing",
    "translations": [
      {
        "language": "AR",
        "text": "مستمر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchySuccessIndicator1",
    "text": "Reduction in process cycle time and approval bottlenecks",
    "translations": [
      {
        "language": "AR",
        "text": "تقليص مدة إنجاز العمليات والحدّ من التأخّر الناجم عن إجراءات الموافقة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchySuccessIndicator2",
    "text": "Improvement in quality/compliance audit results",
    "translations": [
      {
        "language": "AR",
        "text": "تحسّن نتائج تدقيق الجودة والامتثال"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchySuccessIndicator3",
    "text": "Increased employee clarity on roles and decision rights (survey-based)",
    "translations": [
      {
        "language": "AR",
        "text": "زيادة وضوح الأدوار وصلاحيات اتخاذ القرار لدى الموظفين، وفقًا لنتائج الاستبيانات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HierarchySuccessIndicator4",
    "text": "Positive shift in Hierarchy quadrant score on repeat OCAI administration",
    "translations": [
      {
        "language": "AR",
        "text": "تغيّر إيجابي في درجة ربع الثقافة الهرمية عند إعادة تطبيق أداة تقييم الثقافة التنظيمية (OCAI)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfConfidentialLimit",
    "text": "This selection has too few respondents to display results without risking anonymity. Broaden the filters or pick a larger segment.",
    "translations": [
      {
        "language": "AR",
        "text": "يضم هذا الاختيار عددًا قليلًا جدًا من المشاركين لعرض النتائج دون المساس بسرية الهوية. وسّع نطاق التصفية أو اختر مجموعة أكبر."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfInitiativesTitle",
    "text": "Recommended Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات الموصى بها"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfKeyOrientationLabel",
    "text": "Key Orientation",
    "translations": [
      {
        "language": "AR",
        "text": "التوجه الرئيسي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfInitiativesIntro",
    "text": "The following initiatives are recommended to close the culture gap and move the organization toward its preferred culture:",
    "translations": [
      {
        "language": "AR",
        "text": "يوصى بالمبادرات التالية لسد الفجوة الثقافية ونقل المؤسسة نحو ثقافتها المرغوبة:"
      },
      {
        "language": "FR",
        "text": "Les initiatives suivantes sont recommandées pour combler l'écart culturel et orienter l'organisation vers sa culture préférée :"
      }
    ]
  },
  {
    "key": "txt_CvfInitiativesTableLabel",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "FR",
        "text": "Initiatives"
      }
    ]
  },
  {
    "key": "txt_Definition",
    "text": "Definition",
    "translations": [
      {
        "language": "AR",
        "text": "التعريف"
      },
      {
        "language": "FR",
        "text": "Définition"
      }
    ]
  },
  {
    "key": "txt_QuadrantProfile",
    "text": "Quadrant Profile",
    "translations": [
      {
        "language": "AR",
        "text": "ملف الأرباع"
      },
      {
        "language": "FR",
        "text": "Profil des quadrants"
      }
    ]
  },
  {
    "key": "txt_Strengths",
    "text": "Strengths",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة"
      },
      {
        "language": "FR",
        "text": "Points forts"
      }
    ]
  },
  {
    "key": "txt_CvfKeyCharacteristicsLabel",
    "text": "Key Characteristics",
    "translations": [
      {
        "language": "AR",
        "text": "السمات الرئيسية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfConstraintsLabel",
    "text": "Constraints",
    "translations": [
      {
        "language": "AR",
        "text": "القيود"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfFocusLabel",
    "text": "Focus",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfStructureLabel",
    "text": "Structure",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfLeadershipLabel",
    "text": "Leadership Style",
    "translations": [
      {
        "language": "AR",
        "text": "أسلوب القيادة"
      },
      {
        "language": "FR",
        "text": "Style de leadership"
      }
    ]
  },
  {
    "key": "txt_CvfValueDriversLabel",
    "text": "Value Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل تحقيق القيمة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfWhatChangesLabel",
    "text": "What Changes",
    "translations": [
      {
        "language": "AR",
        "text": "ما الذي يتغيّر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfRiskLabel",
    "text": "Risk",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfSuccessIndicatorsLabel",
    "text": "Success Indicators",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشرات النجاح المطلوب متابعتها"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MixedTitle",
    "text": "Mixed",
    "translations": [
      {
        "language": "AR",
        "text": "مختلط"
      },
      {
        "language": "FR",
        "text": "Mixte"
      }
    ]
  },
  {
    "key": "txt_MixedTagline",
    "text": "No single archetype dominates — the top scores are effectively tied.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يهيمن نمط واحد — أعلى الدرجات متعادلة فعلياً."
      },
      {
        "language": "FR",
        "text": "Aucun archétype ne domine — les meilleurs scores sont quasiment à égalité."
      }
    ]
  },
  {
    "key": "txt_MixedDriver",
    "text": "Mixed Focus",
    "translations": [
      {
        "language": "AR",
        "text": "تركيز مختلط"
      },
      {
        "language": "FR",
        "text": "Orientation mixte"
      }
    ]
  },
  {
    "key": "txt_MixedDesc",
    "text": "The top two archetype scores are within a hair of each other, so no one culture style is clearly dominant.",
    "translations": [
      {
        "language": "AR",
        "text": "أعلى نمطين متقاربان جداً في الدرجات، لذا لا يوجد نمط ثقافي واحد مهيمن بوضوح."
      },
      {
        "language": "FR",
        "text": "Les deux meilleurs archétypes sont extrêmement proches, aucun style de culture ne domine clairement."
      }
    ]
  },
  {
    "key": "txt_MixedKeyOrientationFocus",
    "text": "Split evenly between two or more competing orientations",
    "translations": [
      {
        "language": "AR",
        "text": "منقسم بالتساوي بين توجهين متنافسين أو أكثر"
      },
      {
        "language": "FR",
        "text": "Réparti équitablement entre deux orientations concurrentes ou plus"
      }
    ]
  },
  {
    "key": "txt_MixedKeyOrientationStructure",
    "text": "No single structure is dominant across respondents",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد بنية واحدة مهيمنة بين المستجيبين"
      },
      {
        "language": "FR",
        "text": "Aucune structure unique ne domine parmi les répondants"
      }
    ]
  },
  {
    "key": "txt_MixedKeyOrientationLeadership",
    "text": "Leadership style varies by team or respondent",
    "translations": [
      {
        "language": "AR",
        "text": "يختلف أسلوب القيادة حسب الفريق أو المستجيب"
      },
      {
        "language": "FR",
        "text": "Le style de leadership varie selon l'équipe ou le répondant"
      }
    ]
  },
  {
    "key": "txt_MixedKeyOrientationValueDrivers",
    "text": "No single value driver is dominant",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد محرك قيمة واحد مهيمن"
      },
      {
        "language": "FR",
        "text": "Aucun moteur de valeur unique ne domine"
      }
    ]
  },
  {
    "key": "txt_MixedKeyCharacteristics",
    "text": "Scores are split closely between two or more archetypes rather than converging on one — treat this as \"undecided,\" not as evidence of a fifth culture type.",
    "translations": [
      {
        "language": "AR",
        "text": "تتوزع الدرجات بشكل متقارب بين نمطين أو أكثر بدلاً من التقارب على نمط واحد — اعتبر ذلك «غير محسوم» وليس دليلاً على نمط ثقافي خامس."
      },
      {
        "language": "FR",
        "text": "Les scores se répartissent étroitement entre deux archétypes ou plus au lieu de converger vers un seul — à considérer comme « indécis », non comme un cinquième type de culture."
      }
    ]
  },
  {
    "key": "txt_MixedConstraint1",
    "text": "A single dominant-archetype label would misrepresent a genuine split",
    "translations": [
      {
        "language": "AR",
        "text": "وصف النتيجة بنمط مهيمن واحد سيحرّف انقساماً حقيقياً في الدرجات"
      },
      {
        "language": "FR",
        "text": "Un label d'archétype dominant unique dénaturerait une répartition réellement partagée"
      }
    ]
  },
  {
    "key": "txt_CultureReport",
    "text": "Culture Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم الثقافة"
      },
      {
        "language": "FR",
        "text": "Rapport d'évaluation de la culture"
      }
    ]
  },
  {
    "key": "txt_Transition",
    "text": "Transition",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الانتقال"
      },
      {
        "language": "FR",
        "text": "Transition"
      }
    ]
  },
  {
    "key": "txt_CvfPolarityIntro",
    "text": "The section below summarizes the gap profile between the {{0}} current culture and the {{1}} preferred culture, including the CVF transition type and the primary risk to manage.",
    "translations": [
      {
        "language": "AR",
        "text": "يلخّص هذا القسم طبيعة الفجوة بين الثقافة الحالية ({{0}}) والثقافة المرغوبة ({{1}})، مع بيان نوع الانتقال وفق نموذج القيم التنافسية (CVF)، والخطر الرئيسي الذي ينبغي إدارته."
      },
      {
        "language": "FR",
        "text": "La section ci-dessous résume l'écart entre la culture actuelle {{0}} et la culture souhaitée {{1}}, y compris le type de transition CVF et le principal risque à gérer."
      }
    ]
  },
  {
    "key": "txt_CvfPrimaryRiskLabel",
    "text": "Primary Risk to Manage",
    "translations": [
      {
        "language": "AR",
        "text": "الخطر الرئيسي الذي ينبغي إدارته"
      },
      {
        "language": "FR",
        "text": "Risque principal à gérer"
      }
    ]
  },
  {
    "key": "txt_CvfRiskLow",
    "text": "Low risk",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر منخفضة"
      },
      {
        "language": "FR",
        "text": "Risque faible"
      }
    ]
  },
  {
    "key": "txt_CvfRiskModerate",
    "text": "Moderate risk",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر متوسطة"
      },
      {
        "language": "FR",
        "text": "Risque modéré"
      }
    ]
  },
  {
    "key": "txt_CvfRiskHigh",
    "text": "High risk",
    "translations": [
      {
        "language": "AR",
        "text": "مخاطر مرتفعة"
      },
      {
        "language": "FR",
        "text": "Risque élevé"
      }
    ]
  },
  {
    "key": "txt_cvf_range_error",
    "text": "Enter a value between 0 and 100",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل قيمة بين 0 و100"
      },
      {
        "language": "FR",
        "text": "Saisissez une valeur entre 0 et 100"
      }
    ]
  },
  {
    "key": "txt_CurrentToPreferred",
    "text": "Current → Preferred",
    "translations": [
      {
        "language": "AR",
        "text": "الحالي إلى المرغوب"
      },
      {
        "language": "FR",
        "text": "Actuel → Préféré"
      }
    ]
  },
  {
    "key": "txt_QuadrantScore",
    "text": "Quadrant Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الربع"
      },
      {
        "language": "FR",
        "text": "Score du quadrant"
      }
    ]
  },
  {
    "key": "txt_StrategicGapAnalysis",
    "text": "Strategic Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الفجوات الاستراتيجية"
      },
      {
        "language": "FR",
        "text": "Analyse stratégique des écarts"
      }
    ]
  },
  {
    "key": "txt_GapSubtext",
    "text": "Positive deltas indicate strategic areas requiring culture shift priority.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير الفروقات الموجبة إلى مجالات استراتيجية تتطلب أولوية في التحول الثقافي."
      },
      {
        "language": "FR",
        "text": "Les écarts positifs indiquent des domaines stratégiques prioritaires pour l'évolution de la culture."
      }
    ]
  },
  {
    "key": "txt_ViewFullMatrix",
    "text": "View Full Matrix",
    "translations": [
      {
        "language": "AR",
        "text": "عرض المصفوفة الكاملة"
      },
      {
        "language": "FR",
        "text": "Voir la matrice complète"
      }
    ]
  },
  {
    "key": "txtCultureComparison",
    "text": "Culture Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الثقافة"
      }
    ]
  },
  {
    "key": "txtCultureIndexByScale",
    "text": "Culture Index by Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر الثقافة حسب المقياس"
      }
    ]
  },
  {
    "key": "txtCultureReport",
    "text": "Culture Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير الثقافة"
      }
    ]
  },
  {
    "key": "txtCultureSurveyPreview",
    "text": "Culture Assessment Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة تقييم الثقافة"
      }
    ]
  },
  {
    "key": "txtDriversOfWorkplaceCulture",
    "text": "Drivers of Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "محركات ثقافة مكان العمل"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder email body must include the [SurveyURL] placeholder",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يتضمن نص البريد التذكيري رابط التقييم [SurveyURL]"
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Assessment Respondent List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبين للتقييم"
      }
    ]
  },
  {
    "key": "txtWorkplaceCultureScore",
    "text": "Culture Assessment Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة ثقافة مكان العمل"
      }
    ]
  },
  {
    "key": "txt_Low",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please fill in all required fields",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة"
      }
    ]
  },
  {
    "key": "txt_OcaiModelFramework",
    "text": "OCAI Model Framework",
    "translations": [
      {
        "language": "AR",
        "text": "إطار أداة تقييم الثقافة التنظيمية (OCAI)"
      }
    ]
  },
  {
    "key": "txtAssessmentCloningSuccess",
    "text": "Assessment has been cloned successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم استنساخ التقييم بنجاح!"
      }
    ]
  },
  {
    "key": "txtUpdateAssessmentDates",
    "text": "Update Assessment Dates",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث تواريخ التقييم"
      }
    ]
  },
  {
    "key": "txt_CvfReportIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "المقدمة"
      }
    ]
  },
  {
    "key": "txt_CvfReportObjectivesTitle",
    "text": "Objectives of this Report",
    "translations": [
      {
        "language": "AR",
        "text": "أهداف هذا التقرير"
      }
    ]
  },
  {
    "key": "txt_CvfReportScienceTitle",
    "text": "Science Behind the CVF Model",
    "translations": [
      {
        "language": "AR",
        "text": "الأساس العلمي لنموذج القيم التنافسية"
      }
    ]
  },
  {
    "key": "txt_CvfReportFrameworkTitle",
    "text": "The Competing Values Framework (CVF)",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج القيم التنافسية (CVF)"
      }
    ]
  },
  {
    "key": "txt_CvfReportHowToUseTitle",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيفية استخدام التقرير"
      }
    ]
  },
  {
    "key": "txt_CvfReportProfileReadingTitle",
    "text": "Culture Profile Reading",
    "translations": [
      {
        "language": "AR",
        "text": "قراءة ملامح الثقافة التنظيمية"
      }
    ]
  },
  {
    "key": "txt_CvfReportCalculationTitle",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "آلية احتساب الدرجات"
      }
    ]
  },
  {
    "key": "txt_CvfReportIntroP1",
    "text": "Organizational culture is the shared values, behaviors, and everyday practices that shape how people work together, make decisions, lead others, and respond to change. It influences what the organization prioritizes, rewards, and recognizes as success.",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة التنظيمية هي منظومة القيم والسلوكيات والممارسات اليومية المشتركة التي تشكّل طريقة تعاون الأفراد، واتخاذ القرارات، وممارسة القيادة، والاستجابة للتغيير. وهي تؤثر في أولويات المنظمة، وما تكافئ عليه، وما تعدّه نجاحًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportIntroP2",
    "text": "The Organizational Culture Assessment Instrument <b>(OCAI)</b> is a practical assessment used to understand the culture employees experience in the workplace today and the culture they believe is needed for future success.",
    "translations": [
      {
        "language": "AR",
        "text": "أداة تقييم الثقافة التنظيمية <b>(OCAI)</b> أداة عملية تساعد على فهم الثقافة السائدة كما يراها الموظفون في بيئة عملهم الحالية، والثقافة التي يرون أنها ضرورية لتحقيق النجاح مستقبلًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportIntroP3",
    "text": "The assessment does not determine whether a culture is good or bad. Instead, it identifies the cultural values that are currently most strongly experienced, and the values employees believe should receive greater emphasis in the future.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يهدف التقييم إلى تصنيف الثقافة بأنها جيدة أو سيئة؛ بل يحدّد القيم الثقافية الأكثر حضورًا في واقع العمل الحالي، والقيم التي يرى الموظفون ضرورة إيلائها مزيدًا من الاهتمام مستقبلًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportIntroP4",
    "text": "<b>OCAI</b> applies the Competing Values Framework <b>(CVF)</b> to assess culture across four archetypes: <b>Clan, Adhocracy, Market,</b> and <b>Hierarchy</b>. The findings in this report present the current culture profile, preferred culture profile, culture gaps, and recommended initiatives to support the desired direction.",
    "translations": [
      {
        "language": "AR",
        "text": "تستند أداة تقييم الثقافة التنظيمية <b>(OCAI)</b> إلى نموذج القيم التنافسية <b>(CVF)</b>، وتقيّم الثقافة وفق أربعة أنماط: <b>ثقافة الجماعة (Clan)</b>، و<b>ثقافة الإبداع (Adhocracy)</b>، و<b>ثقافة السوق (Market)</b>، و<b>الثقافة الهرمية (Hierarchy)</b>. ويعرض هذا التقرير ملامح الثقافة الحالية والثقافة المرغوبة، والفجوات بينهما، والمبادرات الموصى بها لدعم التوجه المنشود."
      }
    ]
  },
  {
    "key": "txt_CvfReportObjective1",
    "text": "Identify the current organizational culture profile and determine the relative emphasis placed on the Clan, Adhocracy, Market, and Hierarchy archetypes.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد ملامح الثقافة التنظيمية الحالية، ومدى التركيز النسبي على كلٍّ من ثقافة الجماعة، وثقافة الإبداع، وثقافة السوق، والثقافة الهرمية."
      }
    ]
  },
  {
    "key": "txt_CvfReportObjective2",
    "text": "Identify the preferred culture profile and recognize the direction employees believe will better support future success.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد ملامح الثقافة المرغوبة والتوجه الذي يرى الموظفون أنه أكثر دعمًا للنجاح مستقبلًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportObjective3",
    "text": "Understand the gap between current and preferred culture and the cultural emphasis that should be strengthened, reduced, or sustained.",
    "translations": [
      {
        "language": "AR",
        "text": "فهم الفجوة بين الثقافة الحالية والثقافة المرغوبة، وتحديد الجوانب الثقافية التي ينبغي زيادة التركيز عليها أو تقليله أو الإبقاء عليه."
      }
    ]
  },
  {
    "key": "txt_CvfReportObjective4",
    "text": "Access recommended initiatives that support the preferred culture direction and understand how they can be applied through leadership, management, and operating practices.",
    "translations": [
      {
        "language": "AR",
        "text": "الاطلاع على المبادرات الموصى بها لدعم التوجه الثقافي المرغوب، وفهم كيفية تطبيقها من خلال ممارسات القيادة والإدارة والتشغيل."
      }
    ]
  },
  {
    "key": "txt_CvfReportObjective5",
    "text": "Use the OCAI results as a common language for culture discussion, focused action planning, and follow-up measurement.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدام نتائج أداة تقييم الثقافة التنظيمية (OCAI) لغةً مشتركةً لمناقشة الثقافة، وإعداد خطط عمل محددة الأولويات، وإجراء قياسات لاحقة لمتابعة التقدم."
      }
    ]
  },
  {
    "key": "txt_CvfReportScienceP1",
    "text": "The <b>Organizational Culture Assessment Instrument (OCAI)</b> is a structured assessment used to identify the culture employees experience today and the culture they believe is required for future success.",
    "translations": [
      {
        "language": "AR",
        "text": "أداة تقييم الثقافة التنظيمية <b>(OCAI)</b> أداة منهجية لتحديد الثقافة السائدة كما يراها الموظفون حاليًا، والثقافة التي يرون أنها ضرورية لتحقيق النجاح مستقبلًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportScienceP2",
    "text": "The assessment is based on the <b>Competing Values Framework (CVF)</b>, an empirically derived model of organizational effectiveness. The CVF recognizes that organizational culture is shaped by competing priorities: flexibility and discretion versus stability and control, and internal integration versus external differentiation.",
    "translations": [
      {
        "language": "AR",
        "text": "تستند الأداة إلى نموذج القيم التنافسية <b>(CVF)</b>، وهو نموذج للفاعلية التنظيمية طُوّر استنادًا إلى بحوث تجريبية. ويقوم النموذج على أن الثقافة التنظيمية تتشكّل في ظل أولويات متنافسة، تتمثل في المرونة وحرية التصرف مقابل الاستقرار والضبط، والتكامل الداخلي مقابل التمايز في البيئة الخارجية."
      }
    ]
  },
  {
    "key": "txt_CvfReportScienceP3",
    "text": "When these two dimensions are combined, they form four culture archetypes: Clan, Adhocracy, Market, and Hierarchy. Organizations typically demonstrate a relative mix of all four archetypes rather than a single culture type.",
    "translations": [
      {
        "language": "AR",
        "text": "ينتج عن تقاطع هذين البعدين أربعة أنماط ثقافية: ثقافة الجماعة، وثقافة الإبداع، وثقافة السوق، والثقافة الهرمية. وعادةً ما تجمع المنظمات بين هذه الأنماط الأربعة بدرجات متفاوتة، ولا تقتصر على نمط واحد."
      }
    ]
  },
  {
    "key": "txt_CvfReportScienceP4",
    "text": "<b>OCAI</b> applies this framework across six workplace areas: Dominant Characteristics, Organizational Leadership, Management of Employees, Organizational Glue, Strategic Emphases, and Criteria of Success. The results provide a structured basis for identifying the current culture profile, the preferred direction, and the cultural priorities that may require action.",
    "translations": [
      {
        "language": "AR",
        "text": "تطبّق أداة تقييم الثقافة التنظيمية <b>(OCAI)</b> هذا النموذج على ستة أبعاد في بيئة العمل: الخصائص المهيمنة، والقيادة التنظيمية، وإدارة العاملين، والتماسك التنظيمي، والتركيز الاستراتيجي، ومعايير النجاح. وتوفّر النتائج أساسًا منهجيًا لتحديد ملامح الثقافة الحالية، والتوجه المرغوب، والأولويات الثقافية التي قد تستدعي اتخاذ إجراءات."
      }
    ]
  },
  {
    "key": "txt_CvfReportHowToUseP1",
    "text": "This report presents the current and preferred cultural profiles of the assessed population. Using the <b>Competing Values Framework</b>, the <b>OCAI</b> identifies the relative emphasis employees place on the four culture archetypes and the direction of change they believe is needed for future success.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض هذا التقرير ملامح الثقافة الحالية والثقافة المرغوبة لدى الفئة المشمولة بالتقييم. وبالاستناد إلى <b>نموذج القيم التنافسية</b>، تحدّد أداة تقييم الثقافة التنظيمية <b>(OCAI)</b> مدى التركيز النسبي الذي يمنحه الموظفون لكل نمط من الأنماط الثقافية الأربعة، واتجاه التغيير الذي يرونه ضروريًا لتحقيق النجاح مستقبلًا."
      }
    ]
  },
  {
    "key": "txt_CvfReportHowToUseP2",
    "text": "The current culture, preferred culture, and gap analysis displayed in this report are based on the <b>OCAI</b> responses. A higher score indicates a stronger relative emphasis; it is not a percentage of employee agreement or a measure of organizational quality.",
    "translations": [
      {
        "language": "AR",
        "text": "تستند ملامح الثقافة الحالية والثقافة المرغوبة وتحليلات الفجوات الواردة في التقرير إلى استجابات المشاركين في التقييم. وتشير الدرجة الأعلى إلى تركيز نسبي أكبر على النمط الثقافي؛ ولا تعبّر عن نسبة اتفاق الموظفين أو عن مستوى جودة المنظمة."
      }
    ]
  },
  {
    "key": "txt_CvfReportHowToUseP3",
    "text": "Recommended initiatives are only a selection of the many actions that can be taken. Leaders are encouraged to select the actions most appropriate for the organization's strategy, resources, and operating environment, then assign clear ownership and measurable milestones.",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات الموصى بها مجموعة مختارة من إجراءات عديدة يمكن اتخاذها. ويُشجَّع القادة على اختيار ما يتناسب منها مع استراتيجية المنظمة ومواردها وبيئتها التشغيلية، ثم تحديد المسؤولين عن التنفيذ ومحطات إنجاز واضحة قابلة للقياس."
      }
    ]
  },
  {
    "key": "txt_CvfOrientationInternalFlexible",
    "text": "Internal + Flexible",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الداخلي والمرونة"
      }
    ]
  },
  {
    "key": "txt_CvfOrientationExternalFlexible",
    "text": "External + Flexible",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الخارجي والمرونة"
      }
    ]
  },
  {
    "key": "txt_CvfOrientationExternalControl",
    "text": "External + Control",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الخارجي والضبط"
      }
    ]
  },
  {
    "key": "txt_CvfOrientationInternalControl",
    "text": "Internal + Control",
    "translations": [
      {
        "language": "AR",
        "text": "التركيز الداخلي والضبط"
      }
    ]
  },
  {
    "key": "txt_CvfReportStep1Title",
    "text": "Assess",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم"
      }
    ]
  },
  {
    "key": "txt_CvfReportStep1Desc",
    "text": "Employees assess the current culture and the preferred culture.",
    "translations": [
      {
        "language": "AR",
        "text": "يقيّم الموظفون الثقافة الحالية والثقافة المرغوبة."
      }
    ]
  },
  {
    "key": "txt_CvfReportStep2Title",
    "text": "Allocate Points",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع النقاط"
      }
    ]
  },
  {
    "key": "txt_CvfReportStep2Desc",
    "text": "For each of the six assessment areas, employees allocate 100 points across the four CVF culture archetypes.",
    "translations": [
      {
        "language": "AR",
        "text": "يوزّع الموظفون 100 نقطة على الأنماط الثقافية الأربعة في نموذج القيم التنافسية، وذلك لكل بُعد من أبعاد التقييم الستة."
      }
    ]
  },
  {
    "key": "txt_CvfReportStep3Title",
    "text": "Build the Profiles",
    "translations": [
      {
        "language": "AR",
        "text": "بناء ملامح الثقافة"
      }
    ]
  },
  {
    "key": "txt_CvfReportStep3Desc",
    "text": "Scores are averaged to create the current and preferred culture profiles.",
    "translations": [
      {
        "language": "AR",
        "text": "تُحتسب متوسطات الدرجات لتحديد ملامح الثقافة الحالية والثقافة المرغوبة."
      }
    ]
  },
  {
    "key": "txt_survey_mode_tour_desc",
    "text": "Choose whether respondents compare their current and preferred culture on one screen or in two separate steps.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر ما إذا كان المستجيبون سيقارنون بين الثقافة الحالية والمفضّلة في شاشة واحدة أو عبر خطوتين منفصلتين."
      }
    ]
  },
  {
    "key": "txt_CultureStatements",
    "text": "Culture Statements",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات ثقافة بيئة العمل"
      }
    ]
  },
  {
    "key": "txt_CultureStatements_desc",
    "text": "Review the questions your employees will answer before launching the assessment. Each statement is linked to a specific culture archetype, helping you understand how responses shape your organization’s culture profile.<br><br>Hint: Click “👁” to preview the statement sample used in the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على العبارات التي سيجيب عنها الموظفون قبل إطلاق التقييم. ترتبط كل عبارة بنمط ثقافي محدد، مما يساعدك على فهم كيفية مساهمة إجابات المشاركين في تشكيل الملف الثقافي لمؤسستك.<br><br>تلميح: انقر على \"👁\" لعرض نموذج السؤال الذي سيتم استخدامه في التقييم."
      }
    ]
  },
  {
    "key": "txt_FilterbyStatus",
    "text": "Filter by Status",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية حسب الحالة"
      }
    ]
  },
  {
    "key": "txt_FilterbyStatus_desc",
    "text": "Click here to filter the respondent by completed, in-progress, not started, or inactive.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتصفية المستجيب حسب المكتمل، أو قيد الإنجاز، لم يبدأ، أو غير فعال."
      }
    ]
  },
  {
    "key": "txt_OverallCultureScore_desc",
    "text": "The <b>Overall Culture Score</b> shows the level of alignment between the culture employees experience today and the culture they prefer for the future.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض <b>نتيجة الثقافة الإجمالية</b> مستوى المواءمة بين الثقافة التي يختبرها الموظفون حاليًا والثقافة التي يفضلونها للمستقبل."
      }
    ]
  },
  {
    "key": "txtTourFilters",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "التصفيات"
      }
    ]
  },
  {
    "key": "txtTourFilters_desc",
    "text": "Select criteria from the <b>Filters</b> to narrow your analysis.<br><br>Note: The number of respondents must be at least 3 to view the analysis of each criterion.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر معيار من عوامل <b>التصفية</b> لحصر نطاق تحليلك.<br><br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل معيار مختارة."
      }
    ]
  },
  {
    "key": "txt_ResponseRate_tour_desc",
    "text": "The <b>Response Rate</b> shows the percentage and number of invited employees who completed the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض <b>معدل الاستجابة</b> النسبة المئوية وعدد الموظفين المدعوين الذين أكملوا التقييم."
      }
    ]
  },
  {
    "key": "txt_DominantNowPreferred",
    "text": "Dominant Now and Preferred Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة السائدة حاليًا والثقافة المرغوبة"
      }
    ]
  },
  {
    "key": "txt_DominantNowPreferred_desc",
    "text": "This section identifies the culture orientation receiving the greatest emphasis today and the orientation employees believe should receive greater emphasis in the future.",
    "translations": [
      {
        "language": "AR",
        "text": "يحدد هذا القسم التوجه الثقافي الذي يحظى بأكبر قدر من التركيز حاليًا، والتوجه الذي يرى الموظفون ضرورة تعزيز التركيز عليه في المستقبل."
      }
    ]
  },
  {
    "key": "txt_LargestGap_desc",
    "text": "View the culture archetype with the largest difference between the current and preferred culture. This helps identify where the greatest cultural shift is required.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض هذا القسم التوجه الثقافي الذي يمثل أكبر فرق بين الثقافة الحالية والمرغوبة، مما يساعد على تحديد المجال الذي يتطلب أكبر تحول ثقافي."
      }
    ]
  },
  {
    "key": "txt_CurrentPreferredCulture_tour_desc",
    "text": "Compare the current and preferred culture profiles. Each profile explains the culture orientation, what it means for the organization, and the related ways of working and leadership approaches.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن بين الملفين الثقافيين الحالي والمرغوب. يوضح كل ملف التوجه الثقافي، وما يعنيه للمنظمة، وأساليب العمل والقيادة المرتبطة به."
      }
    ]
  },
  {
    "key": "txt_GapAnalysis_desc",
    "text": "The <b>Gap Analysis</b> compares current and preferred culture across the four culture archetypes. Use the Radar or Bar view to understand the direction and size of each cultural change.",
    "translations": [
      {
        "language": "AR",
        "text": "يقارن <b>تحليل الفجوات</b> بين الثقافة الحالية والمرغوبة عبر التوجهات الثقافية الأربعة. استخدم عرض الرادار أو الأعمدة لفهم اتجاه وحجم كل تغيير ثقافي."
      }
    ]
  },
  {
    "key": "txt_CultureGaps_desc",
    "text": "View the exact difference between the current and preferred score for each culture archetype. A positive gap shows an archetype that employees want to strengthen, while a negative gap shows an archetype they want to reduce in relative emphasis.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض الفرق الدقيق بين الدرجة الحالية والمرغوبة لكل توجه ثقافي. تشير الفجوة الإيجابية إلى توجه يرغب الموظفون في تعزيزه، بينما تشير الفجوة السلبية إلى توجه يرغبون في خفض مستوى التركيز النسبي عليه."
      }
    ]
  },
  {
    "key": "txt_PolarityAxis_desc",
    "text": "The <b>Polarity Axis</b> maps the current and future culture across the two CVF dimensions: flexibility versus control, and internal focus versus external focus. It shows the overall direction of the cultural shift.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض <b>محور القيم المتقابلة</b> الثقافة الحالية والمستقبلية عبر بُعدي نموذج القيم التنافسية: المرونة مقابل الضبط، والتركيز الداخلي مقابل التركيز الخارجي. ويوضح الاتجاه العام للتحول الثقافي."
      }
    ]
  },
  {
    "key": "txt_CultureStability_desc",
    "text": "The <b>Culture Stability</b> section shows how much change employees are requesting for each culture archetype. The Culture Stability Index provides an overall indication of how close the preferred culture is to the culture experienced today.",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح قسم <b>استقرار الثقافة</b> مقدار التغيير الذي يطلبه الموظفون في كل توجه ثقافي. ويقدم مؤشر استقرار الثقافة دلالة عامة على مدى قرب الثقافة المرغوبة من الثقافة التي يختبرها الموظفون حاليًا."
      }
    ]
  },
  {
    "key": "txt_GroupComparison_tour_desc",
    "text": "The <b>Comparison</b> section allows you to compare culture profiles across selected employee groups, such as gender, department, location, or any other available breakout criterion.<br><br>Note: Results are hidden when a group has fewer than three respondents to protect respondent confidentiality.",
    "translations": [
      {
        "language": "AR",
        "text": "يتيح لك قسم <b>المقارنة</b> مقارنة الملفات الثقافية عبر مجموعات الموظفين المختارة، مثل الجنس أو الإدارة أو الموقع أو أي معيار تقسيم آخر متاح.<br><br>ملحوظة: تُخفى النتائج عندما يقل عدد المستجيبين في المجموعة عن ثلاثة، وذلك لحماية سرية المستجيبين."
      }
    ]
  },
  {
    "key": "txt_ExportChart",
    "text": "Export Chart",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الرسم البياني"
      }
    ]
  },
  {
    "key": "txt_ExportChart_desc",
    "text": "Export the chart by clicking here.<br><br>Note: Available in Excel and PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل الرسم البياني بالنقر هنا.<br><br>ملحوظة: متوفر بصيغة أكسل و PDF."
      }
    ]
  },
  {
    "key": "txt_DimensionsScore",
    "text": "Dimensions’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجات البُعد"
      }
    ]
  },
  {
    "key": "txt_DimensionsScore_desc",
    "text": "View the current score, preferred score, and change for each cultural archetype within the selected dimension. The radar chart and reading provide a clear summary of the direction and scale of change employees are requesting.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض الدرجة الحالية والدرجة المُفضلة ومقدار التغيير لكل نمط ثقافي ضمن البُعد المختار. ويقدم مخطط الرادار والقراءة ملخصًا واضحًا لاتجاه التغيير وحجمه كما يطلبه الموظفون."
      }
    ]
  },
  {
    "key": "txt_RecommendedPriorities_tour_desc",
    "text": "The <b>Recommended Priorities</b> section ranks the actions expected to have the greatest impact on closing the culture gap. Each priority shows its importance level and the related cultural archetype change.",
    "translations": [
      {
        "language": "AR",
        "text": "يرتب قسم <b>الأولويات الموصى بها</b> الإجراءات المتوقع أن يكون لها أكبر أثر في تقليص الفجوة الثقافية. وتوضح كل أولوية مستوى أهميتها والتغيير المرتبط بالنمط الثقافي المعني."
      }
    ]
  },
  {
    "key": "txt_PriorityDetails",
    "text": "Priority Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الأولوية"
      }
    ]
  },
  {
    "key": "txt_PriorityDetails_desc",
    "text": "Review the expected behaviors, leadership and organizational actions, and success measures for each priority to understand how the cultural shift can be implemented and tracked.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع السلوكيات المتوقعة، وإجراءات القيادة والمنظمة، ومقاييس النجاح لكل أولوية لفهم كيفية تطبيق التحول الثقافي وقياس التقدم فيه."
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐” أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!"
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "EN",
        "text": "Translation"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      },
      {
        "language": "EN",
        "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level."
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      },
      {
        "language": "EN",
        "text": "Scope"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      },
      {
        "language": "EN",
        "text": "Choose the start and end dates for your action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      },
      {
        "language": "EN",
        "text": "Duration"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once everything looks good, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Select the culture type your action plan should move the organisation towards. The preferred culture from the assessment is preselected.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select the culture type your action plan should move the organisation towards. The preferred culture from the assessment is preselected."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      },
      {
        "language": "EN",
        "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      },
      {
        "language": "EN",
        "text": "Topic Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      },
      {
        "language": "EN",
        "text": "Easily navigate between selected focus areas to select your initiatives!"
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      },
      {
        "language": "EN",
        "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited."
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "EN",
        "text": "Initiatives"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      },
      {
        "language": "EN",
        "text": "You can also add initiatives manually."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      },
      {
        "language": "EN",
        "text": "Fill in your \"Initiative Title\""
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "Title"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      },
      {
        "language": "EN",
        "text": "Fill in your \" Initiative Description\""
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      },
      {
        "language": "EN",
        "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Duration"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      },
      {
        "language": "EN",
        "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      },
      {
        "language": "EN",
        "text": "Assign Owner"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      },
      {
        "language": "EN",
        "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!"
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI-Generated Initiatives"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث.\nملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      },
      {
        "language": "EN",
        "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well."
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your initiatives, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      },
      {
        "language": "EN",
        "text": "Easily navigate between selected focus areas to select your tasks!"
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited."
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      },
      {
        "language": "EN",
        "text": "Tasks"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      },
      {
        "language": "EN",
        "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "Create Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      },
      {
        "language": "EN",
        "text": "Create Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      },
      {
        "language": "EN",
        "text": "Add customized tasks based on your specific needs."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      },
      {
        "language": "EN",
        "text": "Add Task"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      },
      {
        "language": "EN",
        "text": "You can update the task by clicking on the pen icon."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      },
      {
        "language": "EN",
        "text": "Edit Task"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      },
      {
        "language": "EN",
        "text": "You can delete any task by clicking on the delete icon."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      },
      {
        "language": "EN",
        "text": "Delete Task"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      },
      {
        "language": "EN",
        "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!"
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI- Generated Tasks"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      },
      {
        "language": "EN",
        "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      },
      {
        "language": "EN",
        "text": "Assign Owner"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner"
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      },
      {
        "language": "EN",
        "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching."
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Plan Details"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      },
      {
        "language": "EN",
        "text": "Once everything is set, click Launch to make your action plan live."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      },
      {
        "language": "EN",
        "text": "Launch"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      },
      {
        "language": "EN",
        "text": "Click here to filter and create an action plan for a selected entity or company-wide."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      },
      {
        "language": "EN",
        "text": "Filters"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      },
      {
        "language": "EN",
        "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      },
      {
        "language": "EN",
        "text": "Action Plan List"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      },
      {
        "language": "EN",
        "text": "Edit or delete the action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      },
      {
        "language": "EN",
        "text": "Edit Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      },
      {
        "language": "EN",
        "text": "To access an action plan, click Open."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      },
      {
        "language": "EN",
        "text": "Accessing Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      },
      {
        "language": "EN",
        "text": "Give your plan a clear, descriptive name to get started."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "Title"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      },
      {
        "language": "EN",
        "text": "Add a brief description to explain the purpose and focus of your action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      },
      {
        "language": "EN",
        "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Export"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      },
      {
        "language": "EN",
        "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance."
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      },
      {
        "language": "EN",
        "text": "Tracking"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Here you view the selected culture types.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Here you view the selected culture types."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      },
      {
        "language": "EN",
        "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      },
      {
        "language": "EN",
        "text": "Tasks Management"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      },
      {
        "language": "EN",
        "text": "You can filter initiatives by status: In Progress, Completed, or Expired."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      },
      {
        "language": "EN",
        "text": "Status Filter"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      },
      {
        "language": "EN",
        "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      },
      {
        "language": "EN",
        "text": "Request for Feedback"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      },
      {
        "language": "EN",
        "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      },
      {
        "language": "EN",
        "text": "Respondent Selection"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. Hint: you can add up to three reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية. تلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      },
      {
        "language": "EN",
        "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. Hint: you can add up to three reminders."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Time Frame"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      },
      {
        "language": "EN",
        "text": "Customize the email template sent or use the default template generated by Zenithr."
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      },
      {
        "language": "EN",
        "text": "Email Template"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      },
      {
        "language": "EN",
        "text": "Click Send Now to share the invitations with respondents."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      },
      {
        "language": "EN",
        "text": "Send Invite"
      }
    ]
  },
  {
    "key": "DownloadTemplate",
    "text": "Download File",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الملف"
      },
      {
        "language": "EN",
        "text": "Download File"
      }
    ]
  },
  {
    "key": "Due_Date",
    "text": "Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "EN",
        "text": "Due Date"
      }
    ]
  },
  {
    "key": "RespondentsValidationErorrs",
    "text": "<span>{{0}}</span> Respondents have the following validation errors:",
    "translations": [
      {
        "language": "AR",
        "text": "<span>{{0}}</span> يوجد لدى المستجيبين أخطاء التحقق التالية:"
      },
      {
        "language": "EN",
        "text": "<span>{{0}}</span> Respondents have the following validation errors:"
      }
    ]
  },
  {
    "key": "Respondentsdetected",
    "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected!",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"font-medium\">{{0}}</span> تم العثور على مستجيبين!"
      },
      {
        "language": "EN",
        "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected!"
      }
    ]
  },
  {
    "key": "Youreasking",
    "text": "You’re asking for feedback on this initiative’s impact:",
    "translations": [
      {
        "language": "AR",
        "text": "يتم الآن طلب تغذية راجعة لمدى تأثير المبادرة المحددة على مكان العمل:"
      },
      {
        "language": "EN",
        "text": "You’re asking for feedback on this initiative’s impact:"
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "استمر"
      },
      {
        "language": "EN",
        "text": "Continue"
      }
    ]
  },
  {
    "key": "txt_Abort_895",
    "text": "Abort",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "EN",
        "text": "Abort"
      }
    ]
  },
  {
    "key": "txt_ActionPla_283",
    "text": "Action Plan Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف خطة العمل بنجاح!"
      },
      {
        "language": "EN",
        "text": "Action Plan Deleted Successfully!"
      }
    ]
  },
  {
    "key": "txt_ActionPla_611",
    "text": "Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Plan"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Planning"
      }
    ]
  },
  {
    "key": "txt_AddTask_557",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مهمة"
      },
      {
        "language": "EN",
        "text": "Add Task"
      }
    ]
  },
  {
    "key": "txt_Areyousur_693",
    "text": "Are you sure you want to delete this action plan? <br/>This action cannot be undone and all related data may be permanently removed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من رغبتك في حذف خطة العمل هذه؟ <br/>لا يمكن التراجع عن هذا الإجراء، وقد يتم حذف جميع البيانات المرتبطة بها نهائياً."
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this action plan? <br/>This action cannot be undone and all related data may be permanently removed."
      }
    ]
  },
  {
    "key": "txt_BulkUploa_742",
    "text": "Bulk Upload",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل على دفعة واحدة"
      },
      {
        "language": "EN",
        "text": "Bulk Upload"
      }
    ]
  },
  {
    "key": "txt_ByTopic_402",
    "text": "By Topic",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الموضوع"
      },
      {
        "language": "EN",
        "text": "By Topic"
      }
    ]
  },
  {
    "key": "txt_Company-w_292",
    "text": "Company-wide",
    "translations": [
      {
        "language": "AR",
        "text": "على مستوى المؤسسة"
      },
      {
        "language": "EN",
        "text": "Company-wide"
      }
    ]
  },
  {
    "key": "txt_Completed_892",
    "text": "Completed on: {{0}}",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال: {{0}}"
      },
      {
        "language": "EN",
        "text": "Completed on: {{0}}"
      }
    ]
  },
  {
    "key": "txt_CreateAct_104",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      },
      {
        "language": "EN",
        "text": "New Action Plan"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Culture Type",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Culture Type"
      }
    ]
  },
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Culture type score",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Culture type score"
      }
    ]
  },
  {
    "key": "txt_Departmen_944",
    "text": "Department-specific",
    "translations": [
      {
        "language": "AR",
        "text": "خاص بالإدارة"
      },
      {
        "language": "EN",
        "text": "Department-specific"
      }
    ]
  },
  {
    "key": "txt_Descripti_145",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "txt_EditIniti_710",
    "text": "Edit Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المبادرة"
      },
      {
        "language": "EN",
        "text": "Edit Initiative"
      }
    ]
  },
  {
    "key": "txt_Export_828",
    "text": "Export ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Export "
      }
    ]
  },
  {
    "key": "txt_FocusArea_748",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "txt_GenerateI_968",
    "text": "Generate Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مبادرات"
      },
      {
        "language": "EN",
        "text": "Generate Initiatives"
      }
    ]
  },
  {
    "key": "txt_GenerateT_948",
    "text": "Generate Task",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مهمة"
      },
      {
        "language": "EN",
        "text": "Generate Task"
      }
    ]
  },
  {
    "key": "txt_Gettailor_360",
    "text": "Get tailored initiatives for each Topic with Zenithr AI.",
    "translations": [
      {
        "language": "AR",
        "text": "احصل على مبادرات مصممة خصيصًا لكل موضوع مع زينيثر AI."
      },
      {
        "language": "EN",
        "text": "Get tailored initiatives for each Topic with Zenithr AI."
      }
    ]
  },
  {
    "key": "txt_Howeffect_770",
    "text": "How effective was this initiative for you?",
    "translations": [
      {
        "language": "AR",
        "text": "ما مدى فعالية هذه المبادرة بالنسبة لك؟"
      },
      {
        "language": "EN",
        "text": "How effective was this initiative for you?"
      }
    ]
  },
  {
    "key": "txt_Initiativ_478",
    "text": "Initiative Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان المبادرة"
      },
      {
        "language": "EN",
        "text": "Initiative Title"
      }
    ]
  },
  {
    "key": "txt_Initiativ_528",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "EN",
        "text": "Initiatives"
      }
    ]
  },
  {
    "key": "txt_LastUpdat_546",
    "text": "Last Updated:",
    "translations": [
      {
        "language": "AR",
        "text": "آخر تحديث:"
      },
      {
        "language": "EN",
        "text": "Last Updated:"
      }
    ]
  },
  {
    "key": "txt_Launch_119",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      },
      {
        "language": "EN",
        "text": "Launch"
      }
    ]
  },
  {
    "key": "txt_Markallas_851",
    "text": "Mark all as complete",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل كمكتمل"
      },
      {
        "language": "EN",
        "text": "Mark all as complete"
      }
    ]
  },
  {
    "key": "txt_NewInitia_374",
    "text": "New Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة جديدة"
      },
      {
        "language": "EN",
        "text": "New Initiative"
      }
    ]
  },
  {
    "key": "txt_Open_675",
    "text": "Open",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      },
      {
        "language": "EN",
        "text": "Open"
      }
    ]
  },
  {
    "key": "txt_OverallPr_227",
    "text": "Overall Progress",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الإنجاز الكلي"
      },
      {
        "language": "EN",
        "text": "Overall Progress"
      }
    ]
  },
  {
    "key": "txt_Overdue_155",
    "text": "Overdue",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "EN",
        "text": "Overdue"
      }
    ]
  },
  {
    "key": "txt_Owner_978",
    "text": "Owner",
    "translations": [
      {
        "language": "AR",
        "text": "المسؤول"
      },
      {
        "language": "EN",
        "text": "Owner"
      }
    ]
  },
  {
    "key": "txt_Permissio_309",
    "text": "Permission",
    "translations": [
      {
        "language": "AR",
        "text": "الصلاحيات"
      },
      {
        "language": "EN",
        "text": "Permission"
      }
    ]
  },
  {
    "key": "txt_Planning&_973",
    "text": "Planning & Action",
    "translations": [
      {
        "language": "AR",
        "text": "التخطيط والعمل"
      },
      {
        "language": "EN",
        "text": "Planning & Action"
      }
    ]
  },
  {
    "key": "txt_Pleaseent_769",
    "text": "Please enter a valid task before saving.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال مهمة صالحة قبل الحفظ."
      },
      {
        "language": "EN",
        "text": "Please enter a valid task before saving."
      }
    ]
  },
  {
    "key": "txt_Pleasereu_180",
    "text": "Please reupload the file after you’ve fixed the validation errors mentioned above.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إعادة رفع الملف بعد إصلاح أخطاء التحقق المذكورة أعلاه."
      },
      {
        "language": "EN",
        "text": "Please reupload the file after you’ve fixed the validation errors mentioned above."
      }
    ]
  },
  {
    "key": "txt_Predefine_961",
    "text": "Predefined Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مُعرفة مسبقاً"
      },
      {
        "language": "EN",
        "text": "Predefined Initiative"
      }
    ]
  },
  {
    "key": "txt_RequestFe_413",
    "text": "Request Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب آراء الموظفين"
      },
      {
        "language": "EN",
        "text": "Request Feedback"
      }
    ]
  },
  {
    "key": "txt_Responses_976",
    "text": "Responses are anonymous and help assess impact. The following question will be sent to selected respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "الردود مجهولة المصدر وتساعد في تقييم الأثر. سيتم إرسال السؤال التالي إلى المستجيبين المحددين."
      },
      {
        "language": "EN",
        "text": "Responses are anonymous and help assess impact. The following question will be sent to selected respondents."
      }
    ]
  },
  {
    "key": "txt_Scope_580",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      },
      {
        "language": "EN",
        "text": "Scope"
      }
    ]
  },
  {
    "key": "txt_SelectDue_300",
    "text": "Select Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد تاريخ الانتهاء"
      },
      {
        "language": "EN",
        "text": "Select Due Date"
      }
    ]
  },
  {
    "key": "txt_SelectedB_211",
    "text": "Selected Business Entity(s) will be automatically applied to the scope of this action plan as follow:",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم تطبيق وحدات العمل المختارة تلقائياً على نطاق خطة العمل هذه كما يلي:"
      },
      {
        "language": "EN",
        "text": "Selected Business Entity(s) will be automatically applied to the scope of this action plan as follow:"
      }
    ]
  },
  {
    "key": "txt_Setthesta_318",
    "text": "Set the start and end dates during which the feedback survey will be active and open for responses:",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخي البداية والنهاية لفترة صلاحية الاستبيان واستقبال الردود:"
      },
      {
        "language": "EN",
        "text": "Set the start and end dates during which the feedback survey will be active and open for responses:"
      }
    ]
  },
  {
    "key": "txt_Show_197",
    "text": "Show",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "EN",
        "text": "Show"
      }
    ]
  },
  {
    "key": "txt_Start&Com_839",
    "text": "Start & Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء والإكمال"
      },
      {
        "language": "EN",
        "text": "Start & Completion Date"
      }
    ]
  },
  {
    "key": "txt_Startanac_763",
    "text": "Start an action plan to address key focus areas, set measurable goals, and drive meaningful improvements across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "بدأ بوضع خطة عمل لمعالجة مجالات التركيز الرئيسية، وتحديد أهداف قابلة للقياس، ودفع عجلة التحسينات الملموسة في جميع أنحاء المؤسسة."
      },
      {
        "language": "EN",
        "text": "Start an action plan to address key focus areas, set measurable goals, and drive meaningful improvements across your organization."
      }
    ]
  },
  {
    "key": "txt_Tasks_853",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      },
      {
        "language": "EN",
        "text": "Tasks"
      }
    ]
  },
  {
    "key": "txt_Thissurve_315",
    "text": "This assessment revealed important insights about your organization’s culture.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد كشف هذا التقييم عن رؤى ومؤشرات هامة عن ثقافة بيئة العمل."
      },
      {
        "language": "EN",
        "text": "This assessment revealed important insights about your organization’s culture."
      }
    ]
  },
  {
    "key": "txt_TimeRemai_140",
    "text": "Time Remaining:",
    "translations": [
      {
        "language": "AR",
        "text": "الوقت المتبقي:"
      },
      {
        "language": "EN",
        "text": "Time Remaining:"
      }
    ]
  },
  {
    "key": "txt_Toaddresp_423",
    "text": "<span class=\"text-exp\">STEP 1:</span>  <br /> <br />  Click \"Download file\" to download the premade spreadsheet (.xlsx). <br /> <br />              <span class=\"text-exp\">STEP 2:</span>  <br /> <br />  Fill out the premade template and save it. <br /> <br />  <span class=\"text-exp\">STEP 3:</span>  <br /> <br />  Click \"Upload File\" to upload the filled-out spreadsheet.",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"text-exp\">خطوة 1: </span>  <br /> <br />  اضغط على زر \"تحميل الملف\" لتحميل جدول بيانات فارغ (.xlsx) <br /> <br />              <span class=\"text-exp\">خطوة 2: </span>  <br /> <br />  املأ جدول بيانات الذي تم تحميله واحفظه <br /> <br />  <span class=\"text-exp\">خطوة 3: </span>  <br /> <br />  اضغط على زر \"رفع الملف\" لرفع جدول البيانات الذي تم تعبئته (.xlsx)"
      },
      {
        "language": "EN",
        "text": "<span class=\"text-exp\">STEP 1:</span>  <br /> <br />  Click \"Download file\" to download the premade spreadsheet (.xlsx). <br /> <br />              <span class=\"text-exp\">STEP 2:</span>  <br /> <br />  Fill out the premade template and save it. <br /> <br />  <span class=\"text-exp\">STEP 3:</span>  <br /> <br />  Click \"Upload File\" to upload the filled-out spreadsheet."
      }
    ]
  },
  {
    "key": "txt_Topics_628",
    "text": "Topics",
    "translations": [
      {
        "language": "AR",
        "text": "الموضوعات"
      },
      {
        "language": "EN",
        "text": "Topics"
      }
    ]
  },
  {
    "key": "txt_TurnInsig_176",
    "text": "Turn Insights Into Action",
    "translations": [
      {
        "language": "AR",
        "text": "تحويل نتائج التقييم إلى خطوات قابلة للتنفيذ"
      },
      {
        "language": "EN",
        "text": "Turn Insights Into Action"
      }
    ]
  },
  {
    "key": "txt_Typeanini_239",
    "text": "Type an initiative title here...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب عنوان المبادرة هنا..."
      },
      {
        "language": "EN",
        "text": "Type an initiative title here..."
      }
    ]
  },
  {
    "key": "txt_Typeashor_778",
    "text": "Type a short description here...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب الوصف هنا..."
      },
      {
        "language": "EN",
        "text": "Type a short description here..."
      }
    ]
  },
  {
    "key": "txt_Typeatask_606",
    "text": "Type a task here....",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب المهمة هنا..."
      },
      {
        "language": "EN",
        "text": "Type a task here...."
      }
    ]
  },
  {
    "key": "txt_Typetosea_606",
    "text": "Type to search...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب للبحث..."
      },
      {
        "language": "EN",
        "text": "Type to search..."
      }
    ]
  },
  {
    "key": "txt_UploadTem_339",
    "text": "Upload File",
    "translations": [
      {
        "language": "AR",
        "text": "رفع الملف"
      },
      {
        "language": "EN",
        "text": "Upload File"
      }
    ]
  },
  {
    "key": "txt_Uploading_588",
    "text": "Uploading file...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري رفع الملف..."
      },
      {
        "language": "EN",
        "text": "Uploading file..."
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "EN",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txt_days_636",
    "text": "days",
    "translations": [
      {
        "language": "AR",
        "text": "يوم"
      },
      {
        "language": "EN",
        "text": "days"
      }
    ]
  },
  {
    "key": "txt_description",
    "text": "Description (Optional)",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description (Optional)"
      }
    ]
  },
  {
    "key": "txt_not_started",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يبدأ"
      },
      {
        "language": "EN",
        "text": "Not Started"
      }
    ]
  },
  {
    "key": "txt_respondents_pool",
    "text": "Respondent Pool",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondent Pool"
      }
    ]
  },
  {
    "key": "txt_title",
    "text": "title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "title"
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Planning"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز جاهزية الذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost AI Readiness."
      }
    ]
  },
  {
    "key": "txt_driver_desc",
    "text": "➜ Your preferred culture is preselected. Pick the culture types this plan should work towards.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "➜ Your preferred culture is preselected. Pick the culture types this plan should work towards."
      }
    ]
  },
  {
    "key": "txt_ActionPlanGoal",
    "text": "Culture Transition",
    "translations": [
      {
        "language": "AR",
        "text": "التحول الثقافي"
      },
      {
        "language": "EN",
        "text": "Culture Transition"
      }
    ]
  },
  {
    "key": "txt_InitiativesOverview",
    "text": "Initiatives Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على المبادرات"
      },
      {
        "language": "EN",
        "text": "Initiatives Overview"
      }
    ]
  },
  {
    "key": "txt_PreselectedFocusArea",
    "text": "Preferred Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة المرغوبة"
      },
      {
        "language": "EN",
        "text": "Preferred Culture"
      }
    ]
  },
  {
    "key": "txt_start_survey",
    "text": "Start Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ التقييم"
      },
      {
        "language": "FR",
        "text": "Commencer l'Évaluation "
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करें"
      },
      {
        "language": "TA",
        "text": "Simulan ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے شروع کریں"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Start Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfReportStep4Title",
    "text": "Compare Change",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة التغيير"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CvfReportStep4Desc",
    "text": "The two profiles are compared to identify the culture archetypes that require greater, less, or continued emphasis.",
    "translations": [
      {
        "language": "AR",
        "text": "تُقارن ملامح الثقافتين لتحديد الأنماط التي ينبغي زيادة التركيز عليها أو تقليله أو الإبقاء عليه."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا التقييم"
      },
      {
        "language": "EN",
        "text": "#UNITS# units will be deducted for this action"
      }
    ]
  },
  {
    "key": "txt_PoweredBy",
    "text": "Powered by",
    "translations": [
      {
        "language": "AR",
        "text": "مُشغل بواسطة"
      },
      {
        "language": "FR",
        "text": "Propulsé par"
      }
    ]
  },
  {
    "key": "txt_GroupReadHintPlain",
    "text": "Gap: green = employees want more, red = employees want less.",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة: الأخضر = يرغب الموظفون في المزيد، الأحمر = يرغبون في أقل."
      },
      {
        "language": "FR",
        "text": "Écart : vert = les employés en veulent plus, rouge = ils en veulent moins."
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Culture Assessment:",
    "translations": [
      {
        "language": "AR",
        "text": "لـ تقييم الثقافة:"
      }
    ]
  },
  {
    "key": "txt_to_complete",
    "text": "Time to complete",
    "translations": [
      {
        "language": "AR",
        "text": "الوقت لاستكمال التقييم"
      }
    ]
  },
  {
    "key": "txtSurveyCompleteTitle",
    "text": "Assessment Completed",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال التقييم"
      }
    ]
  },
  {
    "key": "txtSurveyComplete",
    "text": "The assessment has been completed.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تم إكمال التقييم."
      }
    ]
  },
  {
    "key": "txt_OrganizationalCultureAnalysis",
    "text": "Organizational Culture Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الثقافة التنظيمية"
      }
    ]
  },
  {
    "key": "txt_TotalInvited",
    "text": "Total Invited",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي المدعوين"
      }
    ]
  },
  {
    "key": "txt_TotalCompleted",
    "text": "Total Completed",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي المكتملين"
      }
    ]
  },
  {
    "key": "txt_CultureAlignmentScore",
    "text": "Culture Alignment Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة توافق الثقافة"
      }
    ]
  },
  {
    "key": "txt_ClanStrength1",
    "text": "High employee engagement, loyalty, and retention",
    "translations": [
      {
        "language": "AR",
        "text": "ارتفاع مستويات الارتباط الوظيفي والولاء والاحتفاظ بالموظفين"
      }
    ]
  },
  {
    "key": "txt_ClanStrength2",
    "text": "Strong internal communication and knowledge sharing",
    "translations": [
      {
        "language": "AR",
        "text": "قوة التواصل الداخلي وتبادل المعرفة"
      }
    ]
  },
  {
    "key": "txt_ClanStrength3",
    "text": "Effective onboarding, mentorship, and staff development",
    "translations": [
      {
        "language": "AR",
        "text": "فاعلية تهيئة الموظفين الجدد والإرشاد المهني وتطوير الموظفين"
      }
    ]
  },
  {
    "key": "txt_ClanStrength4",
    "text": "Maintains resilience during periods of stress due to strong team cohesion",
    "translations": [
      {
        "language": "AR",
        "text": "الحفاظ على القدرة على الصمود في فترات الضغط بفضل تماسك الفريق"
      }
    ]
  },
  {
    "key": "txt_AdhocracyStrength1",
    "text": "Strong capacity for innovation and rapid response to market change",
    "translations": [
      {
        "language": "AR",
        "text": "قدرة كبيرة على الابتكار والاستجابة السريعة لتغيّرات السوق"
      }
    ]
  },
  {
    "key": "txt_AdhocracyStrength2",
    "text": "Attracts entrepreneurial talent seeking autonomy and creative latitude",
    "translations": [
      {
        "language": "AR",
        "text": "استقطاب المواهب الريادية التي تبحث عن الاستقلالية وحرية الإبداع"
      }
    ]
  },
  {
    "key": "txt_AdhocracyStrength3",
    "text": "Enables speed-to-market for new products, services, or solutions",
    "translations": [
      {
        "language": "AR",
        "text": "تسريع طرح المنتجات أو الخدمات أو الحلول الجديدة في السوق"
      }
    ]
  },
  {
    "key": "txt_AdhocracyStrength4",
    "text": "High adaptability in volatile or disruptive environments",
    "translations": [
      {
        "language": "AR",
        "text": "قدرة عالية على التكيّف في البيئات المتقلبة أو التي تشهد تحوّلات جذرية"
      }
    ]
  },
  {
    "key": "txt_MarketStrength1",
    "text": "Clear accountability and measurable performance standards",
    "translations": [
      {
        "language": "AR",
        "text": "وضوح المساءلة ومعايير الأداء القابلة للقياس"
      }
    ]
  },
  {
    "key": "txt_MarketStrength2",
    "text": "Strong external customer and competitor orientation",
    "translations": [
      {
        "language": "AR",
        "text": "اهتمام كبير بالعملاء الخارجيين والمنافسين"
      }
    ]
  },
  {
    "key": "txt_MarketStrength3",
    "text": "Drives productivity, efficiency, and goal attainment",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز الإنتاجية والكفاءة وتحقيق الأهداف"
      }
    ]
  },
  {
    "key": "txt_MarketStrength4",
    "text": "Rewards high performers and reinforces a results-based culture",
    "translations": [
      {
        "language": "AR",
        "text": "مكافأة الموظفين ذوي الأداء المتميز وترسيخ ثقافة قائمة على النتائج"
      }
    ]
  },
  {
    "key": "txt_HierarchyStrength1",
    "text": "High reliability, consistency, and quality assurance",
    "translations": [
      {
        "language": "AR",
        "text": "مستويات مرتفعة من الموثوقية والاتساق وضمان الجودة"
      }
    ]
  },
  {
    "key": "txt_HierarchyStrength2",
    "text": "Clearly defined roles, accountability, and reporting lines minimize confusion",
    "translations": [
      {
        "language": "AR",
        "text": "وضوح الأدوار والمسؤوليات وخطوط التبعية الإدارية، بما يحدّ من الالتباس"
      }
    ]
  },
  {
    "key": "txt_HierarchyStrength3",
    "text": "Robust compliance, risk management, and operational discipline",
    "translations": [
      {
        "language": "AR",
        "text": "منظومة قوية للامتثال وإدارة المخاطر والانضباط التشغيلي"
      }
    ]
  },
  {
    "key": "txt_HierarchyStrength4",
    "text": "Effective management of repeatable, high-volume processes",
    "translations": [
      {
        "language": "AR",
        "text": "فاعلية في إدارة العمليات المتكررة ذات الحجم الكبير"
      }
    ]
  },
  {
    "key": "txt_ClanCurrentCultureHeading",
    "text": "Clan as the Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الجماعة بوصفها الثقافة الحالية"
      }
    ]
  },
  {
    "key": "txt_AdhocracyCurrentCultureHeading",
    "text": "Adhocracy as the Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة الإبداع بوصفها الثقافة الحالية"
      }
    ]
  },
  {
    "key": "txt_MarketCurrentCultureHeading",
    "text": "Market as the Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "ثقافة السوق بوصفها الثقافة الحالية"
      }
    ]
  },
  {
    "key": "txt_HierarchyCurrentCultureHeading",
    "text": "Hierarchy as the Current Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة الهرمية بوصفها الثقافة الحالية"
      }
    ]
  }
]